(function() {
  window._satellite = window._satellite || {};
  window._satellite.container = {
  "buildInfo": {
    "buildDate": "2021-11-03T14:40:26Z",
    "turbineBuildDate": "2021-08-11T20:25:49Z",
    "turbineVersion": "27.2.0"
  },
  "environment": {
    "id": "ENa3c42e63628a4f98bfd8cf22fc2a0411",
    "stage": "production"
  },
  "dataElements": {
    "User | Role": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.role"
      }
    },
    "User | Loggedin": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.loggedIn"
      }
    },
    "Transaction | Order ID": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
if(event && event.detail && event.detail.data && event.detail.data.orderId ){ 
  var oid = event.detail.data.orderId;
  if( event.detail.data.items && event.detail.data.items[0] && event.detail.data.items[0].details && event.detail.data.items[0].details.bag){
    oid = "b" + oid;
  }
  return oid;
}
}catch(e){}
}
      }
    },
    "Event | Action": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.action"
      }
    },
    "Content | url path": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  var url = _satellite.getVar("Content | url");
  return url.substring(0,((inx = url.indexOf("?")) > -1 ) ? inx : url.length );
}catch(e){}


}
      }
    },
    "Internal Promotion | Name": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.name"
      }
    },
    "Transaction | Products": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  _satellite.logger.log(_satellite.getVar("Transaction | Items"));
  var items = _satellite.getVar("Transaction | Items"), products="";
  for(var i=0;i< items.length;i++){
    products += ";" + items[i].SKU + ";" + items[i].quantity + ";" + items[i].price + ";;eVar52=" + items[i].productName.toLowerCase() +  ",";
  }
  products = products.substring(0,products.length-1);
  return products;
}catch(e){ _satellite.logger.log("eddl", e )}
}
      }
    },
    "Consent | Personalized Customer": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.personalizedCustomer"
      }
    },
    "Broadlog | Id": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/queryStringParameter.js",
      "settings": {
        "name": "bid",
        "caseInsensitive": true
      }
    },
    "EDDL | event": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.event"
      }
    },
    "Content | Site": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  return eddl[0].data.site;
}catch(e){}
}
      }
    },
    "Transaction | Total Amount": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.totalAmount"
      }
    },
    "Target | Payload pe": {
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.pe"
      }
    },
    "Event | Category": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.category"
      }
    },
    "Analytics | Account": {
      "defaultValue": "sstur-svenskaspelturdev",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  if(eddl && eddl[0] && eddl[0].data){
    switch(eddl[0].data.AASuite){
      case "DEV":
        return "sstur-svenskaspelturdev";
      case "STAGE":
        return "sstur-svenskaspelturstage";
      case "PROD":
        return "sstur-svenskaspelturprod";
    }
  }
}catch(e){}
}
      }
    },
    "Internal Promotion | Id": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.id"
      }
    },
    "Search | Category": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.category"
      }
    },
    "User | User ID": {
      "defaultValue": "",
      "storageDuration": "session",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.userId"
      }
    },
    "Internal Promotion | Position": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.position"
      }
    },
    "Content | Form Factor": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  return eddl[0].data.formFactor;
}catch(e){}
}
      }
    },
    "Content | Page Name": {
      "defaultValue": "",
      "storageDuration": "session",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
    var pageName = event.detail.data.pageName,url = event.detail.data.url;
    var regArr = [{
      "pattern": /(\:forlang-mina-spel:[0-9]+)/g,
      "value": ":forlang-mina-spel:detaljer",
    }, {
      "pattern": /(\:mina-spel:[0-9]+:[0-9]+)/g,
      "value": ":mina-spel:detaljer",
    }, {
      "pattern": /(\:mina-spel:[0-9]+)/g,
      "value": ":mina-spel:detaljer",
    }, {
      "pattern": /spela\-tillsammans:minalag:[0-9]+/g,
      "value": "spela-tillsammans:minalag:lagdetaljer",
    }, {
      "pattern": /spela\-tillsammans:minalag:[0-9]+:nytt-spel/g,
      "value": "spela-tillsammans:minalag:lagdetaljer",
    }, {
      "pattern": /logga\-in:poll\?.+/g,
      "value": "logga-in:poll",
    }, {
      "pattern": /logga\-in\?.+/g,
      "value": ":logga-in",
    }, {
      "pattern": /insattning\?.+/g,
      "value": ":insattning",
    }];

      if (pageName == '' && url == '/')pageName = "home";

    if (pageName.match(/(mina-spel|minalag|logga-in|insattning)/)) {
      for (var i = 0; i < regArr.length; i++) {
        pageName = pageName.replace(regArr[i].pattern, regArr[i].value);
      }
    }

    if (url.indexOf("flik") != -1) {
      var regex = new RegExp('[?&]flik(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return pageName;
      pageName = pageName + ":" + decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    return pageName;
  } catch (e) {}
}
      }
    },
    "Product View | products": {
      "defaultValue": "",
      "modulePath": "mapping-table/src/lib/dataElements/mappingTable.js",
      "settings": {
        "0": {
          "input": "/eurojackpot",
          "method": "exact match",
          "output": "ELOTTO"
        },
        "1": {
          "input": "/eurojackpot/fardiga-spel",
          "method": "exact match",
          "output": "ELOTTO"
        },
        "2": {
          "input": "/eurojackpot/systemspel",
          "method": "exact match",
          "output": "ELOTTO"
        },
        "3": {
          "input": "/lotto/fardiga-spel",
          "method": "exact match",
          "output": "ONSLOTTO"
        },
        "4": {
          "input": "/lotto",
          "method": "exact match",
          "output": "ONSLOTTO"
        },
        "5": {
          "input": "/lotto/systemspel",
          "method": "exact match",
          "output": "ONSLOTTO"
        },
        "6": {
          "input": "/keno",
          "method": "exact match",
          "output": "KENO"
        },
        "7": {
          "input": "/keno/fardiga-spel",
          "method": "exact match",
          "output": "KENO"
        },
        "8": {
          "input": "/keno/systemspel",
          "method": "exact match",
          "output": "KENO"
        },
        "9": {
          "input": "/vikinglotto",
          "method": "exact match",
          "output": "VIKING"
        },
        "10": {
          "input": "/vikinglotto/fardiga-spel",
          "method": "exact match",
          "output": "VIKING"
        },
        "11": {
          "input": "/vikinglotto/systemspel",
          "method": "exact match",
          "output": "VIKING"
        },
        "12": {
          "input": " /kenoxpress/spela",
          "method": "exact match",
          "output": "KenoXpress"
        },
        "13": {
          "input": "/triss/valja/biltriss",
          "method": "exact match",
          "output": "Boosted BilTriss"
        },
        "14": {
          "input": "/triss/valja/triss30",
          "method": "exact match",
          "output": "Triss"
        },
        "15": {
          "input": "/triss/spela/biltriss",
          "method": "exact match",
          "output": "Boosted BilTriss"
        },
        "16": {
          "input": "/triss/spela/dubbeltriss",
          "method": "exact match",
          "output": "DubbelTriss"
        },
        "17": {
          "input": "/triss/valja/minitriss",
          "method": "exact match",
          "output": "MiniTriss"
        },
        "18": {
          "input": "/skrapspel/valja/pacman",
          "method": "exact match",
          "output": "Skrap PAC-MAN"
        },
        "19": {
          "input": "/skrapspel/valja/SkrapKryss",
          "method": "exact match",
          "output": "SkrapKryss"
        },
        "20": {
          "input": "/skrapspel/valja/skrap7an",
          "method": "exact match",
          "output": "Skrap7:an"
        },
        "21": {
          "input": "/skrapspel/valja/skraplotto",
          "method": "exact match",
          "output": "SkrapLotto"
        },
        "22": {
          "input": "/skrapspel/valja/skrapkeno",
          "method": "exact match",
          "output": "SkrapKeno"
        },
        "23": {
          "input": "/skrapspel/valja/skrapbingo",
          "method": "exact match",
          "output": "SkrapBingo"
        },
        "24": {
          "input": "/17-eller-mer",
          "method": "exact match",
          "output": "17 eller mer"
        },
        "25": {
          "input": "/3-i-rad",
          "method": "exact match",
          "output": "3 i rad"
        },
        "26": {
          "input": "/mitt-emellan",
          "method": "exact match",
          "output": "Mitt emellan"
        },
        "27": {
          "input": "/rubbet",
          "method": "exact match",
          "output": "Rubbet"
        },
        "28": {
          "input": "/lordagsgodis",
          "method": "exact match",
          "output": "Lördagsgodis"
        },
        "29": {
          "input": "/fler-lotter/spela/(\\w)+",
          "method": "regex matching",
          "output": "%Product View | fler-lotter%"
        },
        "size": 30,
        "dataElement": "%Content | url%",
        "defaultValueEmpty": true
      }
    },
    "Target | Payload tnta": {
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.tnta"
      }
    },
    "Content | url": {
      "defaultValue": "",
      "storageDuration": "session",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  function removeParameters(name, url) {
  var regex = new RegExp('[&]' + name + '(=([^&#]*)|&|#|$)');
  url = url.replace(regex, '')
  regex = new RegExp(name + '(=([^&#]*)|&|#|$)');
  return url.replace(regex, '')
}
try {
  var url = event.detail.data.url;
  url = decodeURIComponent(url);
  var deleteQueryParam = ["gclid"]
  for (var i = 0; i < deleteQueryParam.length; i++) {
    url = removeParameters(deleteQueryParam[i], url)
  }
  url = url.replace("?&", '?');
  return url;
} catch (e) {}
}
      }
    },
    "Consent | Cookie Object": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/cookie.js",
      "settings": {
        "name": "adobeujs-optin"
      }
    },
    "Content | Loggedin Status": {
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  return eddl[1].data.loggedIn;
}catch(e){}
return "no"
}
      }
    },
    "random id": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/randomNumber.js",
      "settings": {
        "max": 100000000,
        "min": 0
      }
    },
    "Event | Value": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.value"
      }
    },
    "Product View | fler-lotter": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  var url = _satellite.getVar("Content | url");
  _satellite.logger.log("product view url", url);
  url = url.split("/");
  if( url.length == 4){
    return url[3];
  }
  _satellite.logger.log("not a product page");
}catch(e){}
}
      }
    },
    "Content | Domain": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  return window.location.hostname;
}
      }
    },
    "Event | Label": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.label"
      }
    },
    "AAM | exception url": {
      "defaultValue": "false",
      "modulePath": "mapping-table/src/lib/dataElements/mappingTable.js",
      "settings": {
        "0": {
          "input": "/triss",
          "method": "starts with",
          "output": "true"
        },
        "1": {
          "input": "/min-profil/uppgifter",
          "method": "starts with",
          "output": "true"
        },
        "size": 2,
        "dataElement": "%AA | page url%",
        "defaultValueEmpty": true
      }
    },
    "Transaction | Items": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.items"
      }
    },
    "Search | Query": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.query"
      }
    },
    "Consent | Profiling Cookies": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.profilingCookies"
      }
    },
    "AAM | exception link name": {
      "defaultValue": "false",
      "modulePath": "mapping-table/src/lib/dataElements/mappingTable.js",
      "settings": {
        "size": 0,
        "dataElement": "%AA | link name%",
        "defaultValueEmpty": true
      }
    },
    "AA | link name": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  return s.linkName;
}catch(e){}
}
      }
    },
    "AA | page url": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  return s.eVar3;
}catch(e){}
}
      }
    },
    "Event | Registration Type": {
      "defaultValue": "",
      "forceLowerCase": true,
      "storageDuration": "session",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try {
     if (_satellite.getVar("EDDL | event") == "event" && _satellite.getVar("Event | Action") == "Customer Registration") {   
    var label = _satellite.getVar("Event | Label").toLowerCase();
    if (label == "started_new_customer_from_frejaeid" || label == "started_retail_customer_from_frejaeid" || label == "started_retail_customer_from_bankid" || label == "started_new_customer_from_bankid") {
      return label.split("_")[1];
    }
  } 
} catch (e) {
  _satellite.logger.warn("Error in dataelement Event | Registration Type==> " + e);
}
}
      }
    },
    "Consent | Analytics Browser": {
      "defaultValue": "",
      "storageDuration": "session",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.analyticsBrowser"
      }
    },
    "AA | pageName": {
      "defaultValue": "",
      "modulePath": "core/src/lib/dataElements/customCode.js",
      "settings": {
        "source": function(event) {
  try{
  return s.pageName;
}catch(e){}
}
      }
    },
    "Consent | Personalized Browser": {
      "defaultValue": "",
      "storageDuration": "session",
      "modulePath": "core/src/lib/dataElements/javascriptVariable.js",
      "settings": {
        "path": "event.detail.data.personalizedBrowser"
      }
    }
  },
  "extensions": {
    "adobe-mcid": {
      "displayName": "Experience Cloud ID Service",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP4413121ff4ce4a49869b12b0ea80c748/",
      "settings": {
        "orgId": "88743E6A5A74B5900A495D61@AdobeOrg",
        "variables": [
          {
            "name": "cookieDomain",
            "value": "%Content | Domain%"
          },
          {
            "name": "secureCookie",
            "value": "true"
          }
        ],
        "doesOptInApply": true,
        "previousPermissions": "%Consent | Cookie Object%",
        "isOptInStorageEnabled": true
      },
      "modules": {
        "adobe-mcid/src/lib/actions/setCustomerIds.js": {
          "name": "set-customer-ids",
          "displayName": "Set Customer IDs",
          "script": function(module, exports, require, turbine) {
'use strict';

var mcidInstance = require('../sharedModules/mcidInstance');
var logger = turbine.logger;

var isPopulatedString = function(val) {
  return typeof val === 'string' && val.length > 0;
};

var formatForMcid = function(customerIds) {
  var formatted = {};
  var rejected = [];

  customerIds.forEach(function(customerId) {
    var integrationCode = customerId.integrationCode;
    var value = customerId.value;

    if (isPopulatedString(integrationCode) && isPopulatedString(value)) {
      formatted[integrationCode] = {
        id: value
      };

      if (customerId.hasOwnProperty('authState')) {
        formatted[customerId.integrationCode].authState = customerId.authState;
      }

      if (customerId.hasOwnProperty('hashType')) {
        formatted[customerId.integrationCode].hashType = customerId.hashType;
      }
    } else {
      rejected.push(customerId);
    }
  });

  if (rejected.length) {
    logger.warn('Rejected these customer ids: ' + JSON.stringify(rejected));
  }

  return formatted;
};

module.exports = function(settings) {
  if (!mcidInstance) {
    logger.warn('MCID instance cannot be found. Cannot set Customer IDs.');
    return;
  }

  var customerIds = formatForMcid(settings.customerIds);
  mcidInstance.setCustomerIDs(customerIds);
  logger.info('Set Customer IDs: ' + JSON.stringify(customerIds));
};

          }

        },
        "adobe-mcid/src/lib/sharedModules/mcidInstance.js": {
          "script": function(module, exports, require, turbine) {

'use strict';
var document = require('@adobe/reactor-document');
var VisitorAPI = require('../codeLibrary/VisitorAPI');
var timeUnits = require('../../view/utils/timeUnits');

var transformArrayToObject = function(configs) {
  var initConfig = configs.reduce(function(obj, config) {
    var value = /^(true|false)$/i.test(config.value) ? JSON.parse(config.value) : config.value;

    obj[config.name] = value;

    return obj;
  }, {});

  return initConfig;
};

var initializeVisitorId = function(Visitor) {
  var extensionSettings = turbine.getExtensionSettings();
  if (typeof extensionSettings.orgId !== 'string') {
    throw new TypeError('Org ID is not a string.');
  }

  var initConfig = transformArrayToObject(extensionSettings.variables || []);
  var doesOptInApply = extensionSettings.doesOptInApply;
  if (doesOptInApply) {
    if (typeof doesOptInApply === 'boolean') {
      initConfig['doesOptInApply'] = doesOptInApply; 
    } else if (extensionSettings.optInCallback) {
      initConfig['doesOptInApply'] = extensionSettings.optInCallback; 
    }
  }

  var isOptInStorageEnabled = extensionSettings.isOptInStorageEnabled;
  if (isOptInStorageEnabled) {
    initConfig['isOptInStorageEnabled'] = isOptInStorageEnabled;
  }

  var optInCookieDomain = extensionSettings.optInCookieDomain;
  if (optInCookieDomain) {
    initConfig['optInCookieDomain'] = optInCookieDomain;
  }

  var optInStorageExpiry = extensionSettings.optInStorageExpiry;
  if (optInStorageExpiry) {
    var timeUnit = extensionSettings.timeUnit;
    if (timeUnit && timeUnits[timeUnit]) {
      var seconds = optInStorageExpiry * timeUnits[timeUnit];
      initConfig['optInStorageExpiry'] = seconds;
    }
  } else if (isOptInStorageEnabled === true) {
    initConfig['optInStorageExpiry'] = 13 * 30 * 24 * 3600;
  }

  var previousPermissions = extensionSettings.previousPermissions;
  if (previousPermissions) {
    initConfig['previousPermissions'] = previousPermissions;
  }

  var preOptInApprovals = extensionSettings.preOptInApprovals;
  if (preOptInApprovals) {
    initConfig['preOptInApprovals'] = preOptInApprovals;
  } else {
    var preOptInApprovalInput = extensionSettings.preOptInApprovalInput;
    if (preOptInApprovalInput) {
      initConfig['preOptInApprovals'] = preOptInApprovalInput;
    }
  }

  var isIabContext = extensionSettings.isIabContext;
  if (isIabContext) {
    initConfig['isIabContext'] = isIabContext;
  }

  var instance = Visitor.getInstance(extensionSettings.orgId, initConfig);

  turbine.logger.info('Created instance using orgId: "' + extensionSettings.orgId + '"');
  turbine.logger.info('Set variables: ' + JSON.stringify(initConfig));

  instance.getMarketingCloudVisitorID(function(id) {
    turbine.logger.info('Obtained Marketing Cloud Visitor Id: ' + id);
  }, true);

  return instance;
};

var excludePathsMatched = function(path) {
  var extensionSettings = turbine.getExtensionSettings();
  var pathExclusions = extensionSettings.pathExclusions || [];

  return pathExclusions.some(function(pathExclusion) {
    if (pathExclusion.valueIsRegex) {
      return new RegExp(pathExclusion.value, 'i').test(path);
    } else {
      return pathExclusion.value === path;
    }
  });
};

var visitorIdInstance = null;

_satellite.getVisitorId = function() { return visitorIdInstance; };

if (excludePathsMatched(document.location.pathname)) {
  turbine.logger.warn('MCID library not loaded. One of the path exclusions matches the ' +
    'current path.');
} else {
  visitorIdInstance = initializeVisitorId(VisitorAPI);
}

module.exports = visitorIdInstance;

          }
,
          "name": "mcid-instance",
          "shared": true
        },
        "adobe-mcid/src/lib/codeLibrary/VisitorAPI.js": {
          "script": function(module, exports, require, turbine) {
module.exports = function() {
var e=function(){"use strict";function e(t){"@babel/helpers - typeof";return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(t)}function t(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function n(){return{callbacks:{},add:function(e,t){this.callbacks[e]=this.callbacks[e]||[];var n=this.callbacks[e].push(t)-1,i=this;return function(){i.callbacks[e].splice(n,1)}},execute:function(e,t){if(this.callbacks[e]){t=void 0===t?[]:t,t=t instanceof Array?t:[t];try{for(;this.callbacks[e].length;){var n=this.callbacks[e].shift();"function"==typeof n?n.apply(null,t):n instanceof Array&&n[1].apply(n[0],t)}delete this.callbacks[e]}catch(e){}}},executeAll:function(e,t){(t||e&&!U.isObjectEmpty(e))&&Object.keys(this.callbacks).forEach(function(t){var n=void 0!==e[t]?e[t]:"";this.execute(t,n)},this)},hasCallbacks:function(){return Boolean(Object.keys(this.callbacks).length)}}}function i(e,t,n){var i=null==e?void 0:e[t];return void 0===i?n:i}function r(e){for(var t=/^\d+$/,n=0,i=e.length;n<i;n++)if(!t.test(e[n]))return!1;return!0}function a(e,t){for(;e.length<t.length;)e.push("0");for(;t.length<e.length;)t.push("0")}function o(e,t){for(var n=0;n<e.length;n++){var i=parseInt(e[n],10),r=parseInt(t[n],10);if(i>r)return 1;if(r>i)return-1}return 0}function s(e,t){if(e===t)return 0;var n=e.toString().split("."),i=t.toString().split(".");return r(n.concat(i))?(a(n,i),o(n,i)):NaN}function c(e){return e===Object(e)&&0===Object.keys(e).length}function u(e){return"function"==typeof e||e instanceof Array&&e.length}function l(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){return!0};this.log=Ie("log",e,t),this.warn=Ie("warn",e,t),this.error=Ie("error",e,t)}function d(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.cookieName,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=n.cookies;if(!t||!i)return{get:xe,set:xe,remove:xe};var r={remove:function(){i.remove(t)},get:function(){var e=i.get(t),n={};try{n=JSON.parse(e)}catch(e){n={}}return n},set:function(e,n){n=n||{};var a=r.get(),o=Object.assign(a,e);i.set(t,JSON.stringify(o),{domain:n.optInCookieDomain||"",cookieLifetime:n.optInStorageExpiry||3419e4,secure:n.secure,sameSite:n.sameSite,expires:!0})}};return r}function f(e){this.name=this.constructor.name,this.message=e,"function"==typeof Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):this.stack=new Error(e).stack}function p(){function e(e,t){var n=Ae(e);return n.length?n.every(function(e){return!!t[e]}):Oe(t)}function t(){E(M),k(de.COMPLETE),S(C.status,C.permissions),s&&_.set(C.permissions,{optInCookieDomain:c,optInStorageExpiry:u,secure:f,sameSite:p}),I.execute(He)}function n(e){return function(n,i){if(!Me(n))throw new Error("[OptIn] Invalid category(-ies). Please use the `OptIn.Categories` enum.");return k(de.CHANGED),Object.assign(M,ke(Ae(n),e)),i||t(),C}}var i=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=i.doesOptInApply,a=i.previousPermissions,o=i.preOptInApprovals,s=i.isOptInStorageEnabled,c=i.optInCookieDomain,u=i.optInStorageExpiry,l=i.isIabContext,f=i.secureCookie,p=i.sameSiteCookie,g=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},m=g.cookies,h=Ne(a);Fe(h,"Invalid `previousPermissions`!"),Fe(o,"Invalid `preOptInApprovals`!");var _=d({cookieName:"adobeujs-optin"},{cookies:m}),C=this,S=le(C),I=_e(),v=Le(h),D=Le(o),y=s?_.get():{},b={},A=function(e,t){return Pe(e)||t&&Pe(t)?de.COMPLETE:de.PENDING}(v,y),O=function(e,t,n){var i=ke(he,!r);return r?Object.assign({},i,e,t,n):i}(D,v,y),M=Ee(O),k=function(e){return A=e},E=function(e){return O=e};C.deny=n(!1),C.approve=n(!0),C.denyAll=C.deny.bind(C,he),C.approveAll=C.approve.bind(C,he),C.isApproved=function(t){return e(t,C.permissions)},C.isPreApproved=function(t){return e(t,D)},C.fetchPermissions=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=t?C.on(de.COMPLETE,e):xe;return!r||r&&C.isComplete||!!o?e(C.permissions):t||I.add(He,function(){return e(C.permissions)}),n},C.complete=function(){C.status===de.CHANGED&&t()},C.registerPlugin=function(e){if(!e||!e.name||"function"!=typeof e.onRegister)throw new Error(Be);b[e.name]||(b[e.name]=e,e.onRegister.call(e,C))},C.execute=Ue(b),C.memoizeContent=function(e){we(e)&&_.set(e,{optInCookieDomain:c,optInStorageExpiry:u,secure:f,sameSite:p})},C.getMemoizedContent=function(e){var t=_.get();if(t)return t[e]},Object.defineProperties(C,{permissions:{get:function(){return O}},status:{get:function(){return A}},Categories:{get:function(){return fe}},doesOptInApply:{get:function(){return!!r}},isPending:{get:function(){return C.status===de.PENDING}},isComplete:{get:function(){return C.status===de.COMPLETE}},__plugins:{get:function(){return Object.keys(b)}},isIabContext:{get:function(){return l}}})}function g(e,t){function n(){r=null,e.call(e,new f("The call took longer than you wanted!"))}function i(){r&&(clearTimeout(r),e.apply(e,arguments))}if(void 0===t)return e;var r=setTimeout(n,t);return i}function m(){if(window.__tcfapi)return window.__tcfapi;var e=window;if(e===window.top)return void ye.error("__tcfapi not found");for(var t;!t;){e=e.parent;try{e.frames.__tcfapiLocator&&(t=e)}catch(e){}if(e===window.top)break}if(!t)return void ye.error("__tcfapi not found");var n={};return window.__tcfapi=function(e,i,r,a){var o=Math.random()+"",s={__tcfapiCall:{command:e,parameter:a,version:i,callId:o}};n[o]=r,t.postMessage(s,"*")},window.addEventListener("message",function(e){var t=e.data;if("string"==typeof t)try{t=JSON.parse(e.data)}catch(e){}if(t.__tcfapiReturn){var i=t.__tcfapiReturn;"function"==typeof n[i.callId]&&(n[i.callId](i.returnValue,i.success),delete n[i.callId])}},!1),window.__tcfapi}function h(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],i=!0===e.vendor.consents[t],r=n.every(function(t){return!0===e.purpose.consents[t]});return i&&r}function _(){var e=this;e.name="iabPlugin",e.version="0.0.2";var t,n=_e(),i={transparencyAndConsentData:null},r=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return i[e]=t};e.fetchConsentData=function(e){var t=e.callback,n=e.timeout,i=g(t,n);a({callback:i})},e.isApproved=function(e){var t=e.callback,n=e.category,r=e.timeout;if(i.transparencyAndConsentData)return t(null,h(i.transparencyAndConsentData,pe[n],ge[n]));var o=g(function(e,i){t(e,h(i,pe[n],ge[n]))},r);a({category:n,callback:o})},e.onRegister=function(n){t=n;var i=Object.keys(pe),r=function(e,t){!e&&t&&(i.forEach(function(e){var i=h(t,pe[e],ge[e]);n[i?"approve":"deny"](e,!0)}),n.complete())};e.fetchConsentData({callback:r})};var a=function(e){var a=e.callback;if(i.transparencyAndConsentData)return a(null,i.transparencyAndConsentData);n.add("FETCH_CONSENT_DATA",a),o(function(e,a){if(a){var o=Ee(e),s=t.getMemoizedContent("iabConsentHash"),c=De(o.tcString).toString(32);o.consentString=e.tcString,o.hasConsentChangedSinceLastCmpPull=s!==c,r("transparencyAndConsentData",o),t.memoizeContent({iabConsentHash:c})}n.execute("FETCH_CONSENT_DATA",[null,i.transparencyAndConsentData])})},o=function(e){var t=Ve(pe),n=m();"function"==typeof n&&n("getTCData",2,e,t)}}var C="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};Object.assign=Object.assign||function(e){for(var t,n,i=1;i<arguments.length;++i){n=arguments[i];for(t in n)Object.prototype.hasOwnProperty.call(n,t)&&(e[t]=n[t])}return e};var S,I,v={HANDSHAKE:"HANDSHAKE",GETSTATE:"GETSTATE",PARENTSTATE:"PARENTSTATE"},D={MCMID:"MCMID",MCAID:"MCAID",MCAAMB:"MCAAMB",MCAAMLH:"MCAAMLH",MCOPTOUT:"MCOPTOUT",CUSTOMERIDS:"CUSTOMERIDS"},y={MCMID:"getMarketingCloudVisitorID",MCAID:"getAnalyticsVisitorID",MCAAMB:"getAudienceManagerBlob",MCAAMLH:"getAudienceManagerLocationHint",MCOPTOUT:"isOptedOut",ALLFIELDS:"getVisitorValues"},b={CUSTOMERIDS:"getCustomerIDs"},A={MCMID:"getMarketingCloudVisitorID",MCAAMB:"getAudienceManagerBlob",MCAAMLH:"getAudienceManagerLocationHint",MCOPTOUT:"isOptedOut",MCAID:"getAnalyticsVisitorID",CUSTOMERIDS:"getCustomerIDs",ALLFIELDS:"getVisitorValues"},O={MC:"MCMID",A:"MCAID",AAM:"MCAAMB"},M={MCMID:"MCMID",MCOPTOUT:"MCOPTOUT",MCAID:"MCAID",MCAAMLH:"MCAAMLH",MCAAMB:"MCAAMB"},k={UNKNOWN:0,AUTHENTICATED:1,LOGGED_OUT:2},E={GLOBAL:"global"},T={LAX:"Lax",STRICT:"Strict",NONE:"None"},L={MESSAGES:v,STATE_KEYS_MAP:D,ASYNC_API_MAP:y,SYNC_API_MAP:b,ALL_APIS:A,FIELDGROUP_TO_FIELD:O,FIELDS:M,AUTH_STATE:k,OPT_OUT:E,SAME_SITE_VALUES:T},P=L.STATE_KEYS_MAP,R=function(e){function t(){}function n(t,n){var i=this;return function(){var r=e(0,t),a={};return a[t]=r,i.setStateAndPublish(a),n(r),r}}this.getMarketingCloudVisitorID=function(e){e=e||t;var i=this.findField(P.MCMID,e),r=n.call(this,P.MCMID,e);return void 0!==i?i:r()},this.getVisitorValues=function(e){this.getMarketingCloudVisitorID(function(t){e({MCMID:t})})}},w=L.MESSAGES,x=L.ASYNC_API_MAP,N=L.SYNC_API_MAP,F=function(){function e(){}function t(e,t){var n=this;return function(){return n.callbackRegistry.add(e,t),n.messageParent(w.GETSTATE),""}}function n(n){this[x[n]]=function(i){i=i||e;var r=this.findField(n,i),a=t.call(this,n,i);return void 0!==r?r:a()}}function i(t){this[N[t]]=function(){return this.findField(t,e)||{}}}Object.keys(x).forEach(n,this),Object.keys(N).forEach(i,this)},j=L.ASYNC_API_MAP,V=function(){Object.keys(j).forEach(function(e){this[j[e]]=function(t){this.callbackRegistry.add(e,t)}},this)},U=function(e,t){return t={exports:{}},e(t,t.exports),t.exports}(function(t,n){n.isObjectEmpty=function(e){return e===Object(e)&&0===Object.keys(e).length},n.isValueEmpty=function(e){return""===e||n.isObjectEmpty(e)};var i=function(){var e=navigator.appName,t=navigator.userAgent;return"Microsoft Internet Explorer"===e||t.indexOf("MSIE ")>=0||t.indexOf("Trident/")>=0&&t.indexOf("Windows NT 6")>=0};n.getIeVersion=function(){return document.documentMode?document.documentMode:i()?7:null},n.isFirefox=function(e){return!!/Firefox\/([0-9\.]+)(?:\s|$)/.test(e||window.navigator.userAgent)},n.encodeAndBuildRequest=function(e,t){return e.map(encodeURIComponent).join(t)},n.isObject=function(t){return null!==t&&"object"===e(t)&&!1===Array.isArray(t)},n.defineGlobalNamespace=function(){return window.adobe=n.isObject(window.adobe)?window.adobe:{},window.adobe},n.pluck=function(e,t){return t.reduce(function(t,n){return e[n]&&(t[n]=e[n]),t},Object.create(null))},n.parseOptOut=function(e,t,n){t||(t=n,e.d_optout&&e.d_optout instanceof Array&&(t=e.d_optout.join(",")));var i=parseInt(e.d_ottl,10);return isNaN(i)&&(i=7200),{optOut:t,d_ottl:i}},n.normalizeBoolean=function(e){var t=e;return"true"===e?t=!0:"false"===e&&(t=!1),t}}),H=(U.isObjectEmpty,U.isValueEmpty,U.getIeVersion,U.isFirefox,U.encodeAndBuildRequest,U.isObject,U.defineGlobalNamespace,U.pluck,U.parseOptOut,U.normalizeBoolean,n),B=L.MESSAGES,G={0:"prefix",1:"orgID",2:"state"},Y=function(e,t){this.parse=function(e){try{var t={};return e.data.split("|").forEach(function(e,n){if(void 0!==e){t[G[n]]=2!==n?e:JSON.parse(e)}}),t}catch(e){}},this.isInvalid=function(n){var i=this.parse(n);if(!i||Object.keys(i).length<2)return!0;var r=e!==i.orgID,a=!t||n.origin!==t,o=-1===Object.keys(B).indexOf(i.prefix);return r||a||o},this.send=function(n,i,r){var a=i+"|"+e;r&&r===Object(r)&&(a+="|"+JSON.stringify(r));try{n.postMessage(a,t)}catch(e){}}},q=L.MESSAGES,X=function(e,t,n,i){function r(e){Object.assign(p,e)}function a(e){Object.assign(p.state,e),Object.assign(p.state.ALLFIELDS,e),p.callbackRegistry.executeAll(p.state)}function o(e){if(!h.isInvalid(e)){m=!1;var t=h.parse(e);p.setStateAndPublish(t.state)}}function s(e){!m&&g&&(m=!0,h.send(i,e))}function c(){r(new R(n._generateID)),p.getMarketingCloudVisitorID(),p.callbackRegistry.executeAll(p.state,!0),C.removeEventListener("message",u)}function u(e){if(!h.isInvalid(e)){var t=h.parse(e);m=!1,C.clearTimeout(p._handshakeTimeout),C.removeEventListener("message",u),r(new F(p)),C.addEventListener("message",o),p.setStateAndPublish(t.state),p.callbackRegistry.hasCallbacks()&&s(q.GETSTATE)}}function l(){g&&postMessage?(C.addEventListener("message",u),s(q.HANDSHAKE),p._handshakeTimeout=setTimeout(c,250)):c()}function d(){C.s_c_in||(C.s_c_il=[],C.s_c_in=0),p._c="Visitor",p._il=C.s_c_il,p._in=C.s_c_in,p._il[p._in]=p,C.s_c_in++}function f(){function e(e){0!==e.indexOf("_")&&"function"==typeof n[e]&&(p[e]=function(){})}Object.keys(n).forEach(e),p.getSupplementalDataID=n.getSupplementalDataID,p.isAllowed=function(){return!0}}var p=this,g=t.whitelistParentDomain;p.state={ALLFIELDS:{}},p.version=n.version,p.marketingCloudOrgID=e,p.cookieDomain=n.cookieDomain||"",p._instanceType="child";var m=!1,h=new Y(e,g);p.callbackRegistry=H(),p.init=function(){d(),f(),r(new V(p)),l()},p.findField=function(e,t){if(void 0!==p.state[e])return t(p.state[e]),p.state[e]},p.messageParent=s,p.setStateAndPublish=a},W=L.MESSAGES,K=L.ALL_APIS,J=L.ASYNC_API_MAP,z=L.FIELDGROUP_TO_FIELD,Q=function(e,t){function n(){var t={};return Object.keys(K).forEach(function(n){var i=K[n],r=e[i]();U.isValueEmpty(r)||(t[n]=r)}),t}function i(){var t=[];return e._loading&&Object.keys(e._loading).forEach(function(n){if(e._loading[n]){var i=z[n];t.push(i)}}),t.length?t:null}function r(t){return function n(r){var a=i();if(a){var o=J[a[0]];e[o](n,!0)}else t()}}function a(e,i){var r=n();t.send(e,i,r)}function o(e){c(e),a(e,W.HANDSHAKE)}function s(e){r(function(){a(e,W.PARENTSTATE)})()}function c(n){function i(i){r.call(e,i),t.send(n,W.PARENTSTATE,{CUSTOMERIDS:e.getCustomerIDs()})}var r=e.setCustomerIDs;e.setCustomerIDs=i}return function(e){if(!t.isInvalid(e)){(t.parse(e).prefix===W.HANDSHAKE?o:s)(e.source)}}},$=function(e,t){function n(e){return function(n){i[e]=n,r++,r===a&&t(i)}}var i={},r=0,a=Object.keys(e).length;Object.keys(e).forEach(function(t){var i=e[t];if(i.fn){var r=i.args||[];r.unshift(n(t)),i.fn.apply(i.context||null,r)}})},Z={get:function(e){e=encodeURIComponent(e);var t=(";"+document.cookie).split(" ").join(";"),n=t.indexOf(";"+e+"="),i=n<0?n:t.indexOf(";",n+1);return n<0?"":decodeURIComponent(t.substring(n+2+e.length,i<0?t.length:i))},set:function(e,t,n){var r=i(n,"cookieLifetime"),a=i(n,"expires"),o=i(n,"domain"),s=i(n,"secure"),c=i(n,"sameSite"),u=s?"Secure":"",l=c?"SameSite="+c+";":"";if(a&&"SESSION"!==r&&"NONE"!==r){var d=""!==t?parseInt(r||0,10):-60;if(d)a=new Date,a.setTime(a.getTime()+1e3*d);else if(1===a){a=new Date;var f=a.getYear();a.setYear(f+2+(f<1900?1900:0))}}else a=0;return e&&"NONE"!==r?(document.cookie=encodeURIComponent(e)+"="+encodeURIComponent(t)+"; path=/;"+(a?" expires="+a.toGMTString()+";":"")+(o?" domain="+o+";":"")+l+u,this.get(e)===t):0},remove:function(e,t){var n=i(t,"domain");n=n?" domain="+n+";":"";var r=i(t,"secure"),a=i(t,"sameSite"),o=r?"Secure":"",s=a?"SameSite="+a+";":"";document.cookie=encodeURIComponent(e)+"=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"+n+s+o}},ee=function(e,t){var n;!e&&C.location&&(e=C.location.hostname),n=e;var i,r=n.split("."),a=t||{};for(i=r.length-2;i>=0;i--)if(a.domain=r.slice(i).join("."),Z.set("test","cookie",a))return Z.remove("test",a),a.domain;return""},te={compare:s,isLessThan:function(e,t){return s(e,t)<0},areVersionsDifferent:function(e,t){return 0!==s(e,t)},isGreaterThan:function(e,t){return s(e,t)>0},isEqual:function(e,t){return 0===s(e,t)}},ne=!!C.postMessage,ie={postMessage:function(e,t,n){var i=1;t&&(ne?n.postMessage(e,t.replace(/([^:]+:\/\/[^\/]+).*/,"$1")):t&&(n.location=t.replace(/#.*$/,"")+"#"+ +new Date+i+++"&"+e))},receiveMessage:function(e,t){var n;try{ne&&(e&&(n=function(n){if("string"==typeof t&&n.origin!==t||"[object Function]"===Object.prototype.toString.call(t)&&!1===t(n.origin))return!1;e(n)}),C.addEventListener?C[e?"addEventListener":"removeEventListener"]("message",n):C[e?"attachEvent":"detachEvent"]("onmessage",n))}catch(e){}}},re=function(e){var t,n,i="0123456789",r="",a="",o=8,s=10,c=10,u=""+Date.now(),l=u.substr(-6).split("").reverse("").join("");if(1==e){for(i+="ABCDEF",t=0;16>t;t++)n=Math.floor(Math.random()*o),4>t&&l[t]<o&&(n=+l[t]),r+=i.substring(n,n+1),n=Math.floor(Math.random()*o),a+=i.substring(n,n+1),o=16;return r+"-"+a}for(t=0;19>t;t++)n=Math.floor(Math.random()*s),6>t&&l[t]<s?(r+=l[t],n=l[t]):r+=i.substring(n,n+1),0===t&&9==n?s=3:(1==t||2==t)&&10!=s&&2>n?s=10:2<t&&(s=10),n=Math.floor(Math.random()*c),a+=i.substring(n,n+1),0===t&&9==n?c=3:(1==t||2==t)&&10!=c&&2>n?c=10:2<t&&(c=10);return r+a},ae=function(e,t){return{corsMetadata:function(){var e="none",t=!0;return"undefined"!=typeof XMLHttpRequest&&XMLHttpRequest===Object(XMLHttpRequest)&&("withCredentials"in new XMLHttpRequest?e="XMLHttpRequest":"undefined"!=typeof XDomainRequest&&XDomainRequest===Object(XDomainRequest)&&(t=!1),Object.prototype.toString.call(C.HTMLElement).indexOf("Constructor")>0&&(t=!1)),{corsType:e,corsCookiesEnabled:t}}(),getCORSInstance:function(){return"none"===this.corsMetadata.corsType?null:new C[this.corsMetadata.corsType]},fireCORS:function(t,n,i){function r(e){var n;try{if((n=JSON.parse(e))!==Object(n))return void a.handleCORSError(t,null,"Response is not JSON")}catch(e){return void a.handleCORSError(t,e,"Error parsing response as JSON")}try{for(var i=t.callback,r=C,o=0;o<i.length;o++)r=r[i[o]];r(n)}catch(e){a.handleCORSError(t,e,"Error forming callback function")}}var a=this;n&&(t.loadErrorHandler=n);try{var o=this.getCORSInstance();o.open("get",t.corsUrl+"&ts="+(new Date).getTime(),!0),"XMLHttpRequest"===this.corsMetadata.corsType&&(o.withCredentials=!0,o.timeout=e.loadTimeout,o.setRequestHeader("Content-Type","application/x-www-form-urlencoded"),o.onreadystatechange=function(){4===this.readyState&&200===this.status&&r(this.responseText)}),o.onerror=function(e){a.handleCORSError(t,e,"onerror")},o.ontimeout=function(e){a.handleCORSError(t,e,"ontimeout")},o.send(),e._log.requests.push(t.corsUrl)}catch(e){this.handleCORSError(t,e,"try-catch")}},handleCORSError:function(t,n,i){e.CORSErrors.push({corsData:t,error:n,description:i}),t.loadErrorHandler&&("ontimeout"===i?t.loadErrorHandler(!0):t.loadErrorHandler(!1))}}},oe={POST_MESSAGE_ENABLED:!!C.postMessage,DAYS_BETWEEN_SYNC_ID_CALLS:1,MILLIS_PER_DAY:864e5,ADOBE_MC:"adobe_mc",ADOBE_MC_SDID:"adobe_mc_sdid",VALID_VISITOR_ID_REGEX:/^[0-9a-fA-F\-]+$/,ADOBE_MC_TTL_IN_MIN:5,VERSION_REGEX:/vVersion\|((\d+\.)?(\d+\.)?(\*|\d+))(?=$|\|)/,FIRST_PARTY_SERVER_COOKIE:"s_ecid"},se=function(e,t){var n=C.document;return{THROTTLE_START:3e4,MAX_SYNCS_LENGTH:649,throttleTimerSet:!1,id:null,onPagePixels:[],iframeHost:null,getIframeHost:function(e){if("string"==typeof e){var t=e.split("/");return t[0]+"//"+t[2]}},subdomain:null,url:null,getUrl:function(){var t,i="http://fast.",r="?d_nsid="+e.idSyncContainerID+"#"+encodeURIComponent(n.location.origin);return this.subdomain||(this.subdomain="nosubdomainreturned"),e.loadSSL&&(i=e.idSyncSSLUseAkamai?"https://fast.":"https://"),t=i+this.subdomain+".demdex.net/dest5.html"+r,this.iframeHost=this.getIframeHost(t),this.id="destination_publishing_iframe_"+this.subdomain+"_"+e.idSyncContainerID,t},checkDPIframeSrc:function(){var t="?d_nsid="+e.idSyncContainerID+"#"+encodeURIComponent(n.location.href);"string"==typeof e.dpIframeSrc&&e.dpIframeSrc.length&&(this.id="destination_publishing_iframe_"+(e._subdomain||this.subdomain||(new Date).getTime())+"_"+e.idSyncContainerID,this.iframeHost=this.getIframeHost(e.dpIframeSrc),this.url=e.dpIframeSrc+t)},idCallNotProcesssed:null,doAttachIframe:!1,startedAttachingIframe:!1,iframeHasLoaded:null,iframeIdChanged:null,newIframeCreated:null,originalIframeHasLoadedAlready:null,iframeLoadedCallbacks:[],regionChanged:!1,timesRegionChanged:0,sendingMessages:!1,messages:[],messagesPosted:[],messagesReceived:[],messageSendingInterval:oe.POST_MESSAGE_ENABLED?null:100,onPageDestinationsFired:[],jsonForComparison:[],jsonDuplicates:[],jsonWaiting:[],jsonProcessed:[],canSetThirdPartyCookies:!0,receivedThirdPartyCookiesNotification:!1,readyToAttachIframePreliminary:function(){return!(e.idSyncDisableSyncs||e.disableIdSyncs||e.idSyncDisable3rdPartySyncing||e.disableThirdPartyCookies||e.disableThirdPartyCalls)},readyToAttachIframe:function(){return this.readyToAttachIframePreliminary()&&(this.doAttachIframe||e._doAttachIframe)&&(this.subdomain&&"nosubdomainreturned"!==this.subdomain||e._subdomain)&&this.url&&!this.startedAttachingIframe},attachIframe:function(){function e(){r=n.createElement("iframe"),r.sandbox="allow-scripts allow-same-origin",r.title="Adobe ID Syncing iFrame",r.id=i.id,r.name=i.id+"_name",r.style.cssText="display: none; width: 0; height: 0;",r.src=i.url,i.newIframeCreated=!0,t(),n.body.appendChild(r)}function t(e){r.addEventListener("load",function(){r.className="aamIframeLoaded",i.iframeHasLoaded=!0,i.fireIframeLoadedCallbacks(e),i.requestToProcess()})}this.startedAttachingIframe=!0;var i=this,r=n.getElementById(this.id);r?"IFRAME"!==r.nodeName?(this.id+="_2",this.iframeIdChanged=!0,e()):(this.newIframeCreated=!1,"aamIframeLoaded"!==r.className?(this.originalIframeHasLoadedAlready=!1,t("The destination publishing iframe already exists from a different library, but hadn't loaded yet.")):(this.originalIframeHasLoadedAlready=!0,this.iframeHasLoaded=!0,this.iframe=r,this.fireIframeLoadedCallbacks("The destination publishing iframe already exists from a different library, and had loaded alresady."),this.requestToProcess())):e(),this.iframe=r},fireIframeLoadedCallbacks:function(e){this.iframeLoadedCallbacks.forEach(function(t){"function"==typeof t&&t({message:e||"The destination publishing iframe was attached and loaded successfully."})}),this.iframeLoadedCallbacks=[]},requestToProcess:function(t){function n(){r.jsonForComparison.push(t),r.jsonWaiting.push(t),r.processSyncOnPage(t)}var i,r=this;if(t===Object(t)&&t.ibs)if(i=JSON.stringify(t.ibs||[]),this.jsonForComparison.length){var a,o,s,c=!1;for(a=0,o=this.jsonForComparison.length;a<o;a++)if(s=this.jsonForComparison[a],i===JSON.stringify(s.ibs||[])){c=!0;break}c?this.jsonDuplicates.push(t):n()}else n();if((this.receivedThirdPartyCookiesNotification||!oe.POST_MESSAGE_ENABLED||this.iframeHasLoaded)&&this.jsonWaiting.length){var u=this.jsonWaiting.shift();this.process(u),this.requestToProcess()}e.idSyncDisableSyncs||e.disableIdSyncs||!this.iframeHasLoaded||!this.messages.length||this.sendingMessages||(this.throttleTimerSet||(this.throttleTimerSet=!0,setTimeout(function(){r.messageSendingInterval=oe.POST_MESSAGE_ENABLED?null:150},this.THROTTLE_START)),this.sendingMessages=!0,this.sendMessages())},getRegionAndCheckIfChanged:function(t,n){var i=e._getField("MCAAMLH"),r=t.d_region||t.dcs_region;return i?r&&(e._setFieldExpire("MCAAMLH",n),e._setField("MCAAMLH",r),parseInt(i,10)!==r&&(this.regionChanged=!0,this.timesRegionChanged++,e._setField("MCSYNCSOP",""),e._setField("MCSYNCS",""),i=r)):(i=r)&&(e._setFieldExpire("MCAAMLH",n),e._setField("MCAAMLH",i)),i||(i=""),i},processSyncOnPage:function(e){var t,n,i,r;if((t=e.ibs)&&t instanceof Array&&(n=t.length))for(i=0;i<n;i++)r=t[i],r.syncOnPage&&this.checkFirstPartyCookie(r,"","syncOnPage")},process:function(e){var t,n,i,r,a,o=encodeURIComponent,s=!1;if((t=e.ibs)&&t instanceof Array&&(n=t.length))for(s=!0,i=0;i<n;i++)r=t[i],a=[o("ibs"),o(r.id||""),o(r.tag||""),U.encodeAndBuildRequest(r.url||[],","),o(r.ttl||""),"","",r.fireURLSync?"true":"false"],r.syncOnPage||(this.canSetThirdPartyCookies?this.addMessage(a.join("|")):r.fireURLSync&&this.checkFirstPartyCookie(r,a.join("|")));s&&this.jsonProcessed.push(e)},checkFirstPartyCookie:function(t,n,i){var r="syncOnPage"===i,a=r?"MCSYNCSOP":"MCSYNCS";e._readVisitor();var o,s,c=e._getField(a),u=!1,l=!1,d=Math.ceil((new Date).getTime()/oe.MILLIS_PER_DAY);c?(o=c.split("*"),s=this.pruneSyncData(o,t.id,d),u=s.dataPresent,l=s.dataValid,u&&l||this.fireSync(r,t,n,o,a,d)):(o=[],this.fireSync(r,t,n,o,a,d))},pruneSyncData:function(e,t,n){var i,r,a,o=!1,s=!1;for(r=0;r<e.length;r++)i=e[r],a=parseInt(i.split("-")[1],10),i.match("^"+t+"-")?(o=!0,n<a?s=!0:(e.splice(r,1),r--)):n>=a&&(e.splice(r,1),r--);return{dataPresent:o,dataValid:s}},manageSyncsSize:function(e){if(e.join("*").length>this.MAX_SYNCS_LENGTH)for(e.sort(function(e,t){return parseInt(e.split("-")[1],10)-parseInt(t.split("-")[1],10)});e.join("*").length>this.MAX_SYNCS_LENGTH;)e.shift()},fireSync:function(t,n,i,r,a,o){var s=this;if(t){if("img"===n.tag){var c,u,l,d,f=n.url,p=e.loadSSL?"https:":"http:";for(c=0,u=f.length;c<u;c++){l=f[c],d=/^\/\//.test(l);var g=new Image;g.addEventListener("load",function(t,n,i,r){return function(){s.onPagePixels[t]=null,e._readVisitor();var o,c=e._getField(a),u=[];if(c){o=c.split("*");var l,d,f;for(l=0,d=o.length;l<d;l++)f=o[l],f.match("^"+n.id+"-")||u.push(f)}s.setSyncTrackingData(u,n,i,r)}}(this.onPagePixels.length,n,a,o)),g.src=(d?p:"")+l,this.onPagePixels.push(g)}}}else this.addMessage(i),this.setSyncTrackingData(r,n,a,o)},addMessage:function(t){var n=encodeURIComponent,i=n(e._enableErrorReporting?"---destpub-debug---":"---destpub---");this.messages.push((oe.POST_MESSAGE_ENABLED?"":i)+t)},setSyncTrackingData:function(t,n,i,r){t.push(n.id+"-"+(r+Math.ceil(n.ttl/60/24))),this.manageSyncsSize(t),e._setField(i,t.join("*"))},sendMessages:function(){var e,t=this,n="",i=encodeURIComponent;this.regionChanged&&(n=i("---destpub-clear-dextp---"),this.regionChanged=!1),this.messages.length?oe.POST_MESSAGE_ENABLED?(e=n+i("---destpub-combined---")+this.messages.join("%01"),this.postMessage(e),this.messages=[],this.sendingMessages=!1):(e=this.messages.shift(),this.postMessage(n+e),setTimeout(function(){t.sendMessages()},this.messageSendingInterval)):this.sendingMessages=!1},postMessage:function(e){ie.postMessage(e,this.url,this.iframe.contentWindow),this.messagesPosted.push(e)},receiveMessage:function(e){var t,n=/^---destpub-to-parent---/;"string"==typeof e&&n.test(e)&&(t=e.replace(n,"").split("|"),"canSetThirdPartyCookies"===t[0]&&(this.canSetThirdPartyCookies="true"===t[1],this.receivedThirdPartyCookiesNotification=!0,this.requestToProcess()),this.messagesReceived.push(e))},processIDCallData:function(i){(null==this.url||i.subdomain&&"nosubdomainreturned"===this.subdomain)&&("string"==typeof e._subdomain&&e._subdomain.length?this.subdomain=e._subdomain:this.subdomain=i.subdomain||"",this.url=this.getUrl()),i.ibs instanceof Array&&i.ibs.length&&(this.doAttachIframe=!0),this.readyToAttachIframe()&&(e.idSyncAttachIframeOnWindowLoad?(t.windowLoaded||"complete"===n.readyState||"loaded"===n.readyState)&&this.attachIframe():this.attachIframeASAP()),"function"==typeof e.idSyncIDCallResult?e.idSyncIDCallResult(i):this.requestToProcess(i),"function"==typeof e.idSyncAfterIDCallResult&&e.idSyncAfterIDCallResult(i)},canMakeSyncIDCall:function(t,n){return e._forceSyncIDCall||!t||n-t>oe.DAYS_BETWEEN_SYNC_ID_CALLS},attachIframeASAP:function(){function e(){t.startedAttachingIframe||(n.body?t.attachIframe():setTimeout(e,30))}var t=this;e()}}},ce={audienceManagerServer:{},audienceManagerServerSecure:{},cookieDomain:{},cookieLifetime:{},cookieName:{},doesOptInApply:{type:"boolean"},disableThirdPartyCalls:{type:"boolean"},discardTrackingServerECID:{type:"boolean"},idSyncAfterIDCallResult:{},idSyncAttachIframeOnWindowLoad:{type:"boolean"},idSyncContainerID:{},idSyncDisable3rdPartySyncing:{type:"boolean"},disableThirdPartyCookies:{type:"boolean"},idSyncDisableSyncs:{type:"boolean"},disableIdSyncs:{type:"boolean"},idSyncIDCallResult:{},idSyncSSLUseAkamai:{type:"boolean"},isCoopSafe:{type:"boolean"},isIabContext:{type:"boolean"},isOptInStorageEnabled:{type:"boolean"},loadSSL:{type:"boolean"},loadTimeout:{},marketingCloudServer:{},marketingCloudServerSecure:{},optInCookieDomain:{},optInStorageExpiry:{},overwriteCrossDomainMCIDAndAID:{type:"boolean"},preOptInApprovals:{},previousPermissions:{},resetBeforeVersion:{},sdidParamExpiry:{},serverState:{},sessionCookieName:{},secureCookie:{type:"boolean"},sameSiteCookie:{},takeTimeoutMetrics:{},trackingServer:{},trackingServerSecure:{},useLocalStorage:{type:"boolean"},whitelistIframeDomains:{},whitelistParentDomain:{}},ue={getConfigNames:function(){return Object.keys(ce)},getConfigs:function(){return ce},normalizeConfig:function(e,t){return ce[e]&&"boolean"===ce[e].type?"function"!=typeof t?t:t():t}},le=function(e){var t={};return e.on=function(e,n,i){if(!n||"function"!=typeof n)throw new Error("[ON] Callback should be a function.");t.hasOwnProperty(e)||(t[e]=[]);var r=t[e].push({callback:n,context:i})-1;return function(){t[e].splice(r,1),t[e].length||delete t[e]}},e.off=function(e,n){t.hasOwnProperty(e)&&(t[e]=t[e].filter(function(e){if(e.callback!==n)return e}))},e.publish=function(e){if(t.hasOwnProperty(e)){var n=[].slice.call(arguments,1);t[e].slice(0).forEach(function(e){e.callback.apply(e.context,n)})}},e.publish},de={PENDING:"pending",CHANGED:"changed",COMPLETE:"complete"},fe={AAM:"aam",ADCLOUD:"adcloud",ANALYTICS:"aa",CAMPAIGN:"campaign",ECID:"ecid",LIVEFYRE:"livefyre",TARGET:"target",MEDIA_ANALYTICS:"mediaaa"},pe=(S={},t(S,fe.AAM,565),t(S,fe.ECID,565),S),ge=(I={},t(I,fe.AAM,[1,10]),t(I,fe.ECID,[1,10]),I),me=["videoaa","iabConsentHash"],he=function(e){return Object.keys(e).map(function(t){return e[t]})}(fe),_e=function(){var e={};return e.callbacks=Object.create(null),e.add=function(t,n){if(!u(n))throw new Error("[callbackRegistryFactory] Make sure callback is a function or an array of functions.");e.callbacks[t]=e.callbacks[t]||[];var i=e.callbacks[t].push(n)-1;return function(){e.callbacks[t].splice(i,1)}},e.execute=function(t,n){if(e.callbacks[t]){n=void 0===n?[]:n,n=n instanceof Array?n:[n];try{for(;e.callbacks[t].length;){var i=e.callbacks[t].shift();"function"==typeof i?i.apply(null,n):i instanceof Array&&i[1].apply(i[0],n)}delete e.callbacks[t]}catch(e){}}},e.executeAll=function(t,n){(n||t&&!c(t))&&Object.keys(e.callbacks).forEach(function(n){var i=void 0!==t[n]?t[n]:"";e.execute(n,i)},e)},e.hasCallbacks=function(){return Boolean(Object.keys(e.callbacks).length)},e},Ce=function(){},Se=function(e){var t=window,n=t.console;return!!n&&"function"==typeof n[e]},Ie=function(e,t,n){return n()?function(){if(Se(e)){for(var n=arguments.length,i=new Array(n),r=0;r<n;r++)i[r]=arguments[r];console[e].apply(console,[t].concat(i))}}:Ce},ve=l,De=function(){for(var e=[],t=0;t<256;t++){for(var n=t,i=0;i<8;i++)n=1&n?3988292384^n>>>1:n>>>1;e.push(n)}return function(t,n){t=unescape(encodeURIComponent(t)),n||(n=0),n^=-1;for(var i=0;i<t.length;i++){var r=255&(n^t.charCodeAt(i));n=n>>>8^e[r]}return(n^=-1)>>>0}}(),ye=new ve("[ADOBE OPT-IN]"),be=function(t,n){return e(t)===n},Ae=function(e,t){return e instanceof Array?e:be(e,"string")?[e]:t||[]},Oe=function(e){var t=Object.keys(e);return!!t.length&&t.every(function(t){return!0===e[t]})},Me=function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return!(!e||Te(e))&&Ae(e).every(function(e){return he.indexOf(e)>-1||t&&me.indexOf(e)>-1})},ke=function(e,t){return e.reduce(function(e,n){return e[n]=t,e},{})},Ee=function(e){return JSON.parse(JSON.stringify(e))},Te=function(e){return"[object Array]"===Object.prototype.toString.call(e)&&!e.length},Le=function(e){if(we(e))return e;try{return JSON.parse(e)}catch(e){return{}}},Pe=function(e){return void 0===e||(we(e)?Me(Object.keys(e),!0):Re(e))},Re=function(e){try{var t=JSON.parse(e);return!!e&&be(e,"string")&&Me(Object.keys(t),!0)}catch(e){return!1}},we=function(e){return null!==e&&be(e,"object")&&!1===Array.isArray(e)},xe=function(){},Ne=function(e){return be(e,"function")?e():e},Fe=function(e,t){Pe(e)||ye.error("".concat(t))},je=function(e){return Object.keys(e).map(function(t){return e[t]})},Ve=function(e){return je(e).filter(function(e,t,n){return n.indexOf(e)===t})},Ue=function(e){return function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=t.command,i=t.params,r=void 0===i?{}:i,a=t.callback,o=void 0===a?xe:a
;if(!n||-1===n.indexOf("."))throw new Error("[OptIn.execute] Please provide a valid command.");try{var s=n.split("."),c=e[s[0]],u=s[1];if(!c||"function"!=typeof c[u])throw new Error("Make sure the plugin and API name exist.");var l=Object.assign(r,{callback:o});c[u].call(c,l)}catch(e){ye.error("[execute] Something went wrong: "+e.message)}}};f.prototype=Object.create(Error.prototype),f.prototype.constructor=f;var He="fetchPermissions",Be="[OptIn#registerPlugin] Plugin is invalid.";p.Categories=fe,p.TimeoutError=f;var Ge=Object.freeze({OptIn:p,IabPlugin:_}),Ye=function(e,t){e.publishDestinations=function(n){var i=arguments[1],r=arguments[2];try{r="function"==typeof r?r:n.callback}catch(e){r=function(){}}var a=t;if(!a.readyToAttachIframePreliminary())return void r({error:"The destination publishing iframe is disabled in the Visitor library."});if("string"==typeof n){if(!n.length)return void r({error:"subdomain is not a populated string."});if(!(i instanceof Array&&i.length))return void r({error:"messages is not a populated array."});var o=!1;if(i.forEach(function(e){"string"==typeof e&&e.length&&(a.addMessage(e),o=!0)}),!o)return void r({error:"None of the messages are populated strings."})}else{if(!U.isObject(n))return void r({error:"Invalid parameters passed."});var s=n;if("string"!=typeof(n=s.subdomain)||!n.length)return void r({error:"config.subdomain is not a populated string."});var c=s.urlDestinations;if(!(c instanceof Array&&c.length))return void r({error:"config.urlDestinations is not a populated array."});var u=[];c.forEach(function(e){U.isObject(e)&&(e.hideReferrer?e.message&&a.addMessage(e.message):u.push(e))});!function e(){u.length&&setTimeout(function(){var t=new Image,n=u.shift();t.src=n.url,a.onPageDestinationsFired.push(n),e()},100)}()}a.iframe?(r({message:"The destination publishing iframe is already attached and loaded."}),a.requestToProcess()):!e.subdomain&&e._getField("MCMID")?(a.subdomain=n,a.doAttachIframe=!0,a.url=a.getUrl(),a.readyToAttachIframe()?(a.iframeLoadedCallbacks.push(function(e){r({message:"Attempted to attach and load the destination publishing iframe through this API call. Result: "+(e.message||"no result")})}),a.attachIframe()):r({error:"Encountered a problem in attempting to attach and load the destination publishing iframe through this API call."})):a.iframeLoadedCallbacks.push(function(e){r({message:"Attempted to attach and load the destination publishing iframe through normal Visitor API processing. Result: "+(e.message||"no result")})})}},qe=function e(t){function n(e,t){return e>>>t|e<<32-t}for(var i,r,a=Math.pow,o=a(2,32),s="",c=[],u=8*t.length,l=e.h=e.h||[],d=e.k=e.k||[],f=d.length,p={},g=2;f<64;g++)if(!p[g]){for(i=0;i<313;i+=g)p[i]=g;l[f]=a(g,.5)*o|0,d[f++]=a(g,1/3)*o|0}for(t+="";t.length%64-56;)t+="\0";for(i=0;i<t.length;i++){if((r=t.charCodeAt(i))>>8)return;c[i>>2]|=r<<(3-i)%4*8}for(c[c.length]=u/o|0,c[c.length]=u,r=0;r<c.length;){var m=c.slice(r,r+=16),h=l;for(l=l.slice(0,8),i=0;i<64;i++){var _=m[i-15],C=m[i-2],S=l[0],I=l[4],v=l[7]+(n(I,6)^n(I,11)^n(I,25))+(I&l[5]^~I&l[6])+d[i]+(m[i]=i<16?m[i]:m[i-16]+(n(_,7)^n(_,18)^_>>>3)+m[i-7]+(n(C,17)^n(C,19)^C>>>10)|0);l=[v+((n(S,2)^n(S,13)^n(S,22))+(S&l[1]^S&l[2]^l[1]&l[2]))|0].concat(l),l[4]=l[4]+v|0}for(i=0;i<8;i++)l[i]=l[i]+h[i]|0}for(i=0;i<8;i++)for(r=3;r+1;r--){var D=l[i]>>8*r&255;s+=(D<16?0:"")+D.toString(16)}return s},Xe=function(e,t){return"SHA-256"!==t&&"SHA256"!==t&&"sha256"!==t&&"sha-256"!==t||(e=qe(e)),e},We=function(e){return String(e).trim().toLowerCase()},Ke=Ge.OptIn;U.defineGlobalNamespace(),window.adobe.OptInCategories=Ke.Categories;var Je=function(t,n,i){function r(){S._customerIDsHashChanged=!1}function a(e){var t=e;return function(e){var n=e||A.location.href;try{var i=S._extractParamFromUri(n,t);if(i)return q.parsePipeDelimetedKeyValues(i)}catch(e){}}}function o(e){function t(e,t,n){e&&e.match(oe.VALID_VISITOR_ID_REGEX)&&(n===T&&(b=!0),t(e))}t(e[T],S.setMarketingCloudVisitorID,T),S._setFieldExpire(N,-1),t(e[w],S.setAnalyticsVisitorID)}function s(e){e=e||{},S._supplementalDataIDCurrent=e.supplementalDataIDCurrent||"",S._supplementalDataIDCurrentConsumed=e.supplementalDataIDCurrentConsumed||{},S._supplementalDataIDLast=e.supplementalDataIDLast||"",S._supplementalDataIDLastConsumed=e.supplementalDataIDLastConsumed||{}}function c(e){function t(e,t,n){return n=n?n+="|":n,n+=e+"="+encodeURIComponent(t)}function n(e,n){var i=n[0],r=n[1];return null!=r&&r!==F&&(e=t(i,r,e)),e}var i=e.reduce(n,"");return function(e){var t=q.getTimestampInSeconds();return e=e?e+="|":e,e+="TS="+t}(i)}function u(e){var t=e.minutesToLive,n="";return(S.idSyncDisableSyncs||S.disableIdSyncs)&&(n=n||"Error: id syncs have been disabled"),"string"==typeof e.dpid&&e.dpid.length||(n=n||"Error: config.dpid is empty"),"string"==typeof e.url&&e.url.length||(n=n||"Error: config.url is empty"),void 0===t?t=20160:(t=parseInt(t,10),(isNaN(t)||t<=0)&&(n=n||"Error: config.minutesToLive needs to be a positive number")),{error:n,ttl:t}}function l(){return!!S.configs.doesOptInApply&&!(I.optIn.isComplete&&d())}function d(){return S.configs.doesOptInApply&&S.configs.isIabContext?I.optIn.isApproved(I.optIn.Categories.ECID)&&y:I.optIn.isApproved(I.optIn.Categories.ECID)}function f(){[["getMarketingCloudVisitorID"],["setCustomerIDs",void 0],["syncIdentity",void 0],["getAnalyticsVisitorID"],["getAudienceManagerLocationHint"],["getLocationHint"],["getAudienceManagerBlob"]].forEach(function(e){var t=e[0],n=2===e.length?e[1]:"",i=S[t];S[t]=function(e){return d()&&S.isAllowed()?i.apply(S,arguments):("function"==typeof e&&S._callCallback(e,[n]),n)}})}function p(){var e=S._getAudienceManagerURLData(),t=e.url;return S._loadData(E,t,null,e)}function g(e,t){if(y=!0,e)throw new Error("[IAB plugin] : "+e);t&&t.gdprApplies&&(v=t.consentString,D=t.hasConsentChangedSinceLastCmpPull?1:0),p(),_()}function m(e,t){if(y=!0,e)throw new Error("[IAB plugin] : "+e);t.gdprApplies&&(v=t.consentString,D=t.hasConsentChangedSinceLastCmpPull?1:0),S.init(),_()}function h(){I.optIn.isComplete&&(I.optIn.isApproved(I.optIn.Categories.ECID)?S.configs.isIabContext?I.optIn.execute({command:"iabPlugin.fetchConsentData",callback:m}):(S.init(),_()):S.configs.isIabContext?I.optIn.execute({command:"iabPlugin.fetchConsentData",callback:g}):(f(),_()))}function _(){I.optIn.off("complete",h)}if(!i||i.split("").reverse().join("")!==t)throw new Error("Please use `Visitor.getInstance` to instantiate Visitor.");var S=this,I=window.adobe,v="",D=0,y=!1,b=!1;S.version="5.3.0";var A=C,O=A.Visitor;O.version=S.version,O.AuthState=L.AUTH_STATE,O.OptOut=L.OPT_OUT,A.s_c_in||(A.s_c_il=[],A.s_c_in=0),S._c="Visitor",S._il=A.s_c_il,S._in=A.s_c_in,S._il[S._in]=S,A.s_c_in++,S._instanceType="regular",S._log={requests:[]},S.marketingCloudOrgID=t,S.cookieName="AMCV_"+t,S.sessionCookieName="AMCVS_"+t;var M={};n&&n.secureCookie&&n.sameSiteCookie&&(M={sameSite:n.sameSiteCookie,secure:n.secureCookie}),S.cookieDomain=S.useLocalStorage?"":ee(null,M),S.loadSSL=!0,S.loadTimeout=3e4,S.CORSErrors=[],S.marketingCloudServer=S.audienceManagerServer="dpm.demdex.net",S.sdidParamExpiry=30;var k=null,E="MC",T="MCMID",P="MCIDTS",R="A",w="MCAID",x="AAM",N="MCAAMB",F="NONE",j=function(e){return!Object.prototype[e]},V=ae(S);S.FIELDS=L.FIELDS,S.cookieRead=function(e){return S.useLocalStorage?e===S.sessionCookieName?sessionStorage.getItem(e):localStorage.getItem(e):Z.get(e)},S.cookieWrite=function(e,t,n){var i=""+t;if(S.useLocalStorage)return e===S.sessionCookieName?sessionStorage.setItem(e,i):localStorage.setItem(e,i);var r=S.cookieLifetime?(""+S.cookieLifetime).toUpperCase():"",a={expires:n,domain:S.cookieDomain,cookieLifetime:r};return S.configs&&S.configs.secureCookie&&"https:"===location.protocol&&(a.secure=!0),S.configs&&S.configs.sameSiteCookie&&"https:"===location.protocol&&(a.sameSite=L.SAME_SITE_VALUES[S.configs.sameSiteCookie.toUpperCase()]||"Lax"),Z.set(e,i,a)},S.removeCookie=function(e){if(S.useLocalStorage)return e===S.sessionCookieName?sessionStorage.removeItem(e):localStorage.removeItem(e);var t={domain:S.cookieDomain};return S.configs&&S.configs.secureCookie&&"https:"===location.protocol&&(t.secure=!0),S.configs&&S.configs.sameSiteCookie&&"https:"===location.protocol&&(t.sameSite=L.SAME_SITE_VALUES[S.configs.sameSiteCookie.toUpperCase()]||"Lax"),Z.remove(e,t)},S.resetState=function(e){e?S._mergeServerState(e):s()},S._isAllowedDone=!1,S._isAllowedFlag=!1,S.isAllowed=function(){return S._isAllowedDone||(S._isAllowedDone=!0,(S.cookieRead(S.cookieName)||S.cookieWrite(S.cookieName,"T",1))&&(S._isAllowedFlag=!0)),"T"===S.cookieRead(S.cookieName)&&S.removeCookie(S.cookieName),S._isAllowedFlag},S.setMarketingCloudVisitorID=function(e){S._setMarketingCloudFields(e)},S._use1stPartyMarketingCloudServer=!1,S.getMarketingCloudVisitorID=function(e,t){S.marketingCloudServer&&S.marketingCloudServer.indexOf(".demdex.net")<0&&(S._use1stPartyMarketingCloudServer=!0);var n=S._getAudienceManagerURLData("_setMarketingCloudFields"),i=n.url;return S._getRemoteField(T,i,e,t,n)};var H=function(e,t){var n={};S.getMarketingCloudVisitorID(function(){t.forEach(function(e){n[e]=S._getField(e,!0)}),-1!==t.indexOf("MCOPTOUT")?S.isOptedOut(function(t){n.MCOPTOUT=t,e(n)},null,!0):e(n)},!0)};S.getVisitorValues=function(e,t){var n={MCMID:{fn:S.getMarketingCloudVisitorID,args:[!0],context:S},MCOPTOUT:{fn:S.isOptedOut,args:[void 0,!0],context:S},MCAID:{fn:S.getAnalyticsVisitorID,args:[!0],context:S},MCAAMLH:{fn:S.getAudienceManagerLocationHint,args:[!0],context:S},MCAAMB:{fn:S.getAudienceManagerBlob,args:[!0],context:S}},i=t&&t.length?U.pluck(n,t):n;t&&-1===t.indexOf("MCAID")?H(e,t):$(i,e)},S._currentCustomerIDs={},S._customerIDsHashChanged=!1,S._newCustomerIDsHash="",S.setCustomerIDs=function(t,n){if(!S.isOptedOut()&&t){if(!U.isObject(t)||U.isObjectEmpty(t))return!1;S._readVisitor();var i,a,o,s;for(i in t)if(j(i)&&(S._currentCustomerIDs.dataSources=S._currentCustomerIDs.dataSources||{},a=t[i],n=a.hasOwnProperty("hashType")?a.hashType:n,a))if("object"===e(a)){var c={};if(a.id){if(n){if(!(s=Xe(We(a.id),n)))return;a.id=s,c.hashType=n}c.id=a.id}void 0!=a.authState&&(c.authState=a.authState),S._currentCustomerIDs.dataSources[i]=c}else if(n){if(!(s=Xe(We(a),n)))return;S._currentCustomerIDs.dataSources[i]={id:s,hashType:n}}else S._currentCustomerIDs.dataSources[i]={id:a};var u=S.getCustomerIDs(!0),l=S._getField("MCCIDH"),d="";l||(l=0);for(o in u){var f=u[o];if(!U.isObjectEmpty(f))for(i in f)j(i)&&(a=f[i],d+=(d?"|":"")+i+"|"+(a.id?a.id:"")+(a.authState?a.authState:""))}S._newCustomerIDsHash=String(S._hash(d)),S._newCustomerIDsHash!==l&&(S._customerIDsHashChanged=!0,S._mapCustomerIDs(r))}},S.syncIdentity=function(t,n){if(!S.isOptedOut()&&t){if(!U.isObject(t)||U.isObjectEmpty(t))return!1;S._readVisitor();var i,a,o,s,c;for(i in t)if(j(i)&&(S._currentCustomerIDs.nameSpaces=S._currentCustomerIDs.nameSpaces||{},a=t[i],n=a.hasOwnProperty("hashType")?a.hashType:n,a&&"object"===e(a))){var u={};if(a.id){if(n){if(!(o=Xe(We(a.id),n)))return;a.id=o,u.hashType=n}u.id=a.id}void 0!=a.authState&&(u.authState=a.authState),a.dataSource&&(S._currentCustomerIDs.dataSources=S._currentCustomerIDs.dataSources||{},s=a.dataSource,S._currentCustomerIDs.dataSources[s]=u),S._currentCustomerIDs.nameSpaces[i]=u}var l=S.getCustomerIDs(!0),d=S._getField("MCCIDH"),f="";d||(d="0");for(c in l){var p=l[c];if(!U.isObjectEmpty(p))for(i in p)j(i)&&(a=p[i],f+=(f?"|":"")+i+"|"+(a.id?a.id:"")+(a.authState?a.authState:""))}S._newCustomerIDsHash=String(S._hash(f)),S._newCustomerIDsHash!==d&&(S._customerIDsHashChanged=!0,S._mapCustomerIDs(r))}},S.getCustomerIDs=function(e){S._readVisitor();var t,n,i={dataSources:{},nameSpaces:{}},r=S._currentCustomerIDs.dataSources;for(t in r)j(t)&&(n=r[t],n.id&&(i.dataSources[t]||(i.dataSources[t]={}),i.dataSources[t].id=n.id,void 0!=n.authState?i.dataSources[t].authState=n.authState:i.dataSources[t].authState=O.AuthState.UNKNOWN,n.hashType&&(i.dataSources[t].hashType=n.hashType)));var a=S._currentCustomerIDs.nameSpaces;for(t in a)j(t)&&(n=a[t],n.id&&(i.nameSpaces[t]||(i.nameSpaces[t]={}),i.nameSpaces[t].id=n.id,void 0!=n.authState?i.nameSpaces[t].authState=n.authState:i.nameSpaces[t].authState=O.AuthState.UNKNOWN,n.hashType&&(i.nameSpaces[t].hashType=n.hashType)));return e?i:i.dataSources},S.setAnalyticsVisitorID=function(e){S._setAnalyticsFields(e)},S.getAnalyticsVisitorID=function(e,t,n){if(!q.isTrackingServerPopulated()&&!n)return S._callCallback(e,[""]),"";var i="";if(n||(i=S.getMarketingCloudVisitorID(function(t){S.getAnalyticsVisitorID(e,!0)})),i||n){var r=n?S.marketingCloudServer:S.trackingServer,a="";S.loadSSL&&(n?S.marketingCloudServerSecure&&(r=S.marketingCloudServerSecure):S.trackingServerSecure&&(r=S.trackingServerSecure));var o={};if(r){var s="http"+(S.loadSSL?"s":"")+"://"+r+"/id",c="d_visid_ver="+S.version+"&mcorgid="+encodeURIComponent(S.marketingCloudOrgID)+(i?"&mid="+encodeURIComponent(i):"")+(S.idSyncDisable3rdPartySyncing||S.disableThirdPartyCookies?"&d_coppa=true":""),u=["s_c_il",S._in,"_set"+(n?"MarketingCloud":"Analytics")+"Fields"];a=s+"?"+c+"&callback=s_c_il%5B"+S._in+"%5D._set"+(n?"MarketingCloud":"Analytics")+"Fields",o.corsUrl=s+"?"+c,o.callback=u}return o.url=a,S._getRemoteField(n?T:w,a,e,t,o)}return""},S.getAudienceManagerLocationHint=function(e,t){if(S.getMarketingCloudVisitorID(function(t){S.getAudienceManagerLocationHint(e,!0)})){var n=S._getField(w);if(!n&&q.isTrackingServerPopulated()&&(n=S.getAnalyticsVisitorID(function(t){S.getAudienceManagerLocationHint(e,!0)})),n||!q.isTrackingServerPopulated()){var i=S._getAudienceManagerURLData(),r=i.url;return S._getRemoteField("MCAAMLH",r,e,t,i)}}return""},S.getLocationHint=S.getAudienceManagerLocationHint,S.getAudienceManagerBlob=function(e,t){if(S.getMarketingCloudVisitorID(function(t){S.getAudienceManagerBlob(e,!0)})){var n=S._getField(w);if(!n&&q.isTrackingServerPopulated()&&(n=S.getAnalyticsVisitorID(function(t){S.getAudienceManagerBlob(e,!0)})),n||!q.isTrackingServerPopulated()){var i=S._getAudienceManagerURLData(),r=i.url;return S._customerIDsHashChanged&&S._setFieldExpire(N,-1),S._getRemoteField(N,r,e,t,i)}}return""},S._supplementalDataIDCurrent="",S._supplementalDataIDCurrentConsumed={},S._supplementalDataIDLast="",S._supplementalDataIDLastConsumed={},S.getSupplementalDataID=function(e,t){S._supplementalDataIDCurrent||t||(S._supplementalDataIDCurrent=S._generateID(1));var n=S._supplementalDataIDCurrent;return S._supplementalDataIDLast&&!S._supplementalDataIDLastConsumed[e]?(n=S._supplementalDataIDLast,S._supplementalDataIDLastConsumed[e]=!0):n&&(S._supplementalDataIDCurrentConsumed[e]&&(S._supplementalDataIDLast=S._supplementalDataIDCurrent,S._supplementalDataIDLastConsumed=S._supplementalDataIDCurrentConsumed,S._supplementalDataIDCurrent=n=t?"":S._generateID(1),S._supplementalDataIDCurrentConsumed={}),n&&(S._supplementalDataIDCurrentConsumed[e]=!0)),n};var B=!1;S._liberatedOptOut=null,S.getOptOut=function(e,t){var n=S._getAudienceManagerURLData("_setMarketingCloudFields"),i=n.url;if(d())return S._getRemoteField("MCOPTOUT",i,e,t,n);if(S._registerCallback("liberatedOptOut",e),null!==S._liberatedOptOut)return S._callAllCallbacks("liberatedOptOut",[S._liberatedOptOut]),B=!1,S._liberatedOptOut;if(B)return null;B=!0;var r="liberatedGetOptOut";return n.corsUrl=n.corsUrl.replace(/\.demdex\.net\/id\?/,".demdex.net/optOutStatus?"),n.callback=[r],C[r]=function(e){if(e===Object(e)){var t,n,i=U.parseOptOut(e,t,F);t=i.optOut,n=1e3*i.d_ottl,S._liberatedOptOut=t,setTimeout(function(){S._liberatedOptOut=null},n)}S._callAllCallbacks("liberatedOptOut",[t]),B=!1},V.fireCORS(n),null},S.isOptedOut=function(e,t,n){t||(t=O.OptOut.GLOBAL);var i=S.getOptOut(function(n){var i=n===O.OptOut.GLOBAL||n.indexOf(t)>=0;S._callCallback(e,[i])},n);return i?i===O.OptOut.GLOBAL||i.indexOf(t)>=0:null};var G={subscribed:!1,callbacks:[]};S.onReceiveEcid=function(e){if(d())return S.getMarketingCloudVisitorID(e,!0);G.subscribed=!0,e&&"function"==typeof e&&G.callbacks.push(e)},S._fields=null,S._fieldsExpired=null,S._hash=function(e){var t,n,i=0;if(e)for(t=0;t<e.length;t++)n=e.charCodeAt(t),i=(i<<5)-i+n,i&=i;return i},S._generateID=re,S._generateLocalMID=function(){var e=S._generateID(0);return W.isClientSideMarketingCloudVisitorID=!0,e},S._callbackList=null,S._callCallback=function(e,t){try{"function"==typeof e?e.apply(A,t):e[1].apply(e[0],t)}catch(e){}},S._registerCallback=function(e,t){t&&(null==S._callbackList&&(S._callbackList={}),void 0==S._callbackList[e]&&(S._callbackList[e]=[]),S._callbackList[e].push(t))},S._callAllCallbacks=function(e,t){if(null!=S._callbackList){var n=S._callbackList[e];if(n)for(;n.length>0;)S._callCallback(n.shift(),t)}},S._addQuerystringParam=function(e,t,n,i){var r=encodeURIComponent(t)+"="+encodeURIComponent(n),a=q.parseHash(e),o=q.hashlessUrl(e);if(-1===o.indexOf("?"))return o+"?"+r+a;var s=o.split("?"),c=s[0]+"?",u=s[1];return c+q.addQueryParamAtLocation(u,r,i)+a},S._extractParamFromUri=function(e,t){var n=new RegExp("[\\?&#]"+t+"=([^&#]*)"),i=n.exec(e);if(i&&i.length)return decodeURIComponent(i[1])},S._parseAdobeMcFromUrl=a(oe.ADOBE_MC),S._parseAdobeMcSdidFromUrl=a(oe.ADOBE_MC_SDID),S._attemptToPopulateSdidFromUrl=function(e){var n=S._parseAdobeMcSdidFromUrl(e),i=1e9;n&&n.TS&&(i=q.getTimestampInSeconds()-n.TS),n&&n.SDID&&n.MCORGID===t&&i<S.sdidParamExpiry&&(S._supplementalDataIDCurrent=n.SDID,S._supplementalDataIDCurrentConsumed.SDID_URL_PARAM=!0)},S._attemptToPopulateIdsFromUrl=function(){var e=S._parseAdobeMcFromUrl();if(e&&e.TS){var n=q.getTimestampInSeconds(),i=n-e.TS;if(Math.floor(i/60)>oe.ADOBE_MC_TTL_IN_MIN||e.MCORGID!==t)return;o(e)}},S._mergeServerState=function(e){if(e)try{if(e=function(e){return q.isObject(e)?e:JSON.parse(e)}(e),e[S.marketingCloudOrgID]){var t=e[S.marketingCloudOrgID];!function(e){q.isObject(e)&&S.setCustomerIDs(e)}(t.customerIDs),s(t.sdid)}}catch(e){throw new Error("`serverState` has an invalid format.")}},S._timeout=null,S._loadData=function(e,t,n,i){t=S._addQuerystringParam(t,"d_fieldgroup",e,1),i.url=S._addQuerystringParam(i.url,"d_fieldgroup",e,1),i.corsUrl=S._addQuerystringParam(i.corsUrl,"d_fieldgroup",e,1),W.fieldGroupObj[e]=!0,i===Object(i)&&i.corsUrl&&"XMLHttpRequest"===V.corsMetadata.corsType&&V.fireCORS(i,n,e)},S._clearTimeout=function(e){null!=S._timeout&&S._timeout[e]&&(clearTimeout(S._timeout[e]),S._timeout[e]=0)},S._settingsDigest=0,S._getSettingsDigest=function(){if(!S._settingsDigest){var e=S.version;S.audienceManagerServer&&(e+="|"+S.audienceManagerServer),S.audienceManagerServerSecure&&(e+="|"+S.audienceManagerServerSecure),S._settingsDigest=S._hash(e)}return S._settingsDigest},S._readVisitorDone=!1,S._readVisitor=function(){if(!S._readVisitorDone){S._readVisitorDone=!0;var e,t,n,i,r,a,o=S._getSettingsDigest(),s=!1,c=S.cookieRead(S.cookieName),u=new Date;if(c||b||S.discardTrackingServerECID||(c=S.cookieRead(oe.FIRST_PARTY_SERVER_COOKIE)),null==S._fields&&(S._fields={}),c&&"T"!==c)for(c=c.split("|"),c[0].match(/^[\-0-9]+$/)&&(parseInt(c[0],10)!==o&&(s=!0),c.shift()),c.length%2==1&&c.pop(),e=0;e<c.length;e+=2)t=c[e].split("-"),n=t[0],i=c[e+1],t.length>1?(r=parseInt(t[1],10),a=t[1].indexOf("s")>0):(r=0,a=!1),s&&("MCCIDH"===n&&(i=""),r>0&&(r=u.getTime()/1e3-60)),n&&i&&(S._setField(n,i,1),r>0&&(S._fields["expire"+n]=r+(a?"s":""),(u.getTime()>=1e3*r||a&&!S.cookieRead(S.sessionCookieName))&&(S._fieldsExpired||(S._fieldsExpired={}),S._fieldsExpired[n]=!0)));!S._getField(w)&&q.isTrackingServerPopulated()&&(c=S.cookieRead("s_vi"))&&(c=c.split("|"),c.length>1&&c[0].indexOf("v1")>=0&&(i=c[1],e=i.indexOf("["),e>=0&&(i=i.substring(0,e)),i&&i.match(oe.VALID_VISITOR_ID_REGEX)&&S._setField(w,i)))}},S._appendVersionTo=function(e){var t="vVersion|"+S.version,n=e?S._getCookieVersion(e):null;return n?te.areVersionsDifferent(n,S.version)&&(e=e.replace(oe.VERSION_REGEX,t)):e+=(e?"|":"")+t,e},S._writeVisitor=function(){var e,t,n=S._getSettingsDigest();for(e in S._fields)j(e)&&S._fields[e]&&"expire"!==e.substring(0,6)&&(t=S._fields[e],n+=(n?"|":"")+e+(S._fields["expire"+e]?"-"+S._fields["expire"+e]:"")+"|"+t);n=S._appendVersionTo(n),S.cookieWrite(S.cookieName,n,1)},S._getField=function(e,t){return null==S._fields||!t&&S._fieldsExpired&&S._fieldsExpired[e]?null:S._fields[e]},S._setField=function(e,t,n){null==S._fields&&(S._fields={}),S._fields[e]=t,n||S._writeVisitor()},S._getFieldList=function(e,t){var n=S._getField(e,t);return n?n.split("*"):null},S._setFieldList=function(e,t,n){S._setField(e,t?t.join("*"):"",n)},S._getFieldMap=function(e,t){var n=S._getFieldList(e,t);if(n){var i,r={};for(i=0;i<n.length;i+=2)r[n[i]]=n[i+1];return r}return null},S._setFieldMap=function(e,t,n){var i,r=null;if(t){r=[];for(i in t)j(i)&&(r.push(i),r.push(t[i]))}S._setFieldList(e,r,n)},S._setFieldExpire=function(e,t,n){var i=new Date;i.setTime(i.getTime()+1e3*t),null==S._fields&&(S._fields={}),S._fields["expire"+e]=Math.floor(i.getTime()/1e3)+(n?"s":""),t<0?(S._fieldsExpired||(S._fieldsExpired={}),S._fieldsExpired[e]=!0):S._fieldsExpired&&(S._fieldsExpired[e]=!1),n&&(S.cookieRead(S.sessionCookieName)||S.cookieWrite(S.sessionCookieName,"1"))},S._findVisitorID=function(t){return t&&("object"===e(t)&&(t=t.d_mid?t.d_mid:t.visitorID?t.visitorID:t.id?t.id:t.uuid?t.uuid:""+t),t&&"NOTARGET"===(t=t.toUpperCase())&&(t=F),t&&(t===F||t.match(oe.VALID_VISITOR_ID_REGEX))||(t="")),t},S._setFields=function(t,n){if(S._clearTimeout(t),null!=S._loading&&(S._loading[t]=!1),W.fieldGroupObj[t]&&W.setState(t,!1),t===E){!0!==W.isClientSideMarketingCloudVisitorID&&(W.isClientSideMarketingCloudVisitorID=!1);var i=S._getField(T);if(!i||S.overwriteCrossDomainMCIDAndAID){if(!(i="object"===e(n)&&n.mid?n.mid:S._findVisitorID(n))){if(S._use1stPartyMarketingCloudServer&&!S.tried1stPartyMarketingCloudServer)return S.tried1stPartyMarketingCloudServer=!0,void S.getAnalyticsVisitorID(null,!1,!0);i=S._generateLocalMID()}S._setField(T,i)}i&&i!==F||(i=""),"object"===e(n)&&((n.d_region||n.dcs_region||n.d_blob||n.blob)&&S._setFields(x,n),S._use1stPartyMarketingCloudServer&&n.mid&&S._setFields(R,{id:n.id})),S._callAllCallbacks(T,[i])}if(t===x&&"object"===e(n)){var r=604800;void 0!=n.id_sync_ttl&&n.id_sync_ttl&&(r=parseInt(n.id_sync_ttl,10));var a=X.getRegionAndCheckIfChanged(n,r);S._callAllCallbacks("MCAAMLH",[a]);var o=S._getField(N);(n.d_blob||n.blob)&&(o=n.d_blob,o||(o=n.blob),S._setFieldExpire(N,r),S._setField(N,o)),o||(o=""),S._callAllCallbacks(N,[o]),!n.error_msg&&S._newCustomerIDsHash&&S._setField("MCCIDH",S._newCustomerIDsHash)}if(t===R){var s=S._getField(w);s&&!S.overwriteCrossDomainMCIDAndAID||(s=S._findVisitorID(n),s?s!==F&&S._setFieldExpire(N,-1):s=F,S._setField(w,s)),s&&s!==F||(s=""),S._callAllCallbacks(w,[s])}if(S.idSyncDisableSyncs||S.disableIdSyncs)X.idCallNotProcesssed=!0;else{X.idCallNotProcesssed=!1;var c={};c.ibs=n.ibs,c.subdomain=n.subdomain,X.processIDCallData(c)}if(n===Object(n)){var u,l;d()&&S.isAllowed()&&(u=S._getField("MCOPTOUT"));var f=U.parseOptOut(n,u,F);u=f.optOut,l=f.d_ottl,S._setFieldExpire("MCOPTOUT",l,!0),S._setField("MCOPTOUT",u),S._callAllCallbacks("MCOPTOUT",[u])}},S._loading=null,S._getRemoteField=function(e,t,n,i,r){var a,o="",s=q.isFirstPartyAnalyticsVisitorIDCall(e),c={MCAAMLH:!0,MCAAMB:!0};if(d()&&S.isAllowed()){S._readVisitor(),o=S._getField(e,!0===c[e]);if(function(){return(!o||S._fieldsExpired&&S._fieldsExpired[e])&&(!S.disableThirdPartyCalls||s)}()){if(e===T||"MCOPTOUT"===e?a=E:"MCAAMLH"===e||e===N?a=x:e===w&&(a=R),a)return!t||null!=S._loading&&S._loading[a]||(null==S._loading&&(S._loading={}),S._loading[a]=!0,a===x&&(D=0),S._loadData(a,t,function(t){if(!S._getField(e)){t&&W.setState(a,!0);var n="";e===T?n=S._generateLocalMID():a===x&&(n={error_msg:"timeout"}),S._setFields(a,n)}},r)),S._registerCallback(e,n),o||(t||S._setFields(a,{id:F}),"")}else o||(e===T?(S._registerCallback(e,n),o=S._generateLocalMID(),S.setMarketingCloudVisitorID(o)):e===w?(S._registerCallback(e,n),o="",S.setAnalyticsVisitorID(o)):(o="",i=!0))}return e!==T&&e!==w||o!==F||(o="",i=!0),n&&i&&S._callCallback(n,[o]),e===T&&G.subscribed&&(G.callbacks&&G.callbacks.length&&G.callbacks.forEach(function(e){S._callCallback(e,[o])}),G.subscribed=!1,G.callbacks.length=0),o},S._setMarketingCloudFields=function(e){S._readVisitor(),S._setFields(E,e)},S._mapCustomerIDs=function(e){S.getAudienceManagerBlob(e,!0)},S._setAnalyticsFields=function(e){S._readVisitor(),S._setFields(R,e)},S._setAudienceManagerFields=function(e){S._readVisitor(),S._setFields(x,e)},S._getAudienceManagerURLData=function(e){var t=S.audienceManagerServer,n="",i=S._getField(T),r=S._getField(N,!0),a=S._getField(w),o=a&&a!==F?"&d_cid_ic=AVID%01"+encodeURIComponent(a):"";if(S.loadSSL&&S.audienceManagerServerSecure&&(t=S.audienceManagerServerSecure),t){var s,c,u,l=S.getCustomerIDs(!0);if(l)for(c in l){var d=l[c];if(!U.isObjectEmpty(d)){var f="nameSpaces"===c?"&d_cid_ns=":"&d_cid_ic=";for(s in d)j(s)&&(u=d[s],o+=f+encodeURIComponent(s)+"%01"+encodeURIComponent(u.id?u.id:"")+(u.authState?"%01"+u.authState:""))}}e||(e="_setAudienceManagerFields");var p="http"+(S.loadSSL?"s":"")+"://"+t+"/id",g="d_visid_ver="+S.version+(v&&-1!==p.indexOf("demdex.net")?"&gdpr=1&gdpr_consent="+v:"")+(D&&-1!==p.indexOf("demdex.net")?"&d_cf="+D:"")+"&d_rtbd=json&d_ver=2"+(!i&&S._use1stPartyMarketingCloudServer?"&d_verify=1":"")+"&d_orgid="+encodeURIComponent(S.marketingCloudOrgID)+"&d_nsid="+(S.idSyncContainerID||0)+(i?"&d_mid="+encodeURIComponent(i):"")+(S.idSyncDisable3rdPartySyncing||S.disableThirdPartyCookies?"&d_coppa=true":"")+(!0===k?"&d_coop_safe=1":!1===k?"&d_coop_unsafe=1":"")+(r?"&d_blob="+encodeURIComponent(r):"")+o,m=["s_c_il",S._in,e];return n=p+"?"+g+"&d_cb=s_c_il%5B"+S._in+"%5D."+e,{url:n,corsUrl:p+"?"+g,callback:m}}return{url:n}},S.appendVisitorIDsTo=function(e){try{var t=[[T,S._getField(T)],[w,S._getField(w)],["MCORGID",S.marketingCloudOrgID]];return S._addQuerystringParam(e,oe.ADOBE_MC,c(t))}catch(t){return e}},S.appendSupplementalDataIDTo=function(e,t){if(!(t=t||S.getSupplementalDataID(q.generateRandomString(),!0)))return e;try{var n=c([["SDID",t],["MCORGID",S.marketingCloudOrgID]]);return S._addQuerystringParam(e,oe.ADOBE_MC_SDID,n)}catch(t){return e}};var q={parseHash:function(e){var t=e.indexOf("#");return t>0?e.substr(t):""},hashlessUrl:function(e){var t=e.indexOf("#");return t>0?e.substr(0,t):e},addQueryParamAtLocation:function(e,t,n){var i=e.split("&");return n=null!=n?n:i.length,i.splice(n,0,t),i.join("&")},isFirstPartyAnalyticsVisitorIDCall:function(e,t,n){if(e!==w)return!1;var i;return t||(t=S.trackingServer),n||(n=S.trackingServerSecure),!("string"!=typeof(i=S.loadSSL?n:t)||!i.length)&&(i.indexOf("2o7.net")<0&&i.indexOf("omtrdc.net")<0)},isObject:function(e){return Boolean(e&&e===Object(e))},removeCookie:function(e){Z.remove(e,{domain:S.cookieDomain})},isTrackingServerPopulated:function(){return!!S.trackingServer||!!S.trackingServerSecure},getTimestampInSeconds:function(){return Math.round((new Date).getTime()/1e3)},parsePipeDelimetedKeyValues:function(e){return e.split("|").reduce(function(e,t){var n=t.split("=");return e[n[0]]=decodeURIComponent(n[1]),e},{})},generateRandomString:function(e){e=e||5;for(var t="",n="abcdefghijklmnopqrstuvwxyz0123456789";e--;)t+=n[Math.floor(Math.random()*n.length)];return t},normalizeBoolean:function(e){return"true"===e||"false"!==e&&e},parseBoolean:function(e){return"true"===e||"false"!==e&&null},replaceMethodsWithFunction:function(e,t){for(var n in e)e.hasOwnProperty(n)&&"function"==typeof e[n]&&(e[n]=t);return e}};S._helpers=q;var X=se(S,O);S._destinationPublishing=X,S.timeoutMetricsLog=[];var W={isClientSideMarketingCloudVisitorID:null,MCIDCallTimedOut:null,AnalyticsIDCallTimedOut:null,AAMIDCallTimedOut:null,fieldGroupObj:{},setState:function(e,t){switch(e){case E:!1===t?!0!==this.MCIDCallTimedOut&&(this.MCIDCallTimedOut=!1):this.MCIDCallTimedOut=t;break;case R:!1===t?!0!==this.AnalyticsIDCallTimedOut&&(this.AnalyticsIDCallTimedOut=!1):this.AnalyticsIDCallTimedOut=t;break;case x:!1===t?!0!==this.AAMIDCallTimedOut&&(this.AAMIDCallTimedOut=!1):this.AAMIDCallTimedOut=t}}};S.isClientSideMarketingCloudVisitorID=function(){return W.isClientSideMarketingCloudVisitorID},S.MCIDCallTimedOut=function(){return W.MCIDCallTimedOut},S.AnalyticsIDCallTimedOut=function(){return W.AnalyticsIDCallTimedOut},S.AAMIDCallTimedOut=function(){return W.AAMIDCallTimedOut},S.idSyncGetOnPageSyncInfo=function(){return S._readVisitor(),S._getField("MCSYNCSOP")},S.idSyncByURL=function(e){if(!S.isOptedOut()){var t=u(e||{});if(t.error)return t.error;var n,i,r=e.url,a=encodeURIComponent,o=X;return r=r.replace(/^https:/,"").replace(/^http:/,""),n=U.encodeAndBuildRequest(["",e.dpid,e.dpuuid||""],","),i=["ibs",a(e.dpid),"img",a(r),t.ttl,"",n],o.addMessage(i.join("|")),o.requestToProcess(),"Successfully queued"}},S.idSyncByDataSource=function(e){if(!S.isOptedOut())return e===Object(e)&&"string"==typeof e.dpuuid&&e.dpuuid.length?(e.url="//dpm.demdex.net/ibs:dpid="+e.dpid+"&dpuuid="+e.dpuuid,S.idSyncByURL(e)):"Error: config or config.dpuuid is empty"},Ye(S,X),S._getCookieVersion=function(e){e=e||S.cookieRead(S.cookieName);var t=oe.VERSION_REGEX.exec(e);return t&&t.length>1?t[1]:null},S._resetAmcvCookie=function(e){var t=S._getCookieVersion();t&&!te.isLessThan(t,e)||S.removeCookie(S.cookieName)},S.setAsCoopSafe=function(){k=!0},S.setAsCoopUnsafe=function(){k=!1},function(){if(S.configs=Object.create(null),q.isObject(n))for(var e in n)j(e)&&(S[e]=n[e],S.configs[e]=n[e])}(),f();var K;S.init=function(){l()&&(I.optIn.fetchPermissions(h,!0),!I.optIn.isApproved(I.optIn.Categories.ECID))||K||(K=!0,function(){if(q.isObject(n)){S.idSyncContainerID=S.idSyncContainerID||0,k="boolean"==typeof S.isCoopSafe?S.isCoopSafe:q.parseBoolean(S.isCoopSafe),S.resetBeforeVersion&&S._resetAmcvCookie(S.resetBeforeVersion),S._attemptToPopulateIdsFromUrl(),S._attemptToPopulateSdidFromUrl(),S._readVisitor();var e=S._getField(P),t=Math.ceil((new Date).getTime()/oe.MILLIS_PER_DAY);S.idSyncDisableSyncs||S.disableIdSyncs||!X.canMakeSyncIDCall(e,t)||(S._setFieldExpire(N,-1),S._setField(P,t)),S.getMarketingCloudVisitorID(),S.getAudienceManagerLocationHint(),S.getAudienceManagerBlob(),S._mergeServerState(S.serverState)}else S._attemptToPopulateIdsFromUrl(),S._attemptToPopulateSdidFromUrl()}(),function(){if(!S.idSyncDisableSyncs&&!S.disableIdSyncs){X.checkDPIframeSrc();var e=function(){var e=X;e.readyToAttachIframe()&&e.attachIframe()};A.addEventListener("load",function(){O.windowLoaded=!0,e()});try{ie.receiveMessage(function(e){X.receiveMessage(e.data)},X.iframeHost)}catch(e){}}}(),function(){S.whitelistIframeDomains&&oe.POST_MESSAGE_ENABLED&&(S.whitelistIframeDomains=S.whitelistIframeDomains instanceof Array?S.whitelistIframeDomains:[S.whitelistIframeDomains],S.whitelistIframeDomains.forEach(function(e){var n=new Y(t,e),i=Q(S,n);ie.receiveMessage(i,e)}))}())}};Je.config=ue,C.Visitor=Je;var ze=Je,Qe=function(e){if(U.isObject(e))return Object.keys(e).filter(function(t){return""!==e[t]&&ue.getConfigs()[t]}).reduce(function(t,n){var i=ue.normalizeConfig(n,e[n]),r=U.normalizeBoolean(i);return t[n]=r,t},Object.create(null))},$e=Ge.OptIn,Ze=Ge.IabPlugin;return ze.getInstance=function(e,t){if(!e)throw new Error("Visitor requires Adobe Marketing Cloud Org ID.");e.indexOf("@")<0&&(e+="@AdobeOrg");var n=function(){var t=C.s_c_il;if(t)for(var n=0;n<t.length;n++){var i=t[n];if(i&&"Visitor"===i._c&&i.marketingCloudOrgID===e)return i}}();if(n)return n;var i=Qe(t)||{};!function(e){C.adobe.optIn=C.adobe.optIn||function(){var t=U.pluck(e,["doesOptInApply","previousPermissions","preOptInApprovals","isOptInStorageEnabled","optInStorageExpiry","isIabContext","sameSiteCookie","secureCookie"]),n=e.optInCookieDomain||e.cookieDomain;n=n||ee(),n=n===window.location.hostname?"":n,t.optInCookieDomain=n;var i=new $e(t,{cookies:Z});if(t.isIabContext&&t.doesOptInApply){var r=new Ze;i.registerPlugin(r)}return i}()}(i||{});var r=e,a=r.split("").reverse().join(""),o=new ze(e,null,a);i.cookieDomain&&(o.cookieDomain=i.cookieDomain),i.sameSiteCookie&&i.secureCookie&&(o.configs={sameSiteCookie:i.sameSiteCookie,
secureCookie:i.secureCookie}),function(){C.s_c_il.splice(--C.s_c_in,1)}();var s=U.getIeVersion();if("number"==typeof s&&s<10)return o._helpers.replaceMethodsWithFunction(o,function(){});var c=function(){try{return C.self!==C.parent}catch(e){return!0}}()&&(!function(e){return e.cookieWrite("TEST_AMCV_COOKIE","T",1),"T"===e.cookieRead("TEST_AMCV_COOKIE")&&(e.removeCookie("TEST_AMCV_COOKIE"),!0)}(o)||U.isFirefox())&&C.parent?new X(e,i,o,C.parent):new ze(e,i,a);return o=null,c.init(),c},function(){function e(){ze.windowLoaded=!0}C.addEventListener?C.addEventListener("load",e):C.attachEvent&&C.attachEvent("onload",e),ze.codeLoadEnd=(new Date).getTime()}(),ze}();

  return Visitor;
}();

          }

        },
        "adobe-mcid/src/view/utils/timeUnits.js": {
          "script": function(module, exports, require, turbine) {

var timeUnits = {
  Hours: 3600,
  Days: 24 * 3600,
  Weeks: 7 * 24 * 3600,
  Months: 30 * 24 * 3600,
  Years: 365 * 24 * 3600
};

module.exports = timeUnits;

          }

        }
      }
    },
    "common-analytics-plugins": {
      "displayName": "Common Analytics Plugins",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EPb691af6ae5364085b2c253385a4dda8d/",
      "modules": {
        "common-analytics-plugins/src/lib/actions/initialize.js": {
          "name": "initialize",
          "displayName": "Initialize",
          "script": function(module, exports, require, turbine) {
'use strict';

var initMany = require('./common').initMany;

module.exports = function( settings ) {
    var si = settings, parray = [];


    si.il   = si.il   || si.ft   || si.apl  || si.gtbe || si.gttc? true: false;
    si.pt   = si.pt   || si.gqp  || si.mv?                         true: false;
    si.ft   = si.ft   || si.gtbe || si.gttc?                       true: false;
    si.p_fo = si.p_fo || si.fpo  || si.gplt || si.gppv?            true: false;
    si.apl  = si.apl  || si.ape?                                   true: false;

    if( si.ns ) {
                   parray.push( { pname: 'zeroPad',               obj: 'window' }    );
                   parray.push( { pname: 'randomNumber',          obj: 'window' }    );
                   parray.push( { pname: 'twoDecimals',           obj: 'window' }    )
    }
    if( si.ggc ) {
                   parray.push( { pname: 'getGeoCoordinates',     obj: 'window'    } );
                   parray.push( { pname: 'getGeoCoordinates',     obj: 'analytics' } );
    }
    if( si.gnr ) {
                   parray.push( { pname: 'getNewRepeat',          obj: 'window'    } );
                   parray.push( { pname: 'getNewRepeat',          obj: 'analytics' } );
    }
    if( si.gpn )   parray.push( { pname: 'getPageName',           obj: 'window' }    );
    if( si.gnr )   parray.push( { pname: 'getTimeParting',        obj: 'window' }    );
    if( si.grl )   parray.push( { pname: 'getResponsiveLayout',   obj: 'window' }    );

    if( si.il )    parray.push( { pname: 'inList',                obj: 'analytics' } );
    if( si.ft )    parray.push( { pname: 'formatTime',            obj: 'analytics' } );
    if( si.pt )    parray.push( { pname: 'pt',                    obj: 'analytics' } );
    if( si.p_fo )  parray.push( { pname: 'p_fo',                  obj: 'analytics' } );
    if( si.apv )   parray.push( { pname: 'addProductEvar',        obj: 'analytics' } );
    if( si.ape )   parray.push( { pname: 'addProductEvent',       obj: 'analytics' } );
    if( si.apl )   parray.push( { pname: 'apl',                   obj: 'analytics' } );
    if( si.rfl )   parray.push( { pname: 'rfl',                   obj: 'analytics' } );
    if( si.gvo )   parray.push( { pname: 'getValOnce',            obj: 'analytics' } );
    if( si.gpv )   parray.push( { pname: 'getPreviousValue',      obj: 'analytics' } );
    if( si.gapv )  parray.push( { pname: 'getAndPersistValue',    obj: 'analytics' } );
    if( si.gtslv ) parray.push( { pname: 'getTimeSinceLastVisit', obj: 'analytics' } );
    if( si.gdslv ) parray.push( { pname: 'getDaysSinceLastVisit', obj: 'analytics' } );
    if( si.gqp )   parray.push( { pname: 'getQueryParam',         obj: 'analytics' } );
    if( si.gtbe )  parray.push( { pname: 'getTimeBetweenEvents',  obj: 'analytics' } );
    if( si.gtp )   parray.push( { pname: 'getTimeParting',        obj: 'window'    } );
    if( si.gttc )  parray.push( { pname: 'getTimeToComplete',     obj: 'analytics' } );
    if( si.gvd ) {
                   parray.push( { pname: 'getVisitDuration',      obj: 'window'    } );
                   parray.push( { pname: 'getVisitDuration',      obj: 'analytics' } );
    }
    if( si.gvn ) {
                   parray.push( { pname: 'getVisitNum',           obj: 'analytics' } );
                   parray.push( { pname: 'getVisitNum',           obj: 'window'    } );
                   parray.push( { pname: 'endOfDatePeriod',       obj: 'window'    } );
	}
	if( si.gplt ) {
                   parray.push( { pname: 'getPageLoadTime',       obj: 'analytics' } );
                   parray.push( { pname: 'performanceWriteFull',  obj: 'analytics' } );
                   parray.push( { pname: 'performanceWritePart',  obj: 'analytics' } );
                   parray.push( { pname: 'performanceCheck',      obj: 'analytics' } );
    }
    if( si.mv ) {
                   parray.push( { pname: 'manageVars',            obj: 'analytics' } );
                   parray.push( { pname: 'lowerCaseVars',         obj: 'analytics' } );
    }
    if( si.cs ) {
                   parray.push( { pname: 'cleanStr',              obj: 'analytics' } );
                   parray.push( { pname: 'cleanStr',              obj: 'window'    } )
    }
    if( si.gppv ) {
                   parray.push( { pname: 'getPercentPageViewed',  obj: 'analytics' } );
                   parray.push( { pname: 'handlePPVevents',       obj: 'analytics' } )
    }


    initMany( parray );
};
          }

        },
        "common-analytics-plugins/src/lib/main-module.js": {
          "script": function(module, exports, require, turbine) {
'use strict';

if( turbine.getSharedModule('adobe-analytics', 'get-tracker') ) {} else { turbine.logger.error( 'The "Adobe Analytics" extension must be installed in the Launch web property (' + _satellite.property.name + ') in order to use the "Common Analytics Plugins" extension' ) }

var augmentTracker = turbine.getSharedModule('adobe-analytics', 'augment-tracker');

augmentTracker(function(tracker) {
    if( typeof tracker.contextData === 'object' && typeof window.aaPlugins === 'object' ) {
        for( var pf in window.aaPlugins ) {
            tracker.contextData[pf] = window.aaPlugins[pf]
        }
    }
});
          }

        },
        "common-analytics-plugins/src/lib/actions/common.js": {
          "script": function(module, exports, require, turbine) {
'use strict';

var getObj = function( obj, tr ) { return obj==='analytics' || typeof obj === 'undefined'? tr: (obj==='window'? window: null ) },
    err = function( m ) { turbine.logger.error( 'common.js: ' + m ) },
    initAndSetVersion = function( pn, obj, tr ) {
        obj[pn] = require('../plugins/allPlugins')[pn];
        var cd = tr.contextData || {}, n,
            pl = getVersionFromPlugin( pn, obj );
        if( pl.version === 'n/a' ) pl = getVersionFromConfig( pn );
        cd[ pn ] = pl.version
    },
    getVersionFromPlugin = function( pn, obj ) {  
        var pl, v = { plugin: pn, version: 'n/a' };
        try { pl = obj[pn]('-v') } catch(e) { pl = {} }
        try { if( typeof pl.plugin !== 'string' || pl.plugin.length<1 ) pl = v } catch(e) { pl = v }
        return pl
    },
    getVersionFromConfig = function( pn ) { 
        var ex = turbine.getExtensionSettings(), pl = { plugin: pn, version: 'n/a' }
        try { pl.version = ex[pn].version } catch(e) { pl.version = 'n/a' }
        return pl
    }

module.exports.init = function( pluginName, obj ) {
    var augmentTracker = turbine.getSharedModule('adobe-analytics', 'augment-tracker'), ver, cd;
    augmentTracker(function(tracker) {
        if( tracker ) {
            obj = getObj( obj, tracker );
            if( pluginName && obj ) initAndSetVersion( pluginName, obj, tracker );
        }
    })
}

module.exports.initMany = function(a) {
    var augmentTracker = turbine.getSharedModule('adobe-analytics', 'augment-tracker'), ver, cd, obj;
    augmentTracker(function(tracker) {
        if( tracker ) {
            for( var i=0; i<a.length; i++ ) {
                obj = getObj( a[i].obj, tracker )
                if( a[i].pname && obj ) initAndSetVersion( a[i].pname, obj, tracker );
            }
        }
    })
}
          }

        },
        "common-analytics-plugins/src/lib/plugins/allPlugins.js": {
          "script": function(module, exports, require, turbine) {
module.exports.addProductEvar = require('./addProductEvar').addProductEvar;
module.exports.addProductEvent = require('./addProductEvent').addProductEvent;
module.exports.apl = require('./apl').apl;
module.exports.cleanStr = require('./cleanStr').cleanStr;
module.exports.endOfDatePeriod = require('./endOfDatePeriod').endOfDatePeriod;
module.exports.formatTime = require('./formatTime').formatTime;
module.exports.getAndPersistValue = require('./getAndPersistValue').getAndPersistValue;
module.exports.getDaysSinceLastVisit = require('./getDaysSinceLastVisit').getDaysSinceLastVisit;
module.exports.getGeoCoordinates = require('./getGeoCoordinates').getGeoCoordinates;
module.exports.getNewRepeat = require('./getNewRepeat').getNewRepeat;
module.exports.getPageLoadTime = require('./getPageLoadTime').getPageLoadTime;
module.exports.getPageName = require('./getPageName').getPageName;
module.exports.getPreviousValue = require('./getPreviousValue').getPreviousValue;
module.exports.getQueryParam = require('./getQueryParam').getQueryParam;
module.exports.getResponsiveLayout = require('./getResponsiveLayout').getResponsiveLayout;
module.exports.getTimeBetweenEvents = require('./getTimeBetweenEvents').getTimeBetweenEvents;
module.exports.getTimeParting = require('./getTimeParting').getTimeParting;
module.exports.getTimeSinceLastVisit = require('./getTimeSinceLastVisit').getTimeSinceLastVisit;
module.exports.getTimeToComplete = require('./getTimeToComplete').getTimeToComplete;
module.exports.getValOnce = require('./getValOnce').getValOnce;
module.exports.getVisitDuration = require('./getVisitDuration').getVisitDuration;
module.exports.getVisitNum = require('./getVisitNum').getVisitNum;
module.exports.inList = require('./inList').inList;
module.exports.lowerCaseVars = require('./lowerCaseVars').lowerCaseVars;
module.exports.manageVars = require('./manageVars').manageVars;
module.exports.p_fo = require('./p_fo').p_fo;
module.exports.performanceCheck = require('./performanceCheck').performanceCheck;
module.exports.performanceWriteFull = require('./performanceWriteFull').performanceWriteFull;
module.exports.performanceWritePart = require('./performanceWritePart').performanceWritePart;
module.exports.handlePPVevents = require('./handlePPVevents').handlePPVevents;
module.exports.getPercentPageViewed = require('./getPercentPageViewed').getPercentPageViewed;
module.exports.pt = require('./pt').pt;
module.exports.rfl = require('./rfl').rfl;
module.exports.twoDecimals = require('./twoDecimals').twoDecimals;
module.exports.zeroPad = require('./zeroPad').zeroPad;
module.exports.randomNumber = require('./randomNumber').randomNumber;
          }

        },
        "common-analytics-plugins/src/lib/plugins/addProductEvar.js": {
          "script": function(module, exports, require, turbine) {

function addProductEvar(en,ev,ap){var e=en,f=ev,d=ap;if("-v"===e)return{plugin:"addProductEvar",version:"2.0"};a:{if("undefined"!==typeof window.s_c_il){var b=0;for(var c;b<window.s_c_il.length;b++)if(c=window.s_c_il[b],c._c&&"s_c"===c._c){b=c;break a}}b=void 0}if("undefined"!==typeof b&&(b.contextData.addProductEvar="2.0","string"===typeof e&&"string"===typeof f&&""!==f))if(d=d||!1,b.products){c=b.products.split(",");var g=c.length;d=d?0:g-1;for(var a;d<g;d++)a=c[d].split(";"),a[5]&&-1<a[5].toLowerCase().indexOf("evar")?a[5]=a[5]+"|"+e+"="+f:a[5]?a[5]=e+"="+f:a[5]||(a[4]||(a[4]=""),a[3]||(a[3]=""),a[2]||(a[2]=""),a[1]||(a[1]=""),a[5]=e+"="+f),c[d]=a.join(";");b.products=c.join(",")}else b.products=";;;;;"+e+"="+f};

module.exports.addProductEvar = addProductEvar;
          }

        },
        "common-analytics-plugins/src/lib/plugins/addProductEvent.js": {
          "script": function(module, exports, require, turbine) {

function addProductEvent(en,ev,ap){var f=en,g=ev,c=ap;if("-v"===f)return{plugin:"addProductEvent",version:"2.0"};var d=function(){if("undefined"!==typeof window.s_c_il)for(var b=0,e;b<window.s_c_il.length;b++)if(e=window.s_c_il[b],e._c&&"s_c"===e._c)return e}();if("undefined"!==typeof d&&(d.contextData.addProductEvent="2.0",window.apl=window.apl||function(b,e,c,d,f){function g(b,d,c,e){if("string"!==typeof d)return!1;if("string"===typeof b)b=b.split(c||",");else if("object"!==typeof b)return!1;c=0;for(a=b.length;c<a;c++)if(1==e&&d===b[c]||d.toLowerCase()===b[c].toLowerCase())return!0;return!1}if(!b||"string"===typeof b){if("string"!==typeof e||""===e)return b;c=c||",";d=d||c;1==d&&(d=c,f||(f=1));2==d&&1!=f&&(d=c);e=e.split(",");k=e.length;for(var h=0;h<k;h++)g(b,e[h],c,f)||(b=b?b+d+e[h]:e[h])}return b},"string"===typeof f))if(g=isNaN(g)?"1":String(g),c=c||!1,d.events=window.apl(d.events,f),d.products){var l=d.products.split(","),m=l.length;c=c?0:m-1;for(var b;c<m;c++)b=l[c].split(";"),b[4]&&-1<b[4].indexOf("event")?b[4]=b[4]+"|"+f+"="+g:b[5]?b[4]=f+"="+g:b[4]||(b[3]||(b[3]=""),b[2]||(b[2]=""),b[1]||(b[1]=""),b[4]=f+"="+g),l[c]=b.join(";");d.products=l.join(",")}else d.products=";;;;"+f+"="+g};

module.exports.addProductEvent = addProductEvent;
          }

        },
        "common-analytics-plugins/src/lib/plugins/apl.js": {
          "script": function(module, exports, require, turbine) {

function apl(lv,va,d1,d2,cc){var b=lv,d=va,e=d1,c=d2,g=cc;if("-v"===b)return{plugin:"apl",version:"4.0"};var h=function(){if("undefined"!==typeof window.s_c_il)for(var k=0,b;k<window.s_c_il.length;k++)if(b=window.s_c_il[k],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof h&&(h.contextData.apl="4.0");window.inList=window.inList||function(b,d,c,e){if("string"!==typeof d)return!1;if("string"===typeof b)b=b.split(c||",");else if("object"!==typeof b)return!1;c=0;for(a=b.length;c<a;c++)if(1==e&&d===b[c]||d.toLowerCase()===b[c].toLowerCase())return!0;return!1};if(!b||"string"===typeof b){if("string"!==typeof d||""===d)return b;e=e||",";c=c||e;1==c&&(c=e,g||(g=1));2==c&&1!=g&&(c=e);d=d.split(",");h=d.length;for(var f=0;f<h;f++)window.inList(b,d[f],e,g)||(b=b?b+c+d[f]:d[f])}return b};

module.exports.apl = apl;
          }

        },
        "common-analytics-plugins/src/lib/plugins/cleanStr.js": {
          "script": function(module, exports, require, turbine) {

function cleanStr(str){var a=str;if("-v"===a)return{plugin:"cleanStr",version:"2.0"};a:{if("undefined"!==typeof window.s_c_il){var b=0;for(var c;b<window.s_c_il.length;b++)if(c=window.s_c_il[b],c._c&&"s_c"===c._c){b=c;break a}}b=void 0}"undefined"!==typeof b&&(b.contextData.cleanStr="2.0");if("string"===typeof a){a=a.replace(/<\/?[^>]+(>|$)/g,"");a=a.trim();a=a.replace(/[\u2018\u2019\u201A]/g,"'");a=a.replace(/\t+/g,"");for(a=a.replace(/[\n\r]/g," ");-1<a.indexOf("  ");)a=a.replace(/\s\s/g," ");return a}return""}

module.exports.cleanStr = cleanStr;
          }

        },
        "common-analytics-plugins/src/lib/plugins/endOfDatePeriod.js": {
          "script": function(module, exports, require, turbine) {

function endOfDatePeriod(dp){var c=dp;if("-v"===c)return{plugin:"endOfDatePeriod",version:"1.2"};var a=function(){if("undefined"!==typeof window.s_c_il)for(var a=0,b;a<window.s_c_il.length;a++)if(b=window.s_c_il[a],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof a&&(a.contextData.endOfDatePeriod="1.2");a=new Date;var d=isNaN(c)?0:Math.floor(c),e=function(a,b){return(new Date(b?b:1970,a?a:1,0)).getDate()};a.setHours(23);a.setMinutes(59);a.setSeconds(59);"w"===c&&(d=6-a.getDay());"m"===c&&(d=e(a.getMonth()+1,a.getFullYear())-a.getDate());a.setDate(a.getDate()+d);"y"===c&&(a.setMonth(11),a.setDate(31));return a};

module.exports.endOfDatePeriod = endOfDatePeriod;
          }

        },
        "common-analytics-plugins/src/lib/plugins/formatTime.js": {
          "script": function(module, exports, require, turbine) {

function formatTime(ns,tf,bml){var f=ns,d=tf,e=bml;function h(b,d,c,e){if("string"!==typeof d)return!1;if("string"===typeof b)b=b.split(c||",");else if("object"!==typeof b)return!1;c=0;for(a=b.length;c<a;c++)if(1==e&&d===b[c]||d.toLowerCase()===b[c].toLowerCase())return!0;return!1}if(arguments&&"-v"===arguments[0])return{plugin:"formatTime",version:"2.0"};var b=function(){if("undefined"!==typeof window.s_c_il)for(var b=0,c;b<window.s_c_il.length;b++)if(c=window.s_c_il[b],c._c&&"s_c"===c._c)return c}();"undefined"!==typeof b&&(b.contextData.formatTime="2.0");if(!("undefined"===typeof f||isNaN(f)||0>Number(f))){b="";if("string"===typeof d&&"d"===d||("string"!==typeof d||!h("h,m,s",d))&&86400<=f){var c=86400;var g="days";b=isNaN(e)?1:c/(e*c)}else"string"===typeof d&&"h"===d||("string"!==typeof d||!h("m,s",d))&&3600<=f?(c=3600,g="hours",b=isNaN(e)?4:c/(e*c)):"string"===typeof d&&"m"===d||("string"!==typeof d||!h("s",d))&&60<=f?(c=60,g="minutes",b=isNaN(e)?2:c/(e*c)):(c=1,g="seconds",b=isNaN(e)?.2:c/e);b=Math.round(f*b/c)/b+" "+g;0===b.indexOf("1 ")&&(b=b.substring(0,b.length-1));return b}};

module.exports.formatTime = formatTime;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getAndPersistValue.js": {
          "script": function(module, exports, require, turbine) {

function getAndPersistValue(vtp,cn,ex){var d=vtp,k=cn,l=ex;if("undefined"!==typeof d&&"-v"===d)return{plugin:"getAndPersistValue",version:"3.0"};var a=function(){if("undefined"!==typeof window.s_c_il)for(var c=0,b;c<window.s_c_il.length;c++)if(b=window.s_c_il[c],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof a&&(a.contextData.getAndPersistValue="3.0");window.cookieWrite=window.cookieWrite||function(c,b,f){if("string"===typeof c){var h=window.location.hostname,a=window.location.hostname.split(".").length-1;if(h&&!/^[0-9.]+$/.test(h)){a=2<a?a:2;var e=h.lastIndexOf(".");if(0<=e){for(;0<=e&&1<a;)e=h.lastIndexOf(".",e-1),a--;e=0<e?h.substring(e):h}}g=e;b="undefined"!==typeof b?""+b:"";if(f||""===b)if(""===b&&(f=-60),"number"===typeof f){var d=new Date;d.setTime(d.getTime()+6E4*f)}else d=f;return c&&(document.cookie=encodeURIComponent(c)+"="+encodeURIComponent(b)+"; path=/;"+(f?" expires="+d.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(c)===b:!1}};window.cookieRead=window.cookieRead||function(c){if("string"===typeof c)c=encodeURIComponent(c);else return"";var b=" "+document.cookie,a=b.indexOf(" "+c+"="),d=0>a?a:b.indexOf(";",a);return(c=0>a?"":decodeURIComponent(b.substring(a+2+c.length,0>d?b.length:d)))?c:""};a=new Date;k=k?k:"s_gapv";(l=l?l:0)?a.setTime(a.getTime()+864E5*l):a.setTime(a.getTime()+18E5);"undefined"!==typeof d&&d||(d=cookieRead(k));cookieWrite(k,d,a);return d};

module.exports.getAndPersistValue = getAndPersistValue;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getDaysSinceLastVisit.js": {
          "script": function(module, exports, require, turbine) {
function getDaysSinceLastVisit(){var a=new Date,b=a.getTime(),c=this.c_r("s_dslv");a.setTime(b+94608E6);this.c_w("s_dslv",b,a);if(c){a=b-c;if(18E5<a){if(31536E6<a)return"More than a year";if(2592E6<a)return"More than 30 days";if(a<2592E6+1&&6048E5<a)return"More than 7 days";if(a<6048E5+1&&864E5<a)return"Less than 7 days";if(a<864E5+1)return"Less than 1 day"}return""}return"New Visitor"}

module.exports.getDaysSinceLastVisit = getDaysSinceLastVisit;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getGeoCoordinates.js": {
          "script": function(module, exports, require, turbine) {

function getGeoCoordinates(){if(arguments&&"-v"===arguments[0])return{plugin:"getGeoCoordinates",version:"2.0"};var b=function(){if("undefined"!==typeof window.s_c_il)for(var a=0,c;a<window.s_c_il.length;a++)if(c=window.s_c_il[a],c._c&&"s_c"===c._c)return c}();"undefined"!==typeof b&&(b.contextData.getGeoCoordinates="2.0");window.cookieWrite=window.cookieWrite||function(a,c,f){if("string"===typeof a){var h=window.location.hostname,b=window.location.hostname.split(".").length-1;if(h&&!/^[0-9.]+$/.test(h)){b=2<b?b:2;var e=h.lastIndexOf(".");if(0<=e){for(;0<=e&&1<b;)e=h.lastIndexOf(".",e-1),b--;e=0<e?h.substring(e):h}}g=e;c="undefined"!==typeof c?""+c:"";if(f||""===c)if(""===c&&(f=-60),"number"===typeof f){var d=new Date;d.setTime(d.getTime()+6E4*f)}else d=f;return a&&(document.cookie=encodeURIComponent(a)+"="+encodeURIComponent(c)+"; path=/;"+(f?" expires="+d.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(a)===c:!1}};window.cookieRead=window.cookieRead||function(a){if("string"===typeof a)a=encodeURIComponent(a);else return"";var c=" "+document.cookie,b=c.indexOf(" "+a+"="),d=0>b?b:c.indexOf(";",b);return(a=0>b?"":decodeURIComponent(c.substring(b+2+a.length,0>d?c.length:d)))?a:""};var d="";b=cookieRead("s_ggc").split("|");var k={timeout:5E3,maximumAge:0},l=function(a){a=a.coords;cookieWrite("s_ggc",parseFloat(a.latitude.toFixed(4))+"|"+parseFloat(a.longitude.toFixed(4)),30);d="latitude="+parseFloat(a.latitude.toFixed(4))+" | longitude="+parseFloat(a.longitude.toFixed(4))},m=function(a){d="error retrieving geo coordinates"};1<b.length&&(d="latitude="+b[0]+" | longitude="+b[1]);navigator.geolocation&&navigator.geolocation.getCurrentPosition(l,m,k);""===d&&(d="geo coordinates not available");return d};

module.exports.getGeoCoordinates = getGeoCoordinates;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getNewRepeat.js": {
          "script": function(module, exports, require, turbine) {

function getNewRepeat(d){var a=d;if("-v"===a)return{plugin:"getNewRepeat",version:"3.0"};var d=function(){if("undefined"!==typeof window.s_c_il)for(var c=0,b;c<window.s_c_il.length;c++)if(b=window.s_c_il[c],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof d&&(d.contextData.getNewRepeat="3.0");window.cookieWrite=window.cookieWrite||function(c,b,f){if("string"===typeof c){var h=window.location.hostname,a=window.location.hostname.split(".").length-1;if(h&&!/^[0-9.]+$/.test(h)){a=2<a?a:2;var e=h.lastIndexOf(".");if(0<=e){for(;0<=e&&1<a;)e=h.lastIndexOf(".",e-1),a--;e=0<e?h.substring(e):h}}g=e;b="undefined"!==typeof b?""+b:"";if(f||""===b)if(""===b&&(f=-60),"number"===typeof f){var d=new Date;d.setTime(d.getTime()+6E4*f)}else d=f;return c&&(document.cookie=encodeURIComponent(c)+"="+encodeURIComponent(b)+"; path=/;"+(f?" expires="+d.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(c)===b:!1}};window.cookieRead=window.cookieRead||function(c){if("string"===typeof c)c=encodeURIComponent(c);else return"";var b=" "+document.cookie,a=b.indexOf(" "+c+"="),d=0>a?a:b.indexOf(";",a);return(c=0>a?"":decodeURIComponent(b.substring(a+2+c.length,0>d?b.length:d)))?c:""};a=a?a:30;d="s_nr"+a;var k=new Date,m=cookieRead(d),n=m.split("-"),l=k.getTime();k.setTime(l+864E5*a);if(""===m||18E5>l-n[0]&&"New"===n[1])return cookieWrite(d,l+"-New",k),"New";cookieWrite(d,l+"-Repeat",k);return"Repeat"};

module.exports.getNewRepeat = getNewRepeat;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getPageLoadTime.js": {
          "script": function(module, exports, require, turbine) {


function getPageLoadTime(){function l(){var a=performance.timing;if(0<a.loadEventEnd&&(clearInterval(window.pi),""===window.cookieRead("s_plt"))){var b=window,d=b.cookieWrite;var c=a.loadEventEnd;var f=a.navigationStart;c=0<=c&&0<=f?6E4>c-f&&0<=c-f?parseFloat((c-f)/1E3).toFixed(2):60:void 0;d.call(b,"s_plt",c);window.cookieWrite("s_pltp",window.pageName)}window.ptc=a.loadEventEnd}if(arguments&&"-v"===arguments[0])return{plugin:"getPageLoadTime",version:"2.0.1"};var e=function(){if("undefined"!==typeof window.s_c_il)for(var a=0,b;a<window.s_c_il.length;a++)if(b=window.s_c_il[a],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof e&&(e.contextData.getPageLoadTime="2.0.1");window.pageName="undefined"!==typeof e&&e.pageName||"";window.cookieWrite=window.cookieWrite||function(a,b,d){if("string"===typeof a){var c=window.location.hostname,f=window.location.hostname.split(".").length-1;if(c&&!/^[0-9.]+$/.test(c)){f=2<f?f:2;var h=c.lastIndexOf(".");if(0<=h){for(;0<=h&&1<f;)h=c.lastIndexOf(".",h-1),f--;h=0<h?c.substring(h):c}}g=h;b="undefined"!==typeof b?""+b:"";if(d||""===b)if(""===b&&(d=-60),"number"===typeof d){var k=new Date;k.setTime(k.getTime()+6E4*d)}else k=d;return a&&(document.cookie=encodeURIComponent(a)+"="+encodeURIComponent(b)+"; path=/;"+(d?" expires="+k.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(a)===b:!1}};window.cookieRead=window.cookieRead||function(a){if("string"===typeof a)a=encodeURIComponent(a);else return"";var b=" "+document.cookie,d=b.indexOf(" "+a+"="),c=0>d?d:b.indexOf(";",d);return(a=0>d?"":decodeURIComponent(b.substring(d+2+a.length,0>c?b.length:c)))?a:""};window.p_fo=window.p_fo||function(a){window.__fo||(window.__fo={});if(window.__fo[a])return!1;window.__fo[a]={};return!0};"undefined"!==typeof performance&&p_fo("performance")&&((e=performance,e.clearResourceTimings(),""!==window.cookieRead("s_plt")&&(0<e.timing.loadEventEnd&&clearInterval(window.pi),this._pltLoadTime=window.cookieRead("s_plt"),this._pltPreviousPage=window.cookieRead("s_pltp"),window.cookieWrite("s_plt",""),window.cookieWrite("s_pltp","")),0===e.timing.loadEventEnd)?window.pi=setInterval(function(){l()},250):0<e.timing.loadEventEnd&&(window.ptc?window.ptc===e.timing.loadEventEnd&&1===e.getEntries().length&&(window.pwp=setInterval(function(){var a=performance;0<a.getEntries().length&&(window.ppfe===a.getEntries().length?clearInterval(window.pwp):window.ppfe=a.getEntries().length);""===window.cookieRead("s_plt")&&(window.cookieWrite("s_plt",((a.getEntries()[a.getEntries().length-1].responseEnd-a.getEntries()[0].startTime)/1E3).toFixed(2)),window.cookieWrite("s_pltp",window.pageName))},500)):l()))};

module.exports.getPageLoadTime = getPageLoadTime;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getPageName.js": {
          "script": function(module, exports, require, turbine) {

var getPageName=function(si,qv,hv,de){var a=si,b=qv,f=hv,e=de;if("-v"===a)return{plugin:"getPageName",version:"4.2"};a:{if("undefined"!==typeof window.s_c_il){var d=0;for(var g;d<window.s_c_il.length;d++)if(g=window.s_c_il[d],g._c&&"s_c"===g._c){d=g;break a}}d=void 0}"undefined"!==typeof d&&(d.contextData.getPageName="4.2");var c=location.hostname,h=location.pathname.substring(1).split("/"),l=h.length,k=location.search.substring(1).split("&"),m=k.length;d=location.hash.substring(1).split("&");g=d.length;e=e?e:"|";a=a?a:c;b=b?b:"";f=f?f:"";if(1===l&&""===h[0])a=a+e+"home";else for(c=0;c<l;c++)a=a+e+decodeURIComponent(h[c]);if(b&&(1!==m||""!==k[0]))for(h=b.split(","),l=h.length,c=0;c<l;c++)for(b=0;b<m;b++)if(h[c]===k[b].split("=")[0]){a=a+e+decodeURIComponent(k[b]);break}if(f&&(1!==g||""!==d[0]))for(f=f.split(","),k=f.length,c=0;c<k;c++)for(b=0;b<g;b++)if(f[c]===d[b].split("=")[0]){a=a+e+decodeURIComponent(d[b]);break}return a.substring(a.length-e.length)===e?a.substring(0,a.length-e.length):a};

module.exports.getPageName = getPageName;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getPreviousValue.js": {
          "script": function(module, exports, require, turbine) {

function getPreviousValue(v,c){var k=v,d=c;if("-v"===k)return{plugin:"getPreviousValue",version:"3.0"};var a=function(){if("undefined"!==typeof window.s_c_il)for(var c=0,b;c<window.s_c_il.length;c++)if(b=window.s_c_il[c],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof a&&(a.contextData.getPreviousValue="3.0");window.cookieWrite=window.cookieWrite||function(c,b,f){if("string"===typeof c){var h=window.location.hostname,a=window.location.hostname.split(".").length-1;if(h&&!/^[0-9.]+$/.test(h)){a=2<a?a:2;var e=h.lastIndexOf(".");if(0<=e){for(;0<=e&&1<a;)e=h.lastIndexOf(".",e-1),a--;e=0<e?h.substring(e):h}}g=e;b="undefined"!==typeof b?""+b:"";if(f||""===b)if(""===b&&(f=-60),"number"===typeof f){var d=new Date;d.setTime(d.getTime()+6E4*f)}else d=f;return c&&(document.cookie=encodeURIComponent(c)+"="+encodeURIComponent(b)+"; path=/;"+(f?" expires="+d.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(c)===b:!1}};window.cookieRead=window.cookieRead||function(c){if("string"===typeof c)c=encodeURIComponent(c);else return"";var b=" "+document.cookie,a=b.indexOf(" "+c+"="),d=0>a?a:b.indexOf(";",a);return(c=0>a?"":decodeURIComponent(b.substring(a+2+c.length,0>d?b.length:d)))?c:""};var l;d=d||"s_gpv";a=new Date;a.setTime(a.getTime()+18E5);window.cookieRead(d)&&(l=window.cookieRead(d));k?window.cookieWrite(d,k,a):window.cookieWrite(d,l,a);return l};

module.exports.getPreviousValue = getPreviousValue;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getQueryParam.js": {
          "script": function(module, exports, require, turbine) {

function getQueryParam(a,d,f){function n(g,c){c=c.split("?").join("&");c=c.split("#").join("&");var e=c.indexOf("&");if(g&&(-1<e||c.indexOf("=")>e)){e=c.substring(e+1);e=e.split("&");for(var h=0,p=e.length;h<p;h++){var l=e[h].split("="),q=l[1];if(l[0].toLowerCase()===g.toLowerCase())return decodeURIComponent(q||!0)}}return""}if("-v"===a)return{plugin:"getQueryParam",version:"4.0.1"};var b=function(){if("undefined"!==typeof window.s_c_il)for(var g=0,c;g<window.s_c_il.length;g++)if(c=window.s_c_il[g],c._c&&"s_c"===c._c)return c}();"undefined"!==typeof b&&(b.contextData.getQueryParam="4.0");if(a){d=d||"";f=(f||"undefined"!==typeof b&&b.pageURL||location.href)+"";(4<d.length||-1<d.indexOf("="))&&f&&4>f.length&&(b=d,d=f,f=b);b="";for(var m=a.split(","),r=m.length,k=0;k<r;k++)a=n(m[k],f),"string"===typeof a?(a=-1<a.indexOf("#")?a.substring(0,a.indexOf("#")):a,b+=b?d+a:a):b=""===b?a:b+(d+a);return b}};

module.exports.getQueryParam = getQueryParam;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getResponsiveLayout.js": {
          "script": function(module, exports, require, turbine) {

var getResponsiveLayout=function(ppw,plw,tw){var c=ppw,b=plw,e=tw;if("-v"===c)return{plugin:"getResponsiveLayout",version:"1.1"};a:{if("undefined"!==typeof window.s_c_il){var a=0;for(var d;a<window.s_c_il.length;a++)if(d=window.s_c_il[a],d._c&&"s_c"===d._c){a=d;break a}}a=void 0}"undefined"!==typeof a&&(a.contextData.getResponsiveLayout="1.1");if(!(isNaN(c)||isNaN(b)||isNaN(e)||b<c||e<b))return a=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,(c<b&&a<=b?a<=c?"phone portrait layout":"phone landscape layout":a<=b?"phone layout":a<=e?"tablet layout":"desktop layout")+":"+a+"x"+(window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight)};

module.exports.getResponsiveLayout = getResponsiveLayout;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getTimeBetweenEvents.js": {
          "script": function(module, exports, require, turbine) {

function getTimeBetweenEvents(ste,rt,stp,res,cn,etd,fmt,bml,rte){var v=ste,B=rt,x=stp,C=res,k=cn,m=etd,E=fmt,F=bml,p=rte;if("-v"===v)return{plugin:"getTimeBetweenEvents",version:"3.0"};var q=function(){if("undefined"!==typeof window.s_c_il)for(var c=0,b;c<window.s_c_il.length;c++)if(b=window.s_c_il[c],b._c&&"s_c"===b._c)return b}();if("undefined"!==typeof q&&(q.contextData.getTimeBetweenEvents="3.0",window.cookieWrite=window.cookieWrite||function(c,b,d){if("string"===typeof c){var n=window.location.hostname,f=window.location.hostname.split(".").length-1;if(n&&!/^[0-9.]+$/.test(n)){f=2<f?f:2;var l=n.lastIndexOf(".");if(0<=l){for(;0<=l&&1<f;)l=n.lastIndexOf(".",l-1),f--;l=0<l?n.substring(l):n}}g=l;b="undefined"!==typeof b?""+b:"";if(d||""===b)if(""===b&&(d=-60),"number"===typeof d){var e=new Date;e.setTime(e.getTime()+6E4*d)}else e=d;return c&&(document.cookie=encodeURIComponent(c)+"="+encodeURIComponent(b)+"; path=/;"+(d?" expires="+e.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof window.cookieRead)?window.cookieRead(c)===b:!1}},window.cookieRead=window.cookieRead||function(c){if("string"===typeof c)c=encodeURIComponent(c);else return"";var b=" "+document.cookie,d=b.indexOf(" "+c+"="),e=0>d?d:b.indexOf(";",d);return(c=0>d?"":decodeURIComponent(b.substring(d+2+c.length,0>e?b.length:e)))?c:""},window.formatTime=window.formatTime||function(c,b,d){function e(b,d,c,e){if("string"!==typeof d)return!1;if("string"===typeof b)b=b.split(c||",");else if("object"!==typeof b)return!1;c=0;for(a=b.length;c<a;c++)if(1==e&&d===b[c]||d.toLowerCase()===b[c].toLowerCase())return!0;return!1}if(!("undefined"===typeof c||isNaN(c)||0>Number(c))){var f="";"string"===typeof b&&"d"===b||("string"!==typeof b||!e("h,m,s",b))&&86400<=c?(b=86400,f="days",d=isNaN(d)?1:b/(d*b)):"string"===typeof b&&"h"===b||("string"!==typeof b||!e("m,s",b))&&3600<=c?(b=3600,f="hours",d=isNaN(d)?4:b/(d*b)):"string"===typeof b&&"m"===b||("string"!==typeof b||!e("s",b))&&60<=c?(b=60,f="minutes",d=isNaN(d)?2:b/(d*b)):(b=1,f="seconds",d=isNaN(d)?.2:b/d);f=Math.round(c*d/b)/d+" "+f;0===f.indexOf("1 ")&&(f=f.substring(0,f.length-1));return f}},window.inList=window.inList||function(c,b,d,e){if("string"!==typeof b)return!1;if("string"===typeof c)c=c.split(d||",");else if("object"!==typeof c)return!1;d=0;for(a=c.length;d<a;d++)if(1==e&&b===c[d]||b.toLowerCase()===c[d].toLowerCase())return!0;return!1},"string"===typeof v&&"undefined"!==typeof B&&"string"===typeof x&&"undefined"!==typeof C)){k=k?k:"s_tbe";m=isNaN(m)?1:Number(m);var r=!1,t=!1,y=v.split(","),z=x.split(",");p=p?p.split(","):[];for(var u=window.cookieRead(k),w,D=new Date,A=D.getTime(),h=new Date,e=0;e<p.length;++e)if(window.inList(q.events,p[e])){h.setDate(h.getDate()-1);window.cookieWrite(k,"",h);return}h.setTime(h.getTime()+864E5*m);for(e=0;e<y.length&&!r&&(r=window.inList(q.events,y[e]),!0!==r);++e);for(e=0;e<z.length&&!t&&(t=window.inList(q.events,z[e]),!0!==t);++e);1===y.length&&1===z.length&&v===x&&r&&t?(u&&(w=(A-u)/1E3),window.cookieWrite(k,A,m?h:0)):(!r||1!=B&&u||window.cookieWrite(k,A,m?h:0),t&&u&&(w=(D.getTime()-u)/1E3,!0===C&&(h.setDate(h.getDate()-1),window.cookieWrite(k,"",h))));return w?window.formatTime(w,E,F):""}};

module.exports.getTimeBetweenEvents = getTimeBetweenEvents;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getTimeParting.js": {
          "script": function(module, exports, require, turbine) {

function getTimeParting(t){var c=t;if("-v"===t)return{plugin:"getTimeParting",version:"6.3"};a:{if("undefined"!==typeof window.s_c_il){var a=0;for(var b;a<window.s_c_il.length;a++)if(b=window.s_c_il[a],b._c&&"s_c"===b._c){a=b;break a}}a=void 0}"undefined"!==typeof a&&(a.contextData.getTimeParting="6.3");c=document.documentMode?void 0:c||"Etc/GMT";a=(new Date).toLocaleDateString("en-US",{timeZone:c,minute:"numeric",hour:"numeric",weekday:"long",day:"numeric",year:"numeric",month:"long"});a=/([a-zA-Z]+).*?([a-zA-Z]+).*?([0-9]+).*?([0-9]+)(.*?)([0-9])(.*)/.exec(a);return"year="+a[4]+" | month="+a[2]+" | date="+a[3]+" | day="+a[1]+" | time="+(a[6]+a[7])};

module.exports.getTimeParting = getTimeParting;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getTimeSinceLastVisit.js": {
          "script": function(module, exports, require, turbine) {

function getTimeSinceLastVisit(){if(arguments&&"-v"===arguments[0])return{plugin:"getTimeSinceLastVisit",version:"2.0"};var h=function(){if("undefined"!==typeof window.s_c_il)for(var c=0,b;c<window.s_c_il.length;c++)if(b=window.s_c_il[c],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof h&&(h.contextData.getTimeSinceLastVisit="2.0");window.formatTime=window.formatTime||function(c,b,d){function f(b,d,c,e){if("string"!==typeof d)return!1;if("string"===typeof b)b=b.split(c||",");else if("object"!==typeof b)return!1;c=0;for(a=b.length;c<a;c++)if(1==e&&d===b[c]||d.toLowerCase()===b[c].toLowerCase())return!0;return!1}if(!("undefined"===typeof c||isNaN(c)||0>Number(c))){var e="";"string"===typeof b&&"d"===b||("string"!==typeof b||!f("h,m,s",b))&&86400<=c?(b=86400,e="days",d=isNaN(d)?1:b/(d*b)):"string"===typeof b&&"h"===b||("string"!==typeof b||!f("m,s",b))&&3600<=c?(b=3600,e="hours",d=isNaN(d)?4:b/(d*b)):"string"===typeof b&&"m"===b||("string"!==typeof b||!f("s",b))&&60<=c?(b=60,e="minutes",d=isNaN(d)?2:b/(d*b)):(b=1,e="seconds",d=isNaN(d)?.2:b/d);e=Math.round(c*d/b)/d+" "+e;0===e.indexOf("1 ")&&(e=e.substring(0,e.length-1));return e}};window.cookieWrite=window.cookieWrite||function(c,b,d){if("string"===typeof c){var f=window.location.hostname,e=window.location.hostname.split(".").length-1;if(f&&!/^[0-9.]+$/.test(f)){e=2<e?e:2;var k=f.lastIndexOf(".");if(0<=k){for(;0<=k&&1<e;)k=f.lastIndexOf(".",k-1),e--;k=0<k?f.substring(k):f}}g=k;b="undefined"!==typeof b?""+b:"";if(d||""===b)if(""===b&&(d=-60),"number"===typeof d){var h=new Date;h.setTime(h.getTime()+6E4*d)}else h=d;return c&&(document.cookie=encodeURIComponent(c)+"="+encodeURIComponent(b)+"; path=/;"+(d?" expires="+h.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(c)===b:!1}};window.cookieRead=window.cookieRead||function(c){if("string"===typeof c)c=encodeURIComponent(c);else return"";var b=" "+document.cookie,d=b.indexOf(" "+c+"="),f=0>d?d:b.indexOf(";",d);return(c=0>d?"":decodeURIComponent(b.substring(d+2+c.length,0>f?b.length:f)))?c:""};h=new Date;var m=h.getTime(),n=cookieRead("s_tslv")||0,l=Math.round((m-n)/1E3);h.setTime(m+63072E6);cookieWrite("s_tslv",m,h);return n?1800<l||cookieRead("s_inv")?(cookieRead("s_inv")&&(l=cookieRead("s_inv")),cookieWrite("s_inv",l,30),"0"!==l?formatTime(l):"New Visitor"):"":(cookieWrite("s_inv","0",30),"New Visitor")};

module.exports.getTimeSinceLastVisit = getTimeSinceLastVisit;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getTimeToComplete.js": {
          "script": function(module, exports, require, turbine) {

function getTimeToComplete(sos,cn,exp,tp){var f=sos,m=cn,l=exp,e=tp;if("-v"===f)return{plugin:"getTimeToComplete",version:"4.0"};var k=function(){if("undefined"!==typeof window.s_c_il)for(var c=0,b;c<window.s_c_il.length;c++)if(b=window.s_c_il[c],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof k&&(k.contextData.getTimeToComplete="4.0");window.formatTime=window.formatTime||function(c,b,d){function e(b,d,c,e){if("string"!==typeof d)return!1;if("string"===typeof b)b=b.split(c||",");else if("object"!==typeof b)return!1;c=0;for(a=b.length;c<a;c++)if(1==e&&d===b[c]||d.toLowerCase()===b[c].toLowerCase())return!0;return!1}if(!("undefined"===typeof c||isNaN(c)||0>Number(c))){var h="";"string"===typeof b&&"d"===b||("string"!==typeof b||!e("h,m,s",b))&&86400<=c?(b=86400,h="days",d=isNaN(d)?1:b/(d*b)):"string"===typeof b&&"h"===b||("string"!==typeof b||!e("m,s",b))&&3600<=c?(b=3600,h="hours",d=isNaN(d)?4:b/(d*b)):"string"===typeof b&&"m"===b||("string"!==typeof b||!e("s",b))&&60<=c?(b=60,h="minutes",d=isNaN(d)?2:b/(d*b)):(b=1,h="seconds",d=isNaN(d)?.2:b/d);h=Math.round(c*d/b)/d+" "+h;0===h.indexOf("1 ")&&(h=h.substring(0,h.length-1));return h}};window.cookieWrite=window.cookieWrite||function(c,b,d){if("string"===typeof c){var e=window.location.hostname,h=window.location.hostname.split(".").length-1;if(e&&!/^[0-9.]+$/.test(e)){h=2<h?h:2;var f=e.lastIndexOf(".");if(0<=f){for(;0<=f&&1<h;)f=e.lastIndexOf(".",f-1),h--;f=0<f?e.substring(f):e}}g=f;b="undefined"!==typeof b?""+b:"";if(d||""===b)if(""===b&&(d=-60),"number"===typeof d){var k=new Date;k.setTime(k.getTime()+6E4*d)}else k=d;return c&&(document.cookie=encodeURIComponent(c)+"="+encodeURIComponent(b)+"; path=/;"+(d?" expires="+k.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(c)===b:!1}};window.cookieRead=window.cookieRead||function(c){if("string"===typeof c)c=encodeURIComponent(c);else return"";var b=" "+document.cookie,d=b.indexOf(" "+c+"="),e=0>d?d:b.indexOf(";",d);return(c=0>d?"":decodeURIComponent(b.substring(d+2+c.length,0>e?b.length:e)))?c:""};f=f?f.toLowerCase():"start";if("stop"===f||"start"===f){m=m?m:"s_gttc";e?e="d"===e?864E5:"h"===e?36E5:"s"===e?1E3:6E4:(l=30,e=6E4);l=isNaN(l)?30:l;l*=e;k=cookieRead(m);e=new Date;if("stop"===f&&k)return l=Math.round((e.getTime()-k)/1E3),cookieWrite(m,"",0),formatTime(l);"start"!==f||k?k&&Number(k)<e.getTime()+18E5&&cookieWrite(m,k,30):(f=String(e.getTime()),e.setTime(e.getTime()+l),cookieWrite(m,f,e))}};

module.exports.getTimeToComplete = getTimeToComplete;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getValOnce.js": {
          "script": function(module, exports, require, turbine) {

function getValOnce(vtc,cn,et,ep){var e=vtc,k=cn,l=et,m=ep;if(arguments&&"-v"===arguments[0])return{plugin:"getValOnce",version:"3.0"};var c=function(){if("undefined"!==typeof window.s_c_il)for(var b=0,a;b<window.s_c_il.length;b++)if(a=window.s_c_il[b],a._c&&"s_c"===a._c)return a}();"undefined"!==typeof c&&(c.contextData.getValOnce="3.0");window.cookieWrite=window.cookieWrite||function(b,a,d){if("string"===typeof b){var h=window.location.hostname,c=window.location.hostname.split(".").length-1;if(h&&!/^[0-9.]+$/.test(h)){c=2<c?
c:2;var f=h.lastIndexOf(".");if(0<=f){for(;0<=f&&1<c;)f=h.lastIndexOf(".",f-1),c--;f=0<f?h.substring(f):h}}g=f;a="undefined"!==typeof a?""+a:"";if(d||""===a)if(""===a&&(d=-60),"number"===typeof d){var e=new Date;e.setTime(e.getTime()+6E4*d)}else e=d;return b&&(document.cookie=encodeURIComponent(b)+"="+encodeURIComponent(a)+"; path=/;"+(d?" expires="+e.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(b)===a:!1}};window.cookieRead=window.cookieRead||function(b){if("string"===
typeof b)b=encodeURIComponent(b);else return"";var a=" "+document.cookie,d=a.indexOf(" "+b+"="),c=0>d?d:a.indexOf(";",d);return(b=0>d?"":decodeURIComponent(a.substring(d+2+b.length,0>c?a.length:c)))?b:""};return e&&(k=k||"s_gvo",l=l||0,m="m"===m?6E4:864E5,e!==this.c_r(k))?(c=new Date,c.setTime(c.getTime()+l*m),cookieWrite(k,e,0===l?0:m),e):""};

module.exports.getValOnce = getValOnce;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getVisitDuration.js": {
          "script": function(module, exports, require, turbine) {

function getVisitDuration(){if(arguments&&"-v"===arguments[0])return{plugin:"getVisitDuration",version:"2.1"};var d=function(){if("undefined"!==typeof window.s_c_il)for(var c=0,b;c<window.s_c_il.length;c++)if(b=window.s_c_il[c],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof d&&(d.contextData.getVisitDuration="2.1");window.cookieWrite=window.cookieWrite||function(c,b,f){if("string"===typeof c){var h=window.location.hostname,a=window.location.hostname.split(".").length-1;if(h&&!/^[0-9.]+$/.test(h)){a=2<a?a:2;var e=h.lastIndexOf(".");if(0<=e){for(;0<=e&&1<a;)e=h.lastIndexOf(".",e-1),a--;e=0<e?h.substring(e):h}}g=e;b="undefined"!==typeof b?""+b:"";if(f||""===b)if(""===b&&(f=-60),"number"===typeof f){var d=new Date;d.setTime(d.getTime()+6E4*f)}else d=f;return c&&(document.cookie=encodeURIComponent(c)+"="+encodeURIComponent(b)+"; path=/;"+(f?" expires="+d.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof cookieRead)?cookieRead(c)===b:!1}};window.cookieRead=window.cookieRead||function(c){if("string"===typeof c)c=encodeURIComponent(c);else return"";var b=" "+document.cookie,a=b.indexOf(" "+c+"="),d=0>a?a:b.indexOf(";",a);return(c=0>a?"":decodeURIComponent(b.substring(a+2+c.length,0>d?b.length:d)))?c:""};d=(new Date).getTime();var k=cookieRead("s_dur"),a=0;if(isNaN(k)||18E5<d-k)k=d;a=d-k;cookieWrite("s_dur",k+"",30);if(0===a)return"first hit of visit";a=Math.floor(a/6E4);return 0===a?"less than a minute":1===a?"1 minute":a+" minutes"};

module.exports.getVisitDuration = getVisitDuration;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getVisitNum.js": {
          "script": function(module, exports, require, turbine) {

function getVisitNum(rp,erp){var a=rp,l=erp;function m(c){return isNaN(c)?!1:(parseFloat(c)|0)===parseFloat(c)}function n(c){var b=new Date,e=isNaN(c)?0:Math.floor(c);b.setHours(23);b.setMinutes(59);b.setSeconds(59);"w"===c&&(e=6-b.getDay());if("m"===c){e=b.getMonth()+1;var a=b.getFullYear();e=(new Date(a?a:1970,e?e:1,0)).getDate()-b.getDate()}b.setDate(b.getDate()+e);"y"===c&&(b.setMonth(11),b.setDate(31));return b}if("-v"===a)return{plugin:"getVisitNum",version:"4.2"};var f=function(){if("undefined"!==typeof window.s_c_il)for(var c=0,b;c<window.s_c_il.length;c++)if(b=window.s_c_il[c],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof f&&(f.contextData.getVisitNum="4.2");window.cookieWrite=window.cookieWrite||function(c,b,e){if("string"===typeof c){var a=window.location.hostname,d=window.location.hostname.split(".").length-1;if(a&&!/^[0-9.]+$/.test(a)){d=2<d?d:2;var h=a.lastIndexOf(".");if(0<=h){for(;0<=h&&1<d;)h=a.lastIndexOf(".",h-1),d--;h=0<h?a.substring(h):a}}g=h;b="undefined"!==typeof b?""+b:"";if(e||""===b)if(""===b&&(e=-60),"number"===typeof e){var f=new Date;f.setTime(f.getTime()+6E4*e)}else f=e;return c&&(document.cookie=encodeURIComponent(c)+"="+encodeURIComponent(b)+"; path=/;"+(e?" expires="+f.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof window.cookieRead)?window.cookieRead(c)===b:!1}};window.cookieRead=window.cookieRead||function(c){if("string"===typeof c)c=encodeURIComponent(c);else return"";var b=" "+document.cookie,a=b.indexOf(" "+c+"="),d=0>a?a:b.indexOf(";",a);return(c=0>a?"":decodeURIComponent(b.substring(a+2+c.length,0>d?b.length:d)))?c:""};a=a?a:365;l="undefined"!==typeof l?!!l:m(a)?!0:!1;var p=(new Date).getTime();f=n(a);if(window.cookieRead("s_vnc"+a))var d=window.cookieRead("s_vnc"+a).split("&vn="),k=d[1];if(window.cookieRead("s_ivc"))return k?(window.cookieWrite("s_ivc",!0,30),k):"unknown visit number";if("undefined"!==typeof k)return k++,d=l&&m(a)?p+864E5*a:d[0],f.setTime(d),window.cookieWrite("s_vnc"+a,d+"&vn="+k,f),window.cookieWrite("s_ivc",!0,30),k;d=m(a)?p+864E5*a:n(a).getTime();window.cookieWrite("s_vnc"+a,d+"&vn=1",f);window.cookieWrite("s_ivc",!0,30);return"1"};

module.exports.getVisitNum = getVisitNum;
          }

        },
        "common-analytics-plugins/src/lib/plugins/inList.js": {
          "script": function(module, exports, require, turbine) {

function inList(lv,vtc,d,cc){var b=lv,e=vtc,c=d,f=cc;if("-v"===b)return{plugin:"inList",version:"3.0"};a:{if("undefined"!==typeof window.s_c_il){var a=0;for(var d;a<window.s_c_il.length;a++)if(d=window.s_c_il[a],d._c&&"s_c"===d._c){a=d;break a}}a=void 0}"undefined"!==typeof a&&(a.contextData.inList="3.0");if("string"!==typeof e)return!1;if("string"===typeof b)b=b.split(c||",");else if("object"!==typeof b)return!1;c=0;for(a=b.length;c<a;c++)if(1==f&&e===b[c]||e.toLowerCase()===b[c].toLowerCase())return!0;return!1};

module.exports.inList = inList;
          }

        },
        "common-analytics-plugins/src/lib/plugins/lowerCaseVars.js": {
          "script": function(module, exports, require, turbine) {
function lowerCaseVars(v){var s=this;s[v]&&("events"!==v&&-1===v.indexOf("contextData")?(s[v]=s[v].toString(),0!== s[v].indexOf("D=")&&(s[v]=s[v].toLowerCase())):-1<v.indexOf("contextData")&&(v=v.substring(v.indexOf(".")+1),s.contextData[v]&& (s.contextData[v]=s.contextData[v].toString().toLowerCase())))}

module.exports.lowerCaseVars = lowerCaseVars;
          }

        },
        "common-analytics-plugins/src/lib/plugins/manageVars.js": {
          "script": function(module, exports, require, turbine) {

function manageVars(cb,l,il){var g=cb,c=l,d=il;if("-v"===g)return{plugin:"manageVars",version:"3.0"};var f=function(){if("undefined"!==typeof window.s_c_il)for(var a=0,b;a<window.s_c_il.length;a++)if(b=window.s_c_il[a],b._c&&"s_c"===b._c)return b}();if("undefined"!==typeof f){f.contextData.manageVars="3.0";f.blankVars=function(a){this[a]&&(0>a.indexOf("contextData")?this[a]="":(a=a.substring(a.indexOf(".")+1),this.contextData[a]&&(this.contextData[a]="")))};f.lowerCaseVars=function(a){this[a]&&("events"!==a&&-1===a.indexOf("contextData")?(this[a]=this[a].toString(),0!==this[a].indexOf("D=")&&(this[a]=this[a].toLowerCase())):-1<a.indexOf("contextData")&&(a=a.substring(a.indexOf(".")+1),this.contextData[a]&&(this.contextData[a]=this.contextData[a].toString().toLowerCase())))};f.cleanStr=function(a){function b(a){if("string"===typeof a){for(a=a.replace(/<\/?[^>]+(>|$)/g,"").trim().replace(/[\u2018\u2019\u201A]/g,"'").replace(/\t+/g,"").replace(/[\n\r]/g," ");-1<a.indexOf("  ");)a=a.replace(/\s\s/g," ");return a}return""}this[a]&&"function"===typeof b&&(0>a.indexOf("contextData")?this[a]=b(this[a]):(a=a.substring(a.indexOf(".")+1),this.contextData[a]&&(this.contextData[a]=b(this.contextData[a].toString()))))};f.pt=function(a,b,c,d){if(a&&this[c]){a=a.split(b||",");b=a.length;for(var e,f=0;f<b;f++)if(e=this[c](a[f],d))return e}};if(!f[g])return!1;c=c||"";d=d||!0;var b,e="pageName,purchaseID,channel,server,pageType,campaign,state,zip,events,products,transactionID";for(b=1;76>b;b++)e+=",prop"+b;for(b=1;251>b;b++)e+=",eVar"+b;for(b=1;6>b;b++)e+=",hier"+b;for(b=1;4>b;b++)e+=",list"+b;for(b in f.contextData)e+=",contextData."+b;if(c){if(1==d)e=c.replace("['",".").replace("']","");else if(0==d){c=c.split(",");d=e.split(",");e="";for(x in c)for(y in-1<c[x].indexOf("contextData")&&(c[x]="contextData."+c[x].split("'")[1]),d)c[x]===d[y]&&(d[y]="");for(y in d)e+=d[y]?","+d[y]:""}f.pt(e,",",g,0);return!0}return""===c&&d?(f.pt(e,",",g,0),!0):!1}};

module.exports.manageVars = manageVars;
          }

        },
        "common-analytics-plugins/src/lib/plugins/p_fo.js": {
          "script": function(module, exports, require, turbine) {

function p_fo(c){if("-v"===c)return{plugin:"p_fo",version:"3.0"};a:{if("undefined"!==typeof window.s_c_il){var a=0;for(var b;a<window.s_c_il.length;a++)if(b=window.s_c_il[a],b._c&&"s_c"===b._c){a=b;break a}}a=void 0}"undefined"!==typeof a&&(a.contextData.p_fo="3.0");window.__fo||(window.__fo={});if(window.__fo[c])return!1;window.__fo[c]={};return!0};

module.exports.p_fo = p_fo
          }

        },
        "common-analytics-plugins/src/lib/plugins/performanceCheck.js": {
          "script": function(module, exports, require, turbine) {
function performanceCheck(a,b){if(0<=a&&0<=b)return 6E4>a-b&&0<=a-b?parseFloat((a-b)/1E3).toFixed(2):60}

module.exports.performanceCheck = performanceCheck;
          }

        },
        "common-analytics-plugins/src/lib/plugins/performanceWriteFull.js": {
          "script": function(module, exports, require, turbine) {
function performanceWriteFull(){var s=this,a=performance.timing;0<a.loadEventEnd&&(clearInterval(s.pi),""===s.c_r("s_plt")&& (s.c_w("s_plt",s.performanceCheck(a.loadEventEnd,a.navigationStart)),s.c_w("s_pltp",s.pageName)));s.ptc=a.loadEventEnd}

module.exports.performanceWriteFull = performanceWriteFull;
          }

        },
        "common-analytics-plugins/src/lib/plugins/performanceWritePart.js": {
          "script": function(module, exports, require, turbine) {
function performanceWritePart(){var s=this,a=performance;0<a.getEntries().length&&(s.ppfe===a.getEntries().length? clearInterval(s.pwp):s.ppfe=a.getEntries().length);""===s.c_r("s_plt")&&(s.c_w("s_plt",((a.getEntries()[a.getEntries().length-1].responseEnd-a.getEntries()[0].startTime)/1E3).toFixed(2)),s.c_w("s_pltp",s.pageName))}

module.exports.performanceWritePart = performanceWritePart;
          }

        },
        "common-analytics-plugins/src/lib/plugins/handlePPVevents.js": {
          "script": function(module, exports, require, turbine) {

function handlePPVevents(){if("undefined"!==typeof s_c_il){for(var c=0,g=s_c_il.length;c<g;c++)if(s_c_il[c]&&(s_c_il[c].getPercentPageViewed||s_c_il[c].getPreviousPageActivity)){var s=s_c_il[c];break}if(s&&s.ppvID){var f=Math.max(Math.max(document.body.scrollHeight,document.documentElement.scrollHeight),Math.max(document.body.offsetHeight,document.documentElement.offsetHeight),Math.max(document.body.clientHeight,document.documentElement.clientHeight)),h=window.innerHeight||document.documentElement.clientHeight||
document.body.clientHeight;c=(window.pageYOffset||window.document.documentElement.scrollTop||window.document.body.scrollTop)+h;g=Math.min(Math.round(c/f*100),100);var k=Math.floor(c/h);h=Math.floor(f/h);var d="";if(!s.c_r("s_tp")||s.unescape(s.c_r("s_ppv").split(",")[0])!==s.ppvID||s.p_fo(s.ppvID)||1==s.ppvChange&&s.c_r("s_tp")&&f!=s.c_r("s_tp")){(s.unescape(s.c_r("s_ppv").split(",")[0])!==s.ppvID||s.p_fo(s.ppvID+"1"))&&s.c_w("s_ips",c);if(s.c_r("s_tp")&&s.unescape(s.c_r("s_ppv").split(",")[0])===
s.ppvID){s.c_r("s_tp");d=s.c_r("s_ppv");var e=-1<d.indexOf(",")?d.split(","):[];d=e[0]?e[0]:"";e=e[3]?e[3]:"";var l=s.c_r("s_ips");d=d+","+Math.round(e/f*100)+","+Math.round(l/f*100)+","+e+","+k}s.c_w("s_tp",f)}else d=s.c_r("s_ppv");var b=d&&-1<d.indexOf(",")?d.split(",",6):[];f=0<b.length?b[0]:escape(s.ppvID);e=1<b.length?parseInt(b[1]):g;l=2<b.length?parseInt(b[2]):g;var m=3<b.length?parseInt(b[3]):c,n=4<b.length?parseInt(b[4]):k;b=5<b.length?parseInt(b[5]):h;0<g&&(d=f+","+(g>e?g:e)+","+l+","+(c>
m?c:m)+","+(k>n?k:n)+","+(h>b?h:b));s.c_w("s_ppv",d)}}}

module.exports.handlePPVevents = handlePPVevents;
          }

        },
        "common-analytics-plugins/src/lib/plugins/getPercentPageViewed.js": {
          "script": function(module, exports, require, turbine) {

function getPercentPageViewed(pid,ch){var n=pid,r=ch;function p(){if(window.ppvID){var a=Math.max(Math.max(document.body.scrollHeight,document.documentElement.scrollHeight),Math.max(document.body.offsetHeight,document.documentElement.offsetHeight),Math.max(document.body.clientHeight,document.documentElement.clientHeight)),b=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight,d=(window.pageYOffset||window.document.documentElement.scrollTop||window.document.body.scrollTop)+b,f=Math.min(Math.round(d/a*100),100),l=Math.floor(d/b);b=Math.floor(a/b);var c="";if(!window.cookieRead("s_tp")||decodeURIComponent(window.cookieRead("s_ppv").split(",")[0])!==window.ppvID||window.p_fo(window.ppvID)||1==window.ppvChange&&window.cookieRead("s_tp")&&a!=window.cookieRead("s_tp")){(decodeURIComponent(window.cookieRead("s_ppv").split(",")[0])!==window.ppvID||window.p_fo(window.ppvID+"1"))&&window.cookieWrite("s_ips",d);if(window.cookieRead("s_tp")&&decodeURIComponent(window.cookieRead("s_ppv").split(",")[0])===window.ppvID){window.cookieRead("s_tp");c=window.cookieRead("s_ppv");var h=-1<c.indexOf(",")?c.split(","):[];c=h[0]?h[0]:"";h=h[3]?h[3]:"";var q=window.cookieRead("s_ips");c=c+","+Math.round(h/a*100)+","+Math.round(q/a*100)+","+h+","+l}window.cookieWrite("s_tp",a)}else c=window.cookieRead("s_ppv");var k=c&&-1<c.indexOf(",")?c.split(",",6):[];a=0<k.length?k[0]:encodeURIComponent(window.ppvID);h=1<k.length?parseInt(k[1]):f;q=2<k.length?parseInt(k[2]):f;var t=3<k.length?parseInt(k[3]):d,u=4<k.length?parseInt(k[4]):l;k=5<k.length?parseInt(k[5]):b;0<f&&(c=a+","+(f>h?f:h)+","+q+","+(d>t?d:t)+","+(l>u?l:u)+","+(b>k?b:k));window.cookieWrite("s_ppv",c)}}if("-v"===n)return{plugin:"getPercentPageViewed",version:"5.0.1"};var m=function(){if("undefined"!==typeof window.s_c_il)for(var a=0,b;a<window.s_c_il.length;a++)if(b=window.s_c_il[a],b._c&&"s_c"===b._c)return b}();"undefined"!==typeof m&&(m.contextData.getPercentPageViewed="5.0.1");window.pageName="undefined"!==typeof m&&m.pageName||"";window.cookieWrite=window.cookieWrite||function(a,b,d){if("string"===typeof a){var f=window.location.hostname,l=window.location.hostname.split(".").length-1;if(f&&!/^[0-9.]+$/.test(f)){l=2<l?l:2;var c=f.lastIndexOf(".");if(0<=c){for(;0<=c&&1<l;)c=f.lastIndexOf(".",c-1),l--;c=0<c?f.substring(c):f}}g=c;b="undefined"!==typeof b?""+b:"";if(d||""===b)if(""===b&&(d=-60),"number"===typeof d){var h=new Date;h.setTime(h.getTime()+6E4*d)}else h=d;return a&&(document.cookie=encodeURIComponent(a)+"="+encodeURIComponent(b)+"; path=/;"+(d?" expires="+h.toUTCString()+";":"")+(g?" domain="+g+";":""),"undefined"!==typeof window.cookieRead)?window.cookieRead(a)===b:!1}};window.cookieRead=window.cookieRead||function(a){if("string"===typeof a)a=encodeURIComponent(a);else return"";var b=" "+document.cookie,d=b.indexOf(" "+a+"="),f=0>d?d:b.indexOf(";",d);return(a=0>d?"":decodeURIComponent(b.substring(d+2+a.length,0>f?b.length:f)))?a:""};window.p_fo=window.p_fo||function(a){window.__fo||(window.__fo={});if(window.__fo[a])return!1;window.__fo[a]={};return!0};var e=window.cookieRead("s_ppv");e=-1<e.indexOf(",")?e.split(","):[];n=n?n:window.pageName?window.pageName:document.location.href;e[0]=decodeURIComponent(e[0]);window.ppvChange="undefined"===typeof r||1==r?!0:!1;"undefined"!==typeof m&&m.linkType&&"o"===m.linkType||(window.ppvID&&window.ppvID===n||(window.ppvID=n,window.cookieWrite("s_ppv",""),p()),window.p_fo("s_gppvLoad")&&window.addEventListener&&(window.addEventListener("load",p,!1),window.addEventListener("click",p,!1),window.addEventListener("scroll",p,!1)),this._ppvPreviousPage=e[0]?e[0]:"",this._ppvHighestPercentViewed=e[1]?e[1]:"",this._ppvInitialPercentViewed=e[2]?e[2]:"",this._ppvHighestPixelsSeen=e[3]?e[3]:"",this._ppvFoldsSeen=e[4]?e[4]:"",this._ppvFoldsAvailable=e[5]?e[5]:"")};

module.exports.getPercentPageViewed = getPercentPageViewed;
          }

        },
        "common-analytics-plugins/src/lib/plugins/pt.js": {
          "script": function(module, exports, require, turbine) {

function pt(l,de,cf,fa){var b=l,d=de,f=cf,g=fa;if("-v"===b)return{plugin:"pt",version:"3.0"};a:{if("undefined"!==typeof window.s_c_il){var a=0;for(var c;a<window.s_c_il.length;a++)if(c=window.s_c_il[a],c._c&&"s_c"===c._c){a=c;break a}}a=void 0}if("undefined"!==typeof a&&(a.contextData.pt="3.0",b&&a[f])){b=b.split(d||",");d=b.length;for(var e=0;e<d;e++)if(c=a[f](b[e],g))return c}};

module.exports.pt = pt;
          }

        },
        "common-analytics-plugins/src/lib/plugins/rfl.js": {
          "script": function(module, exports, require, turbine) {

function rfl(lv,vr,d1,d2,df){var b=lv,f=vr,e=d1,h=d2,g=df;if("-v"===b)return{plugin:"rfl",version:"2.1"};a:{if("undefined"!==typeof window.s_c_il){var c=0;for(var a;c<window.s_c_il.length;c++)if(a=window.s_c_il[c],a._c&&"s_c"===a._c){c=a;break a}}c=void 0}"undefined"!==typeof c&&(c.contextData.rfl="2.1");if(!b||!f)return"";c=[];a="";e=e||",";h=h||e;g=g||!1;b=b.split(e);e=b.length;for(var d=0;d<e;d++)-1<b[d].indexOf(":")&&(a=b[d].split(":"),a[1]=a[0]+":"+a[1],b[d]=a[0]),-1<b[d].indexOf("=")&&(a=b[d].split("="),a[1]=a[0]+"="+a[1],b[d]=a[0]),b[d]!==f&&a?c.push(a[1]):b[d]!==f?c.push(b[d]):b[d]===f&&g&&(a?c.push(a[1]):c.push(b[d]),g=!1),a="";return c.join(h)};

module.exports.rfl = rfl;
          }

        },
        "common-analytics-plugins/src/lib/plugins/twoDecimals.js": {
          "script": function(module, exports, require, turbine) {

function twoDecimals(v){return"undefined"===typeof v||void 0===v||isNaN(v)?0:Number(Number(v).toFixed(2))};

module.exports.twoDecimals = twoDecimals;
          }

        },
        "common-analytics-plugins/src/lib/plugins/zeroPad.js": {
          "script": function(module, exports, require, turbine) {

function zeroPad(num,nod){num=parseInt(num);nod=parseInt(nod);if(isNaN(num)||isNaN(nod))return"";var c=nod-num.toString().length+1;return Array(+(0<c&&c)).join("0")+num};

module.exports.zeroPad = zeroPad;
          }

        },
        "common-analytics-plugins/src/lib/plugins/randomNumber.js": {
          "script": function(module, exports, require, turbine) {

function randomNumber(nod){nod="number"===typeof nod?17>Math.abs(nod)?Math.round(Math.abs(nod)):17:10;for(var a="1",c=0;c<nod;c++)a+="0";a=Number(a);a=Math.floor(Math.random().toFixed(nod)*a)+"";a.length!==nod&&"undefined"!==typeof zeroPad&&(a=zeroPad(a,nod));return a};

module.exports.randomNumber = randomNumber;
          }

        }
      }
    },
    "adobe-analytics": {
      "displayName": "Adobe Analytics",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EPb56e12d7054b4acea984e91c910051cc/",
      "settings": {
        "orgId": "88743E6A5A74B5900A495D61@AdobeOrg",
        "customSetup": {
          "source": function(s) {
  s.usePlugins=true;
s.trackInlineStats=false;
s.cookieDomain = _satellite.getVar("Content | Domain");
function s_doPlugins(s) {
  s.account =  _satellite.getVar("Analytics | Account");
  s.eVar39 = _satellite.getVisitorId().getMarketingCloudVisitorID();
  if ((s.linkType == "o") || (s.linkType == "d") || (s.linkType == "e")){
   s.linkTrackVars= s.linkTrackVars+",prop6,prop7,eVar5,eVar39,events,eVar14,eVar15,contextData.cm.ssf,eVar3,eVar4";
  }
  s.eVar5  = _satellite.getVar("Content | Form Factor");
  s.prop7  = s.eVar47 = _satellite.getVar("Content | Site");
  s.eVar49 = s.getCustomTimeParting("n", '1','h');
  s.server = _satellite.getVar("Content | Domain"); 
  s.eVar15 = _satellite.getVar("User | User ID");
  s.eVar3 = _satellite.getVar("Content | url");
  s.eVar4 = _satellite.getVar("Content | Page Name");
  if (s.eVar16 || s.eVar17 || s.eVar22){
    s.linkTrackVars= s.linkTrackVars+",prop8,prop9,prop10";
    s.prop8= "D=v16";s.prop9= "D=v17";s.prop10= "D=v22";
  }
  if(!s.eVar14 || s.eVar14 == "")s.eVar14 = _satellite.getVar("Content | Loggedin Status");

  var forwardAAM = false;
  _satellite.logger.log("page fired.", _satellite.getVar("AA | page url"), _satellite.getVar("AAM | exception url"));
  _satellite.logger.log("link fired.", _satellite.getVar("AA | link name"),_satellite.getVar("AAM | exception link name"));

    if(s.linkType == "o"){
    if(_satellite.getVar("AAM | exception link name") != "true"){
      forwardAAM = true;
    }
  }else if(s.linkType != "e" && s.linkType != "d"){
     _satellite.logger.log("s.t() fired.");
    if(_satellite.getVar("AAM | exception url") == "true"){
      forwardAAM = true;

     }
  }
  if(!forwardAAM){
   s.contextData['cm.ssf'] = 1;
   _satellite.logger.log("set cm.ssf fired.",s.contextData['cm.ssf']);
  }else{
     s.contextData['cm.ssf'] = 0;
    _satellite.logger.log("no cm.ssf fired.",s.contextData['cm.ssf']);
  }
}



if (typeof s.ActivityMap === 'object') {
   s.ActivityMap.link = function() {
   return false;
  };
}

s.doPlugins=s_doPlugins

s._tpDST={ 2020:"3/29,10/25",2021:"3/28,10/31",2022:"3/27,10/30",2023:"3/26,10/29",2024:"3/31,10/27",2025:"3/30,10/26",2026:"3/29,10/25",2027:"3/28,10/31",2028:"3/26,10/29",2029:"3/25,10/28",2030:"3/24,10/27"};

s.getCustomTimeParting=function(e,t,a){var n;if(6!=(n=new Date("1/1/2000")).getDay()||0!=n.getMonth())return"Data Not Available";var r,g,u,D,i,s,l,d,o,y,T=new Date;if(t=t||0,t=parseFloat(t),this._tpDST){var h=this._tpDST[T.getFullYear()].split(/,/);i=new Date(h[0]+"/"+T.getFullYear()),o=new Date(h[1]+"/"+T.getFullYear()),"n"==e&&T>i&&T<o?t+=1:"s"==e&&(T>o||T<i)&&(t+=1)}return T=T.getTime()+6e4*T.getTimezoneOffset(),s=(T=new Date(T+36e5*t)).getDate(),l=T.getMonth()+1,d=T.getFullYear(),s<10&&(s="0"+s),l<10&&(l="0"+l),r=T.getHours(),g=(g=T.getMinutes())<10?"0"+g:g,u=T.getDay(),D=" AM",HD=r,r>=12&&(D=" PM",r-=12),0==r&&(r=12),u=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"][u],y=r+":"+g+D,"D"==a?u:"d"==a?s+"/"+l+"/"+d:"dt"==a?s+"/"+l+"/"+d+"|"+y:"h"==a?HD+":00":y+"|"+u};
}
        },
        "libraryCode": {
          "type": "managed",
          "accounts": {
            "staging": [
              "%Analytics | Account%"
            ],
            "production": [
              "%Analytics | Account%"
            ],
            "development": [
              "%Analytics | Account%"
            ]
          },
          "useActivityMap": true,
          "scopeTrackerGlobally": true
        },
        "moduleProperties": {
          "audienceManager": {
            "config": {
              "partner": "svenskaspel"
            }
          }
        },
        "trackerProperties": {
          "charSet": "UTF-8",
          "currencyCode": "SEK",
          "trackingServer": "metricstur.www.svenskaspel.se",
          "trackInlineStats": false,
          "trackDownloadLinks": false,
          "trackExternalLinks": false,
          "writeSecureCookies": true,
          "trackingServerSecure": "smetricstur.www.svenskaspel.se"
        }
      },
      "modules": {
        "adobe-analytics/src/lib/actions/setVariables.js": {
          "name": "set-variables",
          "displayName": "Set Variables",
          "script": function(module, exports, require, turbine) {

'use strict';

var getTracker = require('../sharedModules/getTracker');
var applyTrackerVariables = require('../helpers/applyTrackerVariables');

module.exports = function(settings, event) {
  return getTracker().then(function(tracker) {
    turbine.logger.info('Set variables on the tracker.');
    applyTrackerVariables(tracker, settings.trackerProperties);
    if (settings.customSetup && settings.customSetup.source) {
      settings.customSetup.source.call(event.element, event, tracker);
    }
  }, function(errorMessage) {
    turbine.logger.error(
      'Cannot set variables: ' +
      errorMessage
    );
  });
};

          }

        },
        "adobe-analytics/src/lib/actions/clearVariables.js": {
          "name": "clear-variables",
          "displayName": "Clear Variables",
          "script": function(module, exports, require, turbine) {

'use strict';

var getTracker = require('../sharedModules/getTracker');

module.exports = function() {
  return getTracker().then(function(tracker) {
    if (tracker.clearVars) {
      turbine.logger.info('Clear variables.');
      tracker.clearVars();
    }
  }, function(errorMessage) {
    turbine.logger.error(
      'Cannot clear variables: ' +
      errorMessage
    );
  });
};

          }

        },
        "adobe-analytics/src/lib/actions/sendBeacon.js": {
          "name": "send-beacon",
          "displayName": "Send Beacon",
          "script": function(module, exports, require, turbine) {

'use strict';

var getTracker = require('../sharedModules/getTracker');
var getNodeLinkText = require('../helpers/getNodeLinkText');

var isLink = function(element) {
  return element && element.nodeName && element.nodeName.toLowerCase() === 'a';
};

var getLinkName = function(element) {
  if (isLink(element)) {
    return getNodeLinkText(element);
  } else {
    return 'link clicked';
  }
};

var sendBeacon = function(tracker, settings, targetElement) {
  if (settings.type === 'page') {
    turbine.logger.info('Firing page view beacon.');
    tracker.t();
  } else {
    var linkSettings = {
      linkType: settings.linkType || 'o',
      linkName: settings.linkName || getLinkName(targetElement)
    };

    turbine.logger.info(
      'Firing link track beacon using the values: ' +
      JSON.stringify(linkSettings) + '.'
    );

    tracker.tl(
      isLink(targetElement) ? targetElement : 'true',
      linkSettings.linkType,
      linkSettings.linkName
    );
  }
};

module.exports = function(settings, event) {
  return getTracker().then(function(tracker) {
    sendBeacon(tracker, settings, event.element);
  }, function(errorMessage) {
    turbine.logger.error(
      'Cannot send beacon: ' +
      errorMessage
    );
  });
};

          }

        },
        "adobe-analytics/src/lib/sharedModules/getTracker.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var cookie = require('@adobe/reactor-cookie');
var Promise = require('@adobe/reactor-promise');
var window = require('@adobe/reactor-window');
var settingsHelper = require('../helpers/settingsHelper');
var augmenters = require('../helpers/augmenters');

var applyTrackerVariables = require('../helpers/applyTrackerVariables');
var loadLibrary = require('../helpers/loadLibrary');
var generateVersion = require('../helpers/generateVersion');

var version = generateVersion(turbine.buildInfo.turbineBuildDate);
var BEFORE_SETTINGS_LOAD_PHASE = 'beforeSettings';

var mcidInstance = turbine.getSharedModule('adobe-mcid', 'mcid-instance');

var checkEuCompliance = function(trackingCoookieName) {
  if (!trackingCoookieName) {
    return true;
  }

  var euCookieValue = cookie.get(trackingCoookieName);
  return euCookieValue === 'true';
};

var augmentTracker = function(tracker) {
  return Promise.all(augmenters.map(function(augmenterFn) {
    var result;

    try {
      result = augmenterFn(tracker);
    } catch (e) {
      setTimeout(function() {
        throw e;
      });
    }

    return Promise.resolve(result);
  })).then(function() {
    return tracker;
  });
};

var linkVisitorId = function(tracker) {
  if (mcidInstance) {
    turbine.logger.info('Setting MCID instance on the tracker.');
    tracker.visitor = mcidInstance;
  }

  return tracker;
};

var updateTrackerVersion = function(tracker) {
  turbine.logger.info('Setting version on tracker: "' + version + '".');

  if (typeof tracker.tagContainerMarker !== 'undefined') {
    tracker.tagContainerMarker = version;
  } else if (typeof tracker.version === 'string'
    && tracker.version.substring(tracker.version.length - 5) !== ('-' + version)) {
    tracker.version += '-' + version;
  }

  return tracker;
};

var updateTrackerVariables = function(trackerProperties, customSetup, tracker) {
  if (customSetup.loadPhase === BEFORE_SETTINGS_LOAD_PHASE && customSetup.source) {
    turbine.logger.info('Calling custom script before settings.');
    customSetup.source.call(window, tracker);
  }

  applyTrackerVariables(tracker, trackerProperties || {});

  if (customSetup.loadPhase !== BEFORE_SETTINGS_LOAD_PHASE && customSetup.source) {
    turbine.logger.info('Calling custom script after settings.');
    customSetup.source.call(window, tracker);
  }

  return tracker;
};

var initializeAudienceManagement = function(settings, tracker) {
  if (settingsHelper.isAudienceManagementEnabled(settings)) {
    tracker.loadModule('AudienceManagement');
    turbine.logger.info('Initializing AudienceManagement module');
    tracker.AudienceManagement.setup(settings.moduleProperties.audienceManager.config);
  }
  return tracker;
};

var initialize = function(settings) {
  if (checkEuCompliance(settings.trackingCookieName)) {
    return loadLibrary(settings)
      .then(augmentTracker)
      .then(linkVisitorId)
      .then(updateTrackerVersion)
      .then(updateTrackerVariables.bind(
        null,
        settings.trackerProperties,
        settings.customSetup || {}
      ))
      .then(initializeAudienceManagement.bind(null, settings));
  } else {
    return Promise.reject('EU compliance was not acknowledged by the user.');
  }
};

var promise = initialize(turbine.getExtensionSettings());
module.exports = function() {
  return promise;
};

          }
,
          "name": "get-tracker",
          "shared": true
        },
        "adobe-analytics/src/lib/sharedModules/augmentTracker.js": {
          "name": "augment-tracker",
          "shared": true,
          "script": function(module, exports, require, turbine) {

'use strict';

var augmenters = require('../helpers/augmenters');

module.exports = function(fn) {
  augmenters.push(fn);
};

          }

        },
        "adobe-analytics/src/lib/helpers/applyTrackerVariables.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var queryString = require('@adobe/reactor-query-string');
var window = require('@adobe/reactor-window');

var eVarRegExp = /eVar([0-9]+)/;
var propRegExp = /prop([0-9]+)/;
var linkTrackVarsKeys = new RegExp('^(eVar[0-9]+)|(prop[0-9]+)|(hier[0-9]+)|campaign|purchaseID|' +
  'channel|server|state|zip|pageType$');

var onlyUnique = function(value, index, self) {
  return self.indexOf(value) === index;
};

var buildLinkTrackVars = function(tracker, newTrackerProperties, addEvents) {
  var linkTrackVarsValues = Object.keys(newTrackerProperties)
    .filter(linkTrackVarsKeys.test.bind(linkTrackVarsKeys));

  if (addEvents) {
    linkTrackVarsValues.push('events');
  }

  linkTrackVarsValues = linkTrackVarsValues.concat((tracker.linkTrackVars || '').split(','));

  return linkTrackVarsValues.filter(function(value, index) {
    return value !== 'None' && value && onlyUnique(value, index, linkTrackVarsValues);
  }).join(',');
};

var buildLinkTrackEvents = function(tracker, eventsData) {
  var linkTrackEventsValues = eventsData.map(function(event) {
    return event.name;
  });

  linkTrackEventsValues = linkTrackEventsValues.concat((tracker.linkTrackEvents || '').split(','));

  return linkTrackEventsValues.filter(function(value, index) {
    return value !== 'None'  && onlyUnique(value, index, linkTrackEventsValues);
  }).join(',');
};

var commaJoin = function(store, keyName, trackerProperties) {
  store[keyName] = trackerProperties[keyName].join(',');
};

var variablesTransform = function(store, keyName, trackerProperties) {
  var dynamicVariablePrefix = trackerProperties.dynamicVariablePrefix || 'D=';

  trackerProperties[keyName].forEach(function(variableData) {
    var value;
    if (variableData.type === 'value') {
      value = variableData.value;
    } else {
      var eVarData = eVarRegExp.exec(variableData.value);

      if (eVarData) {
        value = dynamicVariablePrefix + 'v' + eVarData[1];
      } else {
        var propData = propRegExp.exec(variableData.value);

        if (propData) {
          value = dynamicVariablePrefix + 'c' + propData[1];
        }
      }
    }

    store[variableData.name] = value;
  });
};

var transformers = {
  linkDownloadFileTypes: commaJoin,
  linkExternalFilters: commaJoin,
  linkInternalFilters: commaJoin,
  hierarchies: function(store, keyName, trackerProperties) {
    trackerProperties[keyName].forEach(function(hierarchyData) {
      store[hierarchyData.name] = hierarchyData.sections.join(hierarchyData.delimiter);
    });
  },
  props: variablesTransform,
  eVars: variablesTransform,
  campaign: function(store, keyName, trackerProperties) {
    if (trackerProperties[keyName].type === 'queryParam') {
      var queryParams = queryString.parse(window.location.search);
      store[keyName] = queryParams[trackerProperties[keyName].value];
    } else {
      store[keyName] = trackerProperties[keyName].value;
    }
  },
  events: function(store, keyName, trackerProperties) {
    var events = trackerProperties[keyName].map(function(data) {
      var entry = data.name;
      if (data.id) {
        entry = [entry, data.id].join(':');
      }
      if (data.value) {
        entry = [entry, data.value].join('=');
      }
      return entry;
    });
    store[keyName] = events.join(',');
  }
};

module.exports = function(tracker, trackerProperties) {
  var newProperties = {};
  trackerProperties = trackerProperties || {};

  Object.keys(trackerProperties).forEach(function(propertyName) {
    var transform = transformers[propertyName];
    var value = trackerProperties[propertyName];

    if (transform) {
      transform(newProperties, propertyName, trackerProperties);
    } else {
      newProperties[propertyName] = value;
    }
  });

  if (newProperties.events) {
    if (tracker.events && tracker.events.length > 0) {
      newProperties.events = tracker.events + ',' + newProperties.events;
    }
  }

  var hasEvents =
    trackerProperties && trackerProperties.events && trackerProperties.events.length > 0;
  var linkTrackVars = buildLinkTrackVars(tracker, newProperties, hasEvents);
  if (linkTrackVars) {
    newProperties.linkTrackVars = linkTrackVars;
  }

  var linkTrackEvents = buildLinkTrackEvents(tracker, trackerProperties.events || []);
  if (linkTrackEvents) {
    newProperties.linkTrackEvents = linkTrackEvents;
  }

  turbine.logger.info(
    'Applying the following properties on tracker: "' +
    JSON.stringify(newProperties) +
    '".'
  );

  Object.keys(newProperties).forEach(function(propertyName) {
    tracker[propertyName] = newProperties[propertyName];
  });
};

          }

        },
        "adobe-analytics/src/lib/helpers/settingsHelper.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var window = require('@adobe/reactor-window');

var settingsHelper = {
  LIB_TYPES: {
    MANAGED: 'managed',
    PREINSTALLED: 'preinstalled',
    REMOTE: 'remote',
    CUSTOM: 'custom'
  },

  MANAGED_LIB_PATHS: {
    APP_MEASUREMENT: 'AppMeasurement.js',
    ACTIVITY_MAP: 'AppMeasurement_Module_ActivityMap.js',
    AUDIENCE_MANAGEMENT: 'AppMeasurement_Module_AudienceManagement.js',
  },

  getReportSuites: function(reportSuitesData) {
    var reportSuiteValues = reportSuitesData.production;
    if (reportSuitesData[turbine.environment.stage]) {
      reportSuiteValues = reportSuitesData[turbine.environment.stage];
    }

    return reportSuiteValues.join(',');
  },

  isActivityMapEnabled: function(settings) {
    return !(settings.libraryCode &&
      !settings.libraryCode.useActivityMap &&
      settings.libraryCode.useActivityMap === false);
  },

  isAudienceManagementEnabled: function(settings) {
    var isEnabled = false;
    if (settings &&
      settings.moduleProperties &&
      settings.moduleProperties.audienceManager &&
      settings.moduleProperties.audienceManager.config &&
      window &&
      window._satellite &&
      window._satellite.company &&
      window._satellite.company.orgId) {
      isEnabled = true;
    }

    return isEnabled;
  }
};

module.exports = settingsHelper;

          }

        },
        "adobe-analytics/src/lib/helpers/augmenters.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = [];

          }

        },
        "adobe-analytics/src/lib/helpers/loadLibrary.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var loadScript = require('@adobe/reactor-load-script');
var window = require('@adobe/reactor-window');
var Promise = require('@adobe/reactor-promise');
var settingsHelper = require('./settingsHelper');
var pollHelper = require('./pollHelper');

var createTracker = function(settings, reportSuites) {
  if (!window.s_gi) {
    throw new Error(
      'Unable to create AppMeasurement tracker, `s_gi` function not found.' + window.AppMeasurement
    );
  }
  turbine.logger.info('Creating AppMeasurement tracker with these report suites: "' +
    reportSuites + '"');
  var tracker = window.s_gi(reportSuites);
  if (settings.libraryCode.scopeTrackerGlobally) {
    turbine.logger.info('Setting the tracker as window.s');
    window.s = tracker;
  }
  return tracker;
};

var getUrlsToLoad = function(settings) {
  var urls = [];
  switch (settings.libraryCode.type) {
    case settingsHelper.LIB_TYPES.MANAGED:
      urls.push(turbine.getHostedLibFileUrl(settingsHelper.MANAGED_LIB_PATHS.APP_MEASUREMENT));
      if (settingsHelper.isActivityMapEnabled(settings)) {
        urls.push(turbine.getHostedLibFileUrl(settingsHelper.MANAGED_LIB_PATHS.ACTIVITY_MAP));
      }
      break;
    case settingsHelper.LIB_TYPES.CUSTOM:
      urls.push(settings.libraryCode.source);
      break;
    case settingsHelper.LIB_TYPES.REMOTE:
      urls.push(window.location.protocol === 'https:' ?
        settings.libraryCode.httpsUrl : settings.libraryCode.httpUrl);
      break;
  }
  if (settingsHelper.isAudienceManagementEnabled(settings)) {
    var visitorServiceConfig = {
      namespace: window._satellite.company.orgId
    };
    settings.moduleProperties.audienceManager.config.visitorService = visitorServiceConfig;
    urls.push(turbine.getHostedLibFileUrl(settingsHelper.MANAGED_LIB_PATHS.AUDIENCE_MANAGEMENT));
  }
  return urls;
};

var loadLibraryScripts = function(settings) {
  return Promise.all(getUrlsToLoad(settings).map(function(url) {
    turbine.logger.info("Loading script: " + url);
    return loadScript(url);
  }));
};

var setReportSuitesOnTracker = function(settings, tracker) {
  if (settings.libraryCode.accounts) {
    if (!tracker.sa) {
      turbine.logger.warn('Cannot set report suites on tracker. `sa` method not available.');
    } else {
      var reportSuites = settingsHelper.getReportSuites(settings.libraryCode.accounts);
      turbine.logger.info('Setting the following report suites on the tracker: "' +
        reportSuites + '"');
      tracker.sa(reportSuites);
    }
  }

  return tracker;
};

var getTrackerFromVariable = function(trackerVariableName) {
  if (window[trackerVariableName]) {
    turbine.logger.info('Found tracker located at: "' + trackerVariableName + '".');
    return window[trackerVariableName];
  } else {
    throw new Error('Cannot find the global variable name: "' + trackerVariableName + '".');
  }
};

module.exports = function(settings) {
  var loadLibraries = loadLibraryScripts(settings);

  switch (settings.libraryCode.type) {
    case settingsHelper.LIB_TYPES.MANAGED:
      var reportSuites = settingsHelper.getReportSuites(settings.libraryCode.accounts);
      return loadLibraries
        .then(createTracker.bind(null, settings, reportSuites));

    case settingsHelper.LIB_TYPES.PREINSTALLED:
      return loadLibraries
        .then(pollHelper.poll.bind(null, window, settings.libraryCode.trackerVariableName))
        .then(setReportSuitesOnTracker.bind(null, settings));

    case settingsHelper.LIB_TYPES.CUSTOM:
    case settingsHelper.LIB_TYPES.REMOTE:
      return loadLibraries
        .then(getTrackerFromVariable.bind(null, settings.libraryCode.trackerVariableName))
        .then(setReportSuitesOnTracker.bind(null, settings));

    default:
      throw new Error('Cannot load library. Type not supported.');

  }
};

          }

        },
        "adobe-analytics/src/lib/helpers/generateVersion.js": {
          "script": function(module, exports, require, turbine) {


'use strict';

var THIRD_OF_DAY = 8; 

var getDayField = function(date) {
  return date.getUTCDate().toString(36);
};

var getLastChar = function(str) {
  return str.substr(str.length - 1);
};

var getRevision = function(date) {
  return Math.floor(date.getUTCHours() / THIRD_OF_DAY);
};

var getMonthField = function(date) {
  var monthNumber = date.getUTCMonth() + 1;
  var revision = getRevision(date);

  var monthField = (monthNumber + revision * 12).toString(36);

  return getLastChar(monthField);
};

var getYearField = function(date) {
  return (date.getUTCFullYear() - 2010).toString(36);
};

module.exports = function(dateString) {
  var date = new Date(dateString);

  if (isNaN(date)) {
    throw new Error('Invalid date provided');
  }

  return ('L' + getYearField(date) + getMonthField(date) + getDayField(date)).toUpperCase();
};

          }

        },
        "adobe-analytics/src/lib/helpers/pollHelper.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var Promise = require('@adobe/reactor-promise');

var MAX_ITERATIONS = 40;
var INTERVAL = 250;

var found = function(resolve, variableName, result) {
  turbine.logger.info('Found property located at: "' + variableName + '"].');
  resolve(result);
};

var getPromise = function(object, variableName) {
  return new Promise(function(resolve, reject) {
    if (object[variableName]) {
      return found(resolve, variableName, object[variableName]);
    }
    var i = 1;
    var intervalId = setInterval(function() {
      if (object[variableName]) {
        found(resolve, variableName, object[variableName]);
        clearInterval(intervalId);
      }
      if (i >= MAX_ITERATIONS) {
        clearInterval(intervalId);
        reject(new Error(
          'Bailing out. Cannot find the variable name: "' + variableName + '"].'));
      }
      i++;
    }, INTERVAL); 
  });
};

module.exports = {
  poll: function(object, variableName) {
    turbine.logger.info('Waiting for the property to become accessible at: "'
      + variableName + '"].');
    return getPromise(object, variableName);
  }
};

          }

        },
        "adobe-analytics/src/lib/helpers/getNodeLinkText.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var truncateWhiteSpace = function(str) {
  return str && str.replace(/\s+/g, ' ').trim();
};

var unsupportedNodeNames = /^(SCRIPT|STYLE|LINK|CANVAS|NOSCRIPT|#COMMENT)$/i;

var isSupportedTextNode = function(node) {
  if (node && node.nodeName) {
    if (node.nodeName.match(unsupportedNodeNames)) {
      return false;
    }
  }
  return true;
};

var extractSupportedNodes = function(node) {
  var supportedNodes = [];
  var includesUnsupportedNodes = false;
  if (isSupportedTextNode(node)) {
    supportedNodes.push(node);
    if (node.childNodes) {
      var childNodes = Array.prototype.slice.call(node.childNodes);
      childNodes.forEach(function(childNode) {
        var nodes = extractSupportedNodes(childNode);
        supportedNodes = supportedNodes.concat(nodes.supportedNodes);
        includesUnsupportedNodes = includesUnsupportedNodes || nodes.includesUnsupportedNodes;
      });
    }
  } else {
    includesUnsupportedNodes = true;
  }
  return {
    supportedNodes:supportedNodes,
    includesUnsupportedNodes:includesUnsupportedNodes
  };
};

var getNodeAttributeValue = function(node, attributeName, nodeName) {
  var attributeValue;
  if (!nodeName || nodeName === node.nodeName.toUpperCase()) {
    attributeValue = node.getAttribute(attributeName);
  }
  return attributeValue;
};

module.exports = function(node) {
  var nodeText = truncateWhiteSpace(node.innerText || node.textContent);
  var nodes = extractSupportedNodes(node);
  if (!nodeText || nodes.includesUnsupportedNodes) {
    var alt;
    var title;
    var inputValue;
    var imgSrc;
    var texts = [];
    nodes.supportedNodes.forEach(function(supportedNode) {
      if (supportedNode.getAttribute) {
        alt = alt || truncateWhiteSpace(supportedNode.getAttribute('alt'));
        title = title || truncateWhiteSpace(supportedNode.getAttribute('title'));
        inputValue = inputValue || truncateWhiteSpace(
          getNodeAttributeValue(supportedNode, 'value', 'INPUT'));
        imgSrc = imgSrc || truncateWhiteSpace(
          getNodeAttributeValue(supportedNode, 'src', 'IMG'));
      }
      if (supportedNode.nodeValue) {
        texts.push(supportedNode.nodeValue);
      }
    });
    nodeText = truncateWhiteSpace(texts.join(''));
    if (!nodeText) {
      nodeText = truncateWhiteSpace(alt || title || inputValue || imgSrc || '');
    }
  }
  return nodeText;
};

          }

        }
      }
    },
    "core": {
      "displayName": "Core",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EPab6ef5bcd54046888b5cb5b9a98d558b/",
      "modules": {
        "core/src/lib/dataElements/javascriptVariable.js": {
          "name": "javascript-variable",
          "displayName": "JavaScript Variable",
          "script": function(module, exports, require, turbine) {

'use strict';
var getObjectProperty = require('../helpers/getObjectProperty.js');

module.exports = function (settings) {
  return getObjectProperty(window, settings.path);
};

          }

        },
        "core/src/lib/dataElements/customCode.js": {
          "name": "custom-code",
          "displayName": "Custom Code",
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (settings, event) {
  return settings.source(event);
};

          }

        },
        "core/src/lib/dataElements/queryStringParameter.js": {
          "name": "query-string-parameter",
          "displayName": "Query String Parameter",
          "script": function(module, exports, require, turbine) {

'use strict';

var window = require('@adobe/reactor-window');
var queryString = require('@adobe/reactor-query-string');

module.exports = function (settings) {
  var queryParams = queryString.parse(window.location.search);

  if (settings.caseInsensitive) {
    var lowerCaseName = settings.name.toLowerCase();
    var keys = Object.keys(queryParams);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (key.toLowerCase() === lowerCaseName) {
        return queryParams[key];
      }
    }
  } else {
    return queryParams[settings.name];
  }
};

          }

        },
        "core/src/lib/dataElements/cookie.js": {
          "name": "cookie",
          "displayName": "Cookie",
          "script": function(module, exports, require, turbine) {

'use strict';

var cookie = require('@adobe/reactor-cookie');

module.exports = function (settings) {
  return cookie.get(settings.name);
};

          }

        },
        "core/src/lib/dataElements/randomNumber.js": {
          "name": "random-number",
          "displayName": "Random Number",
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (settings) {
  var min = Math.ceil(settings.min);
  var max = Math.floor(settings.max);

  return min > max ? NaN : Math.floor(Math.random() * (max - min + 1)) + min;
};

          }

        },
        "core/src/lib/conditions/valueComparison.js": {
          "name": "value-comparison",
          "displayName": "Value Comparison",
          "script": function(module, exports, require, turbine) {

'use strict';

var isString = require('../helpers/stringAndNumberUtils').isString;
var isNumber = require('../helpers/stringAndNumberUtils').isNumber;
var castToStringIfNumber =
  require('../helpers/stringAndNumberUtils').castToStringIfNumber;
var castToNumberIfString =
  require('../helpers/stringAndNumberUtils').castToNumberIfString;

var updateCase = function (operand, caseInsensitive) {
  return caseInsensitive && isString(operand) ? operand.toLowerCase() : operand;
};

var guardStringCompare = function (compare) {
  return function (leftOperand, rightOperand, caseInsensitive) {
    leftOperand = castToStringIfNumber(leftOperand);
    rightOperand = castToStringIfNumber(rightOperand);

    return (
      isString(leftOperand) &&
      isString(rightOperand) &&
      compare(leftOperand, rightOperand, caseInsensitive)
    );
  };
};

var guardNumberCompare = function (compare) {
  return function (leftOperand, rightOperand) {
    leftOperand = castToNumberIfString(leftOperand);
    rightOperand = castToNumberIfString(rightOperand);

    return (
      isNumber(leftOperand) &&
      isNumber(rightOperand) &&
      compare(leftOperand, rightOperand)
    );
  };
};

var guardCaseSensitivity = function (compare) {
  return function (leftOperand, rightOperand, caseInsensitive) {
    return compare(
      updateCase(leftOperand, caseInsensitive),
      updateCase(rightOperand, caseInsensitive)
    );
  };
};

var conditions = {
  equals: guardCaseSensitivity(function (leftOperand, rightOperand) {
    return leftOperand == rightOperand;
  }),
  doesNotEqual: function () {
    return !conditions.equals.apply(null, arguments);
  },
  contains: guardStringCompare(
    guardCaseSensitivity(function (leftOperand, rightOperand) {
      return leftOperand.indexOf(rightOperand) !== -1;
    })
  ),
  doesNotContain: function () {
    return !conditions.contains.apply(null, arguments);
  },
  startsWith: guardStringCompare(
    guardCaseSensitivity(function (leftOperand, rightOperand) {
      return leftOperand.indexOf(rightOperand) === 0;
    })
  ),
  doesNotStartWith: function () {
    return !conditions.startsWith.apply(null, arguments);
  },
  endsWith: guardStringCompare(
    guardCaseSensitivity(function (leftOperand, rightOperand) {
      return (
        leftOperand.substring(
          leftOperand.length - rightOperand.length,
          leftOperand.length
        ) === rightOperand
      );
    })
  ),
  doesNotEndWith: function () {
    return !conditions.endsWith.apply(null, arguments);
  },
  matchesRegex: guardStringCompare(function (
    leftOperand,
    rightOperand,
    caseInsensitive
  ) {
    return new RegExp(rightOperand, caseInsensitive ? 'i' : '').test(
      leftOperand
    );
  }),
  doesNotMatchRegex: function () {
    return !conditions.matchesRegex.apply(null, arguments);
  },
  lessThan: guardNumberCompare(function (leftOperand, rightOperand) {
    return leftOperand < rightOperand;
  }),
  lessThanOrEqual: guardNumberCompare(function (leftOperand, rightOperand) {
    return leftOperand <= rightOperand;
  }),
  greaterThan: guardNumberCompare(function (leftOperand, rightOperand) {
    return leftOperand > rightOperand;
  }),
  greaterThanOrEqual: guardNumberCompare(function (leftOperand, rightOperand) {
    return leftOperand >= rightOperand;
  }),
  isTrue: function (leftOperand) {
    return leftOperand === true;
  },
  isTruthy: function (leftOperand) {
    return Boolean(leftOperand);
  },
  isFalse: function (leftOperand) {
    return leftOperand === false;
  },
  isFalsy: function (leftOperand) {
    return !leftOperand;
  }
};

module.exports = function (settings) {
  return conditions[settings.comparison.operator](
    settings.leftOperand,
    settings.rightOperand,
    Boolean(settings.comparison.caseInsensitive)
  );
};

          }

        },
        "core/src/lib/events/customEvent.js": {
          "name": "custom-event",
          "displayName": "Custom Event",
          "script": function(module, exports, require, turbine) {

'use strict';
var bubbly = require('./helpers/createBubbly')();

var typesWatched = [];

module.exports = function (settings, trigger) {
  var type = settings.type;

  if (typesWatched.indexOf(type) === -1) {
    typesWatched.push(type);
    window.addEventListener(type, bubbly.evaluateEvent, true);
  }

  bubbly.addListener(settings, function (event) {
    if (event.nativeEvent.type === type) {
      event.detail = event.nativeEvent.detail;
      trigger(event);
    }
  });
};

          }

        },
        "core/src/lib/conditions/customCode.js": {
          "name": "custom-code",
          "displayName": "Custom Code",
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (settings, event) {
  return settings.source.call(event.element, event, event.target);
};

          }

        },
        "core/src/lib/events/libraryLoaded.js": {
          "name": "library-loaded",
          "displayName": "Library Loaded (Page Top)",
          "script": function(module, exports, require, turbine) {

'use strict';

var pageLifecycleEvents = require('./helpers/pageLifecycleEvents');

module.exports = function (settings, trigger) {
  pageLifecycleEvents.registerLibraryLoadedTrigger(trigger);
};

          }

        },
        "core/src/lib/helpers/getObjectProperty.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (obj, property) {
  var propertyChain = property.split('.');
  var currentValue = obj;

  for (var i = 0, len = propertyChain.length; i < len; i++) {
    if (currentValue == null) {
      return undefined;
    }

    currentValue = currentValue[propertyChain[i]];
  }

  return currentValue;
};

          }

        },
        "core/src/lib/helpers/stringAndNumberUtils.js": {
          "script": function(module, exports, require, turbine) {
'use strict';

var isNumber = function (value) {
  return typeof value === 'number' && isFinite(value); 
};

var isString = function (value) {
  return typeof value === 'string' || value instanceof String;
};

var castToStringIfNumber = function (value) {
  return isNumber(value) ? String(value) : value;
};

var castToNumberIfString = function (value) {
  return isString(value) ? Number(value) : value;
};

module.exports = {
  isNumber: isNumber,
  isString: isString,
  castToStringIfNumber: castToStringIfNumber,
  castToNumberIfString: castToNumberIfString
};

          }

        },
        "core/src/lib/events/helpers/createBubbly.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var WeakMap = require('./weakMap');
var matchesProperties = require('./matchesProperties');
var matchesSelector = require('./matchesSelector');


module.exports = function () {
  var listeners = [];

  var processedEvents = new WeakMap();

  var bubbly = {
    addListener: function (settings, callback) {
      listeners.push({
        settings: settings,
        callback: callback
      });
    },
    evaluateEvent: function (event, eventIsSynthetic) {
      if (!listeners.length) {
        return;
      }

      if (processedEvents.has(event)) {
        return;
      }

      var node = event.target;
      var childHasTriggeredRule = false;

      while (node) {
        var preventEvaluationOnAncestors = false;

        var nodeTriggeredRule = false;

        for (var i = 0; i < listeners.length; i++) {
          var listener = listeners[i];
          var elementSelector = listener.settings.elementSelector;
          var elementProperties = listener.settings.elementProperties;

          if (
            listener.settings.bubbleFireIfChildFired === false &&
            childHasTriggeredRule
          ) {
            continue;
          }

          if (
            node !== event.target &&
            listener.settings.bubbleFireIfParent === false
          ) {
            continue;
          }

          if (
            node !== event.target &&
            !elementSelector &&
            (!elementProperties || !Object.keys(elementProperties).length)
          ) {
            continue;
          }

          if (elementSelector && !matchesSelector(node, elementSelector)) {
            continue;
          }

          if (
            elementProperties &&
            !matchesProperties(node, elementProperties)
          ) {
            continue;
          }

          var syntheticEventForCallback = {};

          if (eventIsSynthetic) {
            Object.keys(event).forEach(function (key) {
              syntheticEventForCallback[key] = event[key];
            });
          } else {
            syntheticEventForCallback.nativeEvent = event;
          }

          syntheticEventForCallback.element = node;
          syntheticEventForCallback.target = event.target;

          var callbackResponse = listener.callback(syntheticEventForCallback);

          var ruleTriggered = callbackResponse !== false;

          if (ruleTriggered) {
            nodeTriggeredRule = true;

            if (listener.settings.bubbleStop) {
              preventEvaluationOnAncestors = true;
            }
          }
        }

        if (preventEvaluationOnAncestors) {
          break;
        }

        if (nodeTriggeredRule) {
          childHasTriggeredRule = true;
        }

        node = node.parentNode;
      }

      processedEvents.set(event, true);
    }
  };

  bubbly.__reset = function () {
    listeners = [];
  };

  return bubbly;
};

          }

        },
        "core/src/lib/events/helpers/weakMap.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var window = require('@adobe/reactor-window');
var WeakMap = window.WeakMap;

if (typeof WeakMap === 'undefined') {
  var defineProperty = Object.defineProperty;
  var counter = Date.now() % 1e9;

  WeakMap = function () {
    this.name = '__st' + ((Math.random() * 1e9) >>> 0) + (counter++ + '__');
  };

  WeakMap.prototype = {
    set: function (key, value) {
      var entry = key[this.name];
      if (entry && entry[0] === key) entry[1] = value;
      else
        defineProperty(key, this.name, { value: [key, value], writable: true });
      return this;
    },
    get: function (key) {
      var entry;
      return (entry = key[this.name]) && entry[0] === key
        ? entry[1]
        : undefined;
    },
    delete: function (key) {
      var entry = key[this.name];
      if (!entry || entry[0] !== key) return false;
      entry[0] = entry[1] = undefined;
      return true;
    },
    has: function (key) {
      var entry = key[this.name];
      if (!entry) return false;
      return entry[0] === key;
    }
  };
}

module.exports = WeakMap;

          }

        },
        "core/src/lib/events/helpers/matchesProperties.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

var textMatch = require('./../../helpers/textMatch');

var getElementProperty = function (element, property) {
  if (property === '@text' || property === 'innerText') {
    return element.textContent || element.innerText;
  } else if (property in element) {
    return element[property];
  } else if (element.getAttribute) {
    return element.getAttribute(property);
  }
};

module.exports = function (element, properties) {
  if (properties) {
    return properties.every(function (property) {
      var actualValue = getElementProperty(element, property.name);
      var criterionValue = property.valueIsRegex
        ? new RegExp(property.value, 'i')
        : property.value;
      return textMatch(actualValue, criterionValue);
    });
  }
  return true;
};

          }

        },
        "core/src/lib/events/helpers/matchesSelector.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (element, selector) {
  var matches = element.matches || element.msMatchesSelector;

  if (matches) {
    try {
      return matches.call(element, selector);
    } catch (error) {
      turbine.logger.warn(
        'Matching element failed. ' + selector + ' is not a valid selector.'
      );
      return false;
    }
  }

  return false;
};

          }

        },
        "core/src/lib/helpers/textMatch.js": {
          "script": function(module, exports, require, turbine) {

'use strict';

module.exports = function (str, pattern) {
  if (pattern == null) {
    throw new Error('Illegal Argument: Pattern is not present');
  }
  if (str == null) {
    return false;
  }
  if (typeof pattern === 'string') {
    return str === pattern;
  } else if (pattern instanceof RegExp) {
    return pattern.test(str);
  } else {
    return false;
  }
};

          }

        },
        "core/src/lib/events/helpers/pageLifecycleEvents.js": {
          "script": function(module, exports, require, turbine) {

'use strict';


var window = require('@adobe/reactor-window');
var document = require('@adobe/reactor-document');

var isIE10 = window.navigator.appVersion.indexOf('MSIE 10') !== -1;
var WINDOW_LOADED = 'WINDOW_LOADED';
var DOM_READY = 'DOM_READY';
var PAGE_BOTTOM = 'PAGE_BOTTOM';

var lifecycleEventsOrder = [PAGE_BOTTOM, DOM_READY, WINDOW_LOADED];

var createSyntheticEvent = function (element, nativeEvent) {
  return {
    element: element,
    target: element,
    nativeEvent: nativeEvent
  };
};

var registry = {};
lifecycleEventsOrder.forEach(function (event) {
  registry[event] = [];
});

var processRegistry = function (lifecycleEvent, nativeEvent) {
  lifecycleEventsOrder
    .slice(0, getLifecycleEventIndex(lifecycleEvent) + 1)
    .forEach(function (lifecycleEvent) {
      processTriggers(nativeEvent, lifecycleEvent);
    });
};

var detectLifecycleEvent = function () {
  if (document.readyState === 'complete') {
    return WINDOW_LOADED;
  } else if (document.readyState === 'interactive') {
    return !isIE10 ? DOM_READY : null;
  }
};

var getLifecycleEventIndex = function (event) {
  return lifecycleEventsOrder.indexOf(event);
};

var processTriggers = function (nativeEvent, lifecycleEvent) {
  registry[lifecycleEvent].forEach(function (triggerData) {
    processTrigger(nativeEvent, triggerData);
  });
  registry[lifecycleEvent] = [];
};

var processTrigger = function (nativeEvent, triggerData) {
  var trigger = triggerData.trigger;
  var syntheticEventFn = triggerData.syntheticEventFn;

  trigger(syntheticEventFn ? syntheticEventFn(nativeEvent) : null);
};

window._satellite = window._satellite || {};
window._satellite.pageBottom = processRegistry.bind(null, PAGE_BOTTOM);

document.addEventListener(
  'DOMContentLoaded',
  processRegistry.bind(null, DOM_READY),
  true
);
window.addEventListener(
  'load',
  processRegistry.bind(null, WINDOW_LOADED),
  true
);

window.setTimeout(function () {
  var lifecycleEvent = detectLifecycleEvent();
  if (lifecycleEvent) {
    processRegistry(lifecycleEvent);
  }
}, 0);

module.exports = {
  registerLibraryLoadedTrigger: function (trigger) {
    trigger();
  },
  registerPageBottomTrigger: function (trigger) {
    registry[PAGE_BOTTOM].push({
      trigger: trigger
    });
  },
  registerDomReadyTrigger: function (trigger) {
    registry[DOM_READY].push({
      trigger: trigger,
      syntheticEventFn: createSyntheticEvent.bind(null, document)
    });
  },
  registerWindowLoadedTrigger: function (trigger) {
    registry[WINDOW_LOADED].push({
      trigger: trigger,
      syntheticEventFn: createSyntheticEvent.bind(null, window)
    });
  }
};

          }

        }
      }
    },
    "mapping-table": {
      "displayName": "Mapping Table",
      "hostedLibFilesBaseUrl": "https://assets.adobedtm.com/extensions/EP29c1cfa85ec74c28b3ef1369f262762b/",
      "modules": {
        "mapping-table/src/lib/dataElements/mappingTable.js": {
          "name": "mapping-table",
          "displayName": "Mapping Table",
          "script": function(module, exports, require, turbine) {
'use strict';

module.exports = function (settings) {
    if (typeof settings !== 'undefined' && settings !== null) {
        var dataElemValue = settings.dataElement;
        addStartsWithToIE();

        try {
            for (var i = 0; i < settings.size; i++) {
                var method = settings[i].method;
                var out = settings[i].output;
                var inp = settings[i].input;

                if (method === 'exact match') {
                    if (dataElemValue === inp) {
                        return out;
                    }
                } else if (method === 'exact match i') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    if (dataElemValue.toLowerCase() === inp.toLowerCase()) {
                        return out;
                    }
                } else if (method === 'starts with') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    if (dataElemValue.startsWith(inp)) {
                        return out;
                    }
                } else if (method === 'contains') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    if (dataElemValue.indexOf(inp) > -1) {
                        return out;
                    }
                } else if (method === 'regex') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    if (new RegExp(inp).test(dataElemValue)) {
                        return out;
                    }
                } else if (method === 'regex matching') {
                    if (typeof dataElemValue === 'boolean') {
                        continue;
                    }
                    var match = dataElemValue.match(new RegExp(inp));
                    if (match !== null) {
                        for (var j = (match.length - 1); j >= 1; j--) {
                            out = out.split('$' + j).join(match[j]);
                        }
                        return out;
                    }
                } else if (method === 'is true') {
                    if (dataElemValue === true) {
                        return out;
                    }
                } else if (method === 'is false') {
                    if (dataElemValue === false) {
                        return out;
                    }
                }
            }
        } catch (e) {
            turbine.logger.error('Error during evaluation: ' + e.message);
        }

        if (settings.defaultValueEmpty === true) {
            return undefined;
        }
        return dataElemValue;
    }
};

var addStartsWithToIE = function () {
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
            position = position || 0;
            return this.substr(position, searchString.length) === searchString;
        };
    }
};


          }

        }
      }
    }
  },
  "company": {
    "orgId": "88743E6A5A74B5900A495D61@AdobeOrg"
  },
  "property": {
    "name": "Svenska Spel TUR",
    "settings": {
      "domains": [
        "svenskaspel.se"
      ],
      "undefinedVarsReturnEmpty": false,
      "ruleComponentSequencingEnabled": false
    },
    "id": "PR9fb886999dc64193bdce3f0c9e40b8a4"
  },
  "rules": [
    {
      "id": "RLb3d465419b9146de93facbc62c88090d",
      "name": "AA | Content | User | event - user",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "user"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  _satellite.logger.log(_satellite.getVar("User | User ID"));
}
            },
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar14",
                  "type": "value",
                  "value": "%User | Loggedin%"
                },
                {
                  "name": "eVar15",
                  "type": "value",
                  "value": "%User | User ID%"
                },
                {
                  "name": "eVar48",
                  "type": "value",
                  "value": "%User | Role%"
                }
              ],
              "props": [
                {
                  "name": "prop6",
                  "type": "alias",
                  "value": "eVar14"
                }
              ]
            }
          }
        }
      ]
    },
    {
      "id": "RLde8e0ca88fe24c52b7c7267c3654cc0a",
      "name": "AA | Transaction | Complete | event - transt",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "trans"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var items = event.detail.data.items, products = [],lottoRegex = new RegExp("^Lotto"), vikingRegex = new RegExp("^Vikinglotto"), euroRegex = new RegExp("^Eurojackpot"), kenoRegex = new RegExp("^Keno$"),
   kxpressRegex = new RegExp("^KenoXpress$"), trissRegex = new RegExp("Triss"), skrapRegex = new RegExp("Skrap"), rubbetRegex = new RegExp("Rubbet"), lördagRegex = new RegExp("Lördagsgodis"), voucher = [];

    if (event.detail.data) {
    if (event.detail.data.gameAccount || event.detail.data.gameType) {
      _satellite.setVar("transaction | gameAccount", event.detail.data.gameAccount);
      _satellite.setVar("transaction | gameType", event.detail.data.gameType);
    } else _satellite.logger.log("No value in gameAccount and gameType ");
  }else _satellite.logger.log("No value in items object ");

function _pstr(items){
  var a =  items[i].details.kungkeno; b = items[i].details.bag, c = items[i].productName, d = items[i].details;
      if (a || b) {
        _satellite.setVar("transaction | kungkeno - bag", true);
        if (a) {
         _satellite.setVar("transaction | kungkeno", true);
          products.push("|event67");
        }
        if (b) {
         _satellite.setVar("transaction | bagprice", true);
          products.push("|event13=" + b.split(" ")[1]);
        }
      }
      products.push(";eVar52=" + ((c) ?c.trim().toLowerCase() : "") + ((d && b) ? "|eVar53=" + b : ""));
      return products.join('');
    }

function _prepstr(items){
    products.push(";" + ((items[i].SKU) ? items[i].SKU : "") + ";" + ((items[i].quantity) ? items[i].quantity : "1") + ";" + ((items[i].price) ? items[i].price : "0"));
    return products;
}

function _voucher(items){
  _prepstr(items);
  trissRegex.test(items[i].productName)?products.push(";event94=" + items[i].price):"";
  skrapRegex.test(items[i].productName)?products.push(";event95=" + items[i].price):"";
  _pstr(items);
  trissRegex.test(items[i].productName)?voucher.push("triss"):"";
  skrapRegex.test(items[i].productName)?voucher.push("skrap"):"";
  _satellite.setVar("transaction | voucherevent", voucher.join(""));
  _satellite.setVar("transaction | voucher", true);
}

if(lottoRegex.test(items[0].productName)){for(var i = 0; i < items.length; i++){if (i > 0){products.push(',');}_prepstr(items);products.push(";event89=" + items[i].price); _pstr(items);_satellite.setVar("transaction | event", "lotto");}}
if(vikingRegex.test(items[0].productName)){for(var i = 0; i < items.length; i++){if (i > 0){products.push(',');}_prepstr(items);products.push(";event93=" + items[i].price); _pstr(items);_satellite.setVar("transaction | event", "viking");}}
if(euroRegex.test(items[0].productName)){for(var i = 0; i < items.length; i++){if (i > 0){products.push(',');}_prepstr(items);products.push(";event90=" + items[i].price); _pstr(items);_satellite.setVar("transaction | event", "euro");}}
if(kenoRegex.test(items[0].productName)){for(var i = 0; i < items.length; i++){if (i > 0){products.push(',');}_prepstr(items);products.push(";event91=" + items[i].price); _pstr(items);_satellite.setVar("transaction | event", "keno");}}
if(kxpressRegex.test(items[0].productName)){for(var i = 0; i < items.length; i++){if (i > 0){products.push(',');}_prepstr(items);products.push(";event92=" + items[i].price); _pstr(items);_satellite.setVar("transaction | event", "xpress");}}
if(trissRegex.test(items[0].productName)){if(items[0].SKU == "VOUCHER"){for (var i = 0; i < items.length; i++){if(i > 0){products.push(',');}_voucher(items)}}else{for(var i = 0; i < items.length; i++){if (i > 0){products.push(',');}_prepstr(items);products.push(";event94=" + items[i].price);_pstr(items);_satellite.setVar("transaction | event", "triss");}}}
if(skrapRegex.test(items[0].productName)) {if(items[0].SKU == "VOUCHER"){for (var i = 0; i < items.length; i++){if(i > 0){products.push(',');}_voucher(items)}}else{for (var i = 0; i < items.length; i++) {if (i > 0) {products.push(',');}_prepstr(items);products.push(";event95=" + items[i].price);_pstr(items);_satellite.setVar("transaction | event", "skrap");}}}
if(rubbetRegex.test(items[0].productName)){for(var i = 0; i < items.length; i++){if (i > 0){products.push(',');}_prepstr(items);products.push(";event96=" + items[i].details.bag.split(" ")[1]); _pstr(items);_satellite.setVar("transaction | event", "rubbet");}}
if(lördagRegex.test(items[0].productName)){for(var i = 0; i < items.length; i++){if (i > 0){products.push(',');}_prepstr(items);products.push(";event97=" + items[i].details.bag.split(" ")[1]); _pstr(items);_satellite.setVar("transaction | event", "lördagsgodis");}}
if (products.length != 0) {_satellite.setVar("transaction | product string", products.join(""))}
  else {for (var i = 0; i < items.length; i++) {if (i > 0) {products.push(',');}_prepstr(items);_pstr(items);_satellite.logger.warn("new product found: using default");_satellite.setVar("transaction | product string", products.join(""))}}
return true;

} catch (e) {
 _satellite.logger.warn("Error in AA|Transaction|Complete|event-trans_condition  " + e);
}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  s.products = _satellite.getVar("transaction | product string");
if (_satellite.getVar("transaction | gameAccount")) {
      s.eVar56=_satellite.getVar("transaction | gameAccount");
  s.linkTrackVars = s.apl(s.linkTrackVars,"eVar56",",",2);
    }
if (_satellite.getVar("transaction | gameType")) {
      s.eVar55=_satellite.getVar("transaction | gameType");
  s.linkTrackVars = s.apl(s.linkTrackVars,"eVar55",",",2);
    }
s.linkTrackVars = s.apl(s.linkTrackVars,"products,purchaseID,transactionID",",",2);
  switch (_satellite.getVar("transaction | event")) {
  case "lotto":
    s.events = s.apl(s.events, "event80,event89", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event80,event89", ",", 2);
    break;
  case "viking":
    s.events = s.apl(s.events, "event84,event93", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event84,event93", ",", 2);
    break;
  case "euro":
    s.events = s.apl(s.events, "event81,event90", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event81,event90", ",", 2);
    break;
  case "keno":
    s.events = s.apl(s.events, "event82,event91", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event82,event91", ",", 2);
    break;
  case "xpress":
    s.events = s.apl(s.events, "event83,event92", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event83,event92", ",", 2);
    break;
  case "triss":
    s.events = s.apl(s.events, "event85,event94", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event85,event94", ",", 2);
    break;
  case "skrap":
    s.events = s.apl(s.events, "event86,event95", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event86,event95", ",", 2);
    break;
  case "rubbet":
    s.events = s.apl(s.events, "event87,event96", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event87,event96", ",", 2);
    break;
  case "lördagsgodis":
    s.events = s.apl(s.events, "event88,event97", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event88,event97", ",", 2);
    break;
}
if (_satellite.getVar("transaction | kungkeno - bag") == true) {
  if (_satellite.getVar("transaction | kungkeno") == true) {
    s.events = s.apl(s.events, "event67", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event67",",",2);
  }
  if (_satellite.getVar("transaction | bagprice") == true) {
    s.events = s.apl(s.events, "event13", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event13",",",2);
  }
}

switch (_satellite.getVar("transaction | voucher") == true) {
  case _satellite.getVar("transaction | voucherevent").includes("skraptriss"):
  case _satellite.getVar("transaction | voucherevent").includes("trissskrap"):
    s.events = s.apl(s.events, "event86,event95,event85,event94", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event86,event95,event85,event94", ",", 2);
    break;
  case _satellite.getVar("transaction | voucherevent") == "triss":
  case _satellite.getVar("transaction | voucherevent").includes("trisstriss"):
    s.events = s.apl(s.events, "event85,event94", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event85,event94", ",", 2);
    break;
  case _satellite.getVar("transaction | voucherevent") == "skrap":
  case _satellite.getVar("transaction | voucherevent").includes("skrapskrap"):
    s.events = s.apl(s.events, "event86,event95", ",", 2);
    s.linkTrackEvents = s.apl(s.linkTrackEvents, "event86,event95", ",", 2);
    break;
  }

_satellite.logger.log("s.linkTrackVars==> "+s.linkTrackVars);
_satellite.logger.log("s.linkTrackEvents==> "+s.linkTrackEvents);
_satellite.logger.log("s.events==> "+s.events);
}
            },
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar57",
                  "type": "value",
                  "value": "%Transaction | Order ID%"
                }
              ],
              "events": [
                {
                  "name": "purchase"
                }
              ],
              "purchaseID": "%Transaction | Order ID%",
              "transactionID": "%Transaction | Order ID%"
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "Transaction",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL36f867691c15492bb6cd2d810a4287df",
      "name": "AA | Internal Promotion | Click | event - promoClick",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "promoClick"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar16",
                  "type": "value",
                  "value": "%Internal Promotion | Id%"
                },
                {
                  "name": "eVar17",
                  "type": "value",
                  "value": "%Internal Promotion | Position%"
                },
                {
                  "name": "eVar22",
                  "type": "value",
                  "value": "%Internal Promotion | Name%"
                }
              ],
              "events": [
                {
                  "name": "event2"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%EDDL | event%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL5f3d39b7ce8447789876fbe17abcdd0f",
      "name": "AA | Subscription | Activate | event - Activate",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "startsWith",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Activate"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Action");
  var arr = action.split(":");
  _satellite.logger.log(arr[0].trim(),arr[1].trim());
  _satellite.setVar("subscription:product",arr[1].trim());
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar29",
                  "type": "value",
                  "value": "%subscription:product%"
                }
              ],
              "events": [
                {
                  "name": "event65"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL563b1258d71246bf8b0c59442a1824f0",
      "name": "AA | Deposit | Failure | event - Deposit Failure",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Deposit Failure"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar19",
                  "type": "value",
                  "value": "%Event | Label%"
                },
                {
                  "name": "eVar20",
                  "type": "value",
                  "value": "%Event | Value%"
                }
              ],
              "events": [
                {
                  "name": "event12"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL308921f9c0364608bf98ef41e5674a6b",
      "name": "AA | Users | Registration Started | event - Registration Started",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 40.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Customer Registration"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Label").toLowerCase();
  if(action == "started_new_customer_from_frejaeid"|| action == "started_retail_customer_from_frejaeid" || action == "started_retail_customer_from_bankid"|| action == "started_new_customer_from_bankid"){   
     var data = action.split("_");
    _satellite.setVar("registration: type",data[1]);
    _satellite.setVar("registration: method",data[4]);
    return true;
  }else{ 
    return false;
  }
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar44",
                  "type": "value",
                  "value": "%registration: method%"
                },
                {
                  "name": "eVar54",
                  "type": "value",
                  "value": "%registration: type%"
                }
              ],
              "events": [
                {
                  "name": "event62"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action% | Started",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL6a46bbaa9c9741289c80eacaf0898e4f",
      "name": "AA | Video | Start | event - Start",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Start"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Video"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar21",
                  "type": "value",
                  "value": "%Event | Label%"
                }
              ],
              "events": [
                {
                  "name": "event23"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Category% - %Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL136bbeec9cbf41c18a4eb17a0fb47aef",
      "name": "AA | Users | Registration Duration | event - intermediate_duration",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 40.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Customer Registration"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Label").toLowerCase();
  if(action == "intermediate_duration_bankid"|| action == "intermediate_duration_frejaeid"){   
    var data = action.split("_");
    _satellite.setVar("registration: method",data[2]); 
    return true;
  }else{ 
    return false;
  }
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar44",
                  "type": "value",
                  "value": "%registration: method%"
                },
                {
                  "name": "eVar54",
                  "type": "value",
                  "value": "%Event | Registration Type%"
                }
              ],
              "events": [
                {
                  "name": "event66",
                  "value": "%Event | Value%"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action% | Duration",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL6cdbcaf8e3094e5b810a897cb320baa6",
      "name": "AA | Form | Avsluta formulär | event - Avsluta formulär",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Avsluta formulär"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar34",
                  "type": "value",
                  "value": "%Event | Label%"
                }
              ],
              "events": [
                {
                  "name": "event37"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLca5657505e2b4a3db911aaf415a1259a",
      "name": "AA | A4T | Pay Load Push | event - analyticsPayloadPush",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 20.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "targetPayload"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
    var  url = "https://smetricstur.www.svenskaspel.se/b/ss/" + _satellite.getVar("Analytics | Account") + "/1?ndh=1";
	url += "&mid=" + _satellite.getVisitorId().getMarketingCloudVisitorID();
	url += "&g=" + document.location.href;
    url += "&pe=" + _satellite.getVar("Target | Payload pe");
    url += "&tnta=" + _satellite.getVar("Target | Payload tnta");
    var img = new Image();
    img.src = url;
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [

      ]
    },
    {
      "id": "RLc8fcfd7707464e6a94b8da795992aa95",
      "name": "ECID | Consent | Analytics Browser Accept | event - consentChanged",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "consentChanged"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  if (_satellite.getVar("Consent | Analytics Browser") == true) {
    return true;
  }
  return false;
} catch (e) {
  _satellite.logger.log("Error in analytics consent condition " + e);
}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  try{
  _satellite.logger.log("Start# The user consent checked for analytiss and optIn set AA-ECID-AAM " );
  adobe.optIn.approve([adobe.optIn.Categories.ECID,adobe.optIn.Categories.ANALYTICS,adobe.optIn.Categories.AAM],true);
  adobe.optIn.complete();
  _satellite.logger.log("The user consent checked for analytiss and optIn set AA-ECID-AAM " );
}catch(e){ _satellite.logger.error("Error in analytics consent " + e);}
}
            },
            "trackerProperties": {
            }
          }
        }
      ]
    },
    {
      "id": "RL770510218b84441a9902732206f92dfd",
      "name": "AA | Withdrawal | Failure | event -  Withdrawal Failure",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Withdrawal Failure"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event17"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL5fbfa58d84fb4d5ca4dffc93af05b0ca",
      "name": "ECID | Consent | Personalized Customer Accept | event - consentChanged",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "consentChanged"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isTrue"
            },
            "leftOperand": "%Consent | Personalized Customer%"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  if (_satellite.getVar("Consent | Analytics Browser") == true) {
    return true;
  }
  return false;
} catch (e) {
  _satellite.logger.log("Error in analytics consent condition in personalized web " + e);
}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  try{
  adobe.optIn.approve([adobe.optIn.Categories.TARGET],true);
  adobe.optIn.complete();
  _satellite.logger.log("The user consent checked for personalized web and optIn set AT " );
}catch(e){}
}
            },
            "trackerProperties": {
            }
          }
        }
      ]
    },
    {
      "id": "RL02559ccc9e044d108bce18173c0b8e6d",
      "name": "AA | Betrow | Start | event - Betrow Start",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Betrow Started"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event38"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLa4fab58e72994c9ebdbecb0d74b7e19a",
      "name": "AA | Login | Success | event - Login success",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Login Success"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar14",
                  "type": "value",
                  "value": "yes"
                },
                {
                  "name": "eVar45",
                  "type": "value",
                  "value": "%Event | Label%"
                }
              ],
              "events": [
                {
                  "name": "event4"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL6101b3036d4f4c85bf42feebf3ef1d33",
      "name": "AA | Content | Page View | event - pageView",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "pageView"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
    var pid = decodeURIComponent(event.detail.data.url);
    pid = pid.substring(0,( c = pid.indexOf("?") ) >-1 ? c : pid.length );
    var cat = pid.split('/');
    if(pid=="/"){
      cat[1] = "vattendelaren";
      cat[2] = "home";
    }else if(pid=="/tur"){
      cat[1] = "home";
      cat[2] = "home";
    }
    _satellite.setVar("site section: level1", cat[1] ? cat[1] : "");
    _satellite.setVar("site section: level2",cat[2] ? cat[2] : cat[1] ? cat[1] : "");
    _satellite.setVar("site section: pageID",pid);
    return true;
}catch(e){_satellite.logger.warn("error in pageview condition "+e)}
return true;
}
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  if (_satellite.getVar("Consent | Analytics Browser") == true) {
    return true;
  }
  return false;
} catch (e) {
  _satellite.logger.log("Error in analytics consent condition " + e);
}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  try{
  s.prop2 = s.getPreviousValue(s.pageName,'gpv','');
  if(s.prop2=="")
    s.prop2="First page"; 
  s.campaign = s.Util.getQueryParam("cid");
  var isUTM = s.Util.getQueryParam("utm_source");
  s.eVar39 = _satellite.getVisitorId().getMarketingCloudVisitorID();   
  if (!s.campaign && isUTM){
    var gaUTM=[];
    gaUTM.push(s.Util.getQueryParam('utm_source'));
    gaUTM.push(s.Util.getQueryParam('utm_medium'));

    if (s.Util.getQueryParam('utm_campaign') != "") {
        gaUTM.push(s.Util.getQueryParam('utm_campaign'));
     } else {
        gaUTM.push("na");
     }
    if (s.Util.getQueryParam('utm_term') != "") {
        gaUTM.push(s.Util.getQueryParam('utm_term'));
     } else {
        gaUTM.push("na");
     }
    if (s.Util.getQueryParam('utm_content') != "") {
        gaUTM.push(s.Util.getQueryParam('utm_content'));
    } else {
        gaUTM.push("na");
     }
    gaUTM.push('(ga-utm)');
    s.campaign = gaUTM.join(":");
  }
var pid = decodeURIComponent(event.detail.data.url);
if(pid == "/tur/grasroten"){
  s.events=s.apl(s.events,"event35",",",2);
}
}catch(e){_satellite.logger.warn("Error in pageveiw setvariable "+e)}
}
            },
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar1",
                  "type": "value",
                  "value": "%site section: level1%"
                },
                {
                  "name": "eVar2",
                  "type": "value",
                  "value": "%site section: level2%"
                },
                {
                  "name": "eVar3",
                  "type": "value",
                  "value": "%Content | url%"
                },
                {
                  "name": "eVar4",
                  "type": "value",
                  "value": "%Content | Page Name%"
                },
                {
                  "name": "eVar5",
                  "type": "value",
                  "value": "%Content | Form Factor%"
                },
                {
                  "name": "eVar46",
                  "type": "value",
                  "value": "%Content | Form Factor%"
                },
                {
                  "name": "eVar47",
                  "type": "value",
                  "value": "%Content | Site%"
                }
              ],
              "props": [
                {
                  "name": "prop1",
                  "type": "alias",
                  "value": "eVar2"
                },
                {
                  "name": "prop3",
                  "type": "alias",
                  "value": "eVar3"
                },
                {
                  "name": "prop4",
                  "type": "alias",
                  "value": "eVar4"
                },
                {
                  "name": "prop5",
                  "type": "alias",
                  "value": "eVar5"
                },
                {
                  "name": "prop7",
                  "type": "value",
                  "value": "%Content | Site%"
                }
              ],
              "channel": "%site section: level1%",
              "pageName": "%Content | Page Name%"
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "page"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL69d5f61163784578968e8e4d81a2c6c1",
      "name": "AA | Deposit | Success | event - Deposit Success",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Deposit Success"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar19",
                  "type": "value",
                  "value": "%Event | Label%"
                },
                {
                  "name": "eVar20",
                  "type": "value",
                  "value": "%Event | Value%"
                }
              ],
              "events": [
                {
                  "name": "event11"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL6b920e343d6a40baa89ae8ca69fa78fb",
      "name": "AA | Betrow | Complete | event - Betrow Complete",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Betrow Complete"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event39"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL98ad85e5386b43e9b71c7ae27cc62cfb",
      "name": "AA | Subscription | Changed | event - Changed",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "startsWith",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Changed"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Action");
  var arr = action.split(":");
  _satellite.logger.log(arr[0].trim(),arr[1].trim());
  _satellite.setVar("subscription:product",arr[1].trim());
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar29",
                  "type": "value",
                  "value": "%subscription:product%"
                }
              ],
              "events": [
                {
                  "name": "event29"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLad29cd9d4b014a6c958dff393380c6cc",
      "name": "AA | Subscription | Reactivate | event - Reactivate",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "startsWith",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Reactivate"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Action");
  var arr = action.split(":");
  _satellite.logger.log(arr[0].trim(),arr[1].trim());
  _satellite.setVar("subscription:product",arr[1].trim());
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar29",
                  "type": "value",
                  "value": "%subscription:product%"
                }
              ],
              "events": [
                {
                  "name": "event31"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL407fb9a8727a44ad9352fd9824b41a00",
      "name": "AA | Login | Failure | event - login failure",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Login Failure"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar14",
                  "type": "value",
                  "value": "no"
                },
                {
                  "name": "eVar45",
                  "type": "value",
                  "value": "%Event | Label%"
                }
              ],
              "events": [
                {
                  "name": "event5"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL44d7b45b40414ef29dcf9e81afa879d6",
      "name": "ECID | Declared ID | Not Authenticated | event - user",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "user"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "doesNotEqual",
              "caseInsensitive": true
            },
            "leftOperand": "%User | Loggedin%",
            "rightOperand": "yes"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-mcid/src/lib/actions/setCustomerIds.js",
          "settings": {
            "customerIds": [
              {
                "value": "%User | User ID%",
                "hashType": "",
                "authState": 2,
                "integrationCode": "declaredid"
              },
              {
                "value": "%User | User ID%",
                "authState": 2,
                "integrationCode": "AdobeCampaignID"
              }
            ]
          }
        }
      ]
    },
    {
      "id": "RL450304404e304a11b6114e89f03e61bb",
      "name": "AA | Gräsroten | Avsluta mitt stöd | event - Avsluta mitt stöd",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Avsluta mitt stöd"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar31",
                  "type": "value",
                  "value": "%Event | Label%"
                }
              ],
              "events": [
                {
                  "name": "event34"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL9a674eee9e1f4b16bcc37c9cdb7afae7",
      "name": "AA | Form | Påbörja formulär | event - Påbörja formulär",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Påbörja formulär"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar34",
                  "type": "value",
                  "value": "%Event | Label%"
                }
              ],
              "events": [
                {
                  "name": "event36"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLcc037963a79e42f7b21b7af3783effaa",
      "name": "AA | Subscription | Started : Triss | event - Started : Triss",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Started : Triss"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event30"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLe18fdf5e8fa546e59cc70391ed5e36eb",
      "name": "DataLayer | Config | Page Load | event - Page Top",
      "events": [
        {
          "modulePath": "core/src/lib/events/libraryLoaded.js",
          "settings": {
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  window.eddl && window.eddl.libraryLoaded && window.eddl.libraryLoaded("launch");
}catch(e){}
}
          }
        }
      ],
      "actions": [

      ]
    },
    {
      "id": "RL1a6029d6ed824a77a55affbdb399666c",
      "name": "AA | Subscription | Create More | event - Create More",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "startsWith",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Create More"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Action");
  var arr = action.split(":");
  _satellite.logger.log(arr[0].trim(),arr[1].trim());
  _satellite.setVar("subscription:product",arr[1].trim());
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar29",
                  "type": "value",
                  "value": "%subscription:product%"
                }
              ],
              "events": [
                {
                  "name": "event64"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL423dd8bf51714a3fbc2f221675bba1ae",
      "name": "AA | Subscription | Started First | event - Started first",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "startsWith",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Started first"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Action");
  var arr = action.split(":");
  _satellite.logger.log(arr[0].trim(),arr[1].trim());
  _satellite.setVar("subscription:product",arr[1].trim());
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar29",
                  "type": "value",
                  "value": "%subscription:product%"
                }
              ],
              "events": [
                {
                  "name": "event63"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLc2d84558d5bb490384755cce5c7f30f8",
      "name": "AA | Content | Product View | event - pageView",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 20.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "pageView"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  var products = _satellite.getVar("Product View | products");
if(products != ""){
  _satellite.setVar("product| product name", products);
  _satellite.logger.log("product| product name"+products);
  return true;
}

}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  _satellite.logger.log("Products =====", _satellite.getVar("product| product name"))
s.products = ";" + _satellite.getVar("product| product name");
var pp = sessionStorage.getItem("s_eVar38");
if(pp)
  s.eVar38 = sessionStorage.getItem("s_eVar38");
sessionStorage.setItem("s_eVar38",s.products.substring(1));
_satellite.logger.log("Set the Product View")

}
            },
            "trackerProperties": {
              "events": [
                {
                  "id": "%random id%",
                  "name": "prodView"
                }
              ]
            }
          }
        }
      ]
    },
    {
      "id": "RL486c63e6636b4cf2bfbcb4dce9178624",
      "name": "AA | Spelpaus | Activate | event - Activate",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Activate"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Spelpaus"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var label = _satellite.getVar("Event | Label");
  if(label != ""){
    var tm = label.match(/\d+/)
	if(tm && tm[0]){
      _satellite.setVar("spelpaus: type"  , label.substring(0,label.indexOf(tm[0])));   
      _satellite.setVar("spelpaus: length", tm[0]);
    }else{
      _satellite.setVar("spelpaus: type"  , label);   
      _satellite.setVar("spelpaus: length", "");
    } 
  }
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar27",
                  "type": "value",
                  "value": "%spelpaus: type%"
                },
                {
                  "name": "eVar43",
                  "type": "value",
                  "value": "%spelpaus: type%"
                }
              ],
              "events": [
                {
                  "name": "event20"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Category% - %Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLe56a4f9df4ea411eb1f2f43615c7317b",
      "name": "AA | Plugins | Initialise | Page Load - Top ",
      "events": [
        {
          "modulePath": "core/src/lib/events/libraryLoaded.js",
          "settings": {
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  if (_satellite.getVar("Consent | Analytics Browser") == true) {
    return true;
  }
  return false;
}catch(e){_satellite.logger.error("error in consent plugin rule "+ e)}

}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "common-analytics-plugins/src/lib/actions/initialize.js",
          "settings": {
            "cs": false,
            "ft": false,
            "il": true,
            "mv": false,
            "ns": false,
            "pt": false,
            "ape": false,
            "apl": true,
            "apv": false,
            "fpo": true,
            "ggc": false,
            "gnr": false,
            "gpn": false,
            "gpv": true,
            "gqp": false,
            "grl": false,
            "gtp": false,
            "gvd": false,
            "gvn": false,
            "gvo": false,
            "rfl": false,
            "gapv": false,
            "gplt": false,
            "gtbe": false,
            "gtsv": false,
            "gttc": false,
            "gtslv": false
          }
        }
      ]
    },
    {
      "id": "RLdd62b2d19d6748079332064dde6511d3",
      "name": "AA | Gräsroten | Ge mitt stöd | event - Ge mitt stöd",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Ge mitt stöd"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar31",
                  "type": "value",
                  "value": "%Event | Label%"
                }
              ],
              "events": [
                {
                  "name": "event33"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL637cae9604764820a13d5d2de568426e",
      "name": "AA | Users | Registration Success | event - Registration Success",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Customer Registration"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Label").toLowerCase();
  if( action == "bankid" || action == "frejaeid"  ){
    var data = action.split("_");
    _satellite.setVar("registration: method",data[0]); 
    return true;
  }else{

      return false;
  }
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar44",
                  "type": "value",
                  "value": "%registration: method%"
                },
                {
                  "name": "eVar54",
                  "type": "value",
                  "value": "%Event | Registration Type%"
                }
              ],
              "events": [
                {
                  "name": "event61"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action% | Success",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLf0fadcd801524b148621dc7e7825599b",
      "name": "AA | Search | Results | event - search",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "search"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar32",
                  "type": "value",
                  "value": "%Search | Query%"
                },
                {
                  "name": "eVar42",
                  "type": "value",
                  "value": "%Search | Category%"
                }
              ],
              "events": [
                {
                  "name": "event60"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "page"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLf81a75af74e649a4828d5d5be4496e28",
      "name": "AA | Login | Logout | event - logout",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Logout"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event6"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL2272b9d1d36842cc9ec8e675e528f4a8",
      "name": "AA | Withdrawal | Success | event - Withdrawal Success",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Withdrawal Success"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event16"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL15e6e08ab83549d0a35b9c888276a94d",
      "name": "AA | Subscription | Started More | event - Started More",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "startsWith",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Started More"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Action");
  var arr = action.split(":");
  _satellite.logger.log(arr[0].trim(),arr[1].trim());
  _satellite.setVar("subscription:product",arr[1].trim());
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar29",
                  "type": "value",
                  "value": "%subscription:product%"
                }
              ],
              "events": [
                {
                  "name": "event28"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL32e6eb18fc8b47e482d64184b5bac7f7",
      "name": "ECID | Declared ID | Authenticated | event - user",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "user"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%User | Loggedin%",
            "rightOperand": "yes"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-mcid/src/lib/actions/setCustomerIds.js",
          "settings": {
            "customerIds": [
              {
                "value": "%User | User ID%",
                "hashType": "",
                "authState": 1,
                "integrationCode": "declaredid"
              },
              {
                "value": "%User | User ID%",
                "authState": 1,
                "integrationCode": "AdobeCampaignID"
              }
            ]
          }
        }
      ]
    },
    {
      "id": "RL9efb9db41adb43a397f9760f47c19587",
      "name": "AA | Content | Print EDDL Object",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  _satellite.logger.log("AA | Content | Print EDDL Object output DataLayer eddlChanged: " + JSON.stringify(event.detail));
return true;
}
          }
        }
      ],
      "actions": [

      ]
    },
    {
      "id": "RL429ee6a2f7ff4a8a8f1fa4a049bf5b06",
      "name": "AA | Target | A/B Test | event - A/B Test",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "A/B Test"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar40",
                  "type": "value",
                  "value": "%Event | Action%"
                },
                {
                  "name": "eVar41",
                  "type": "value",
                  "value": "%Event | Label%"
                }
              ],
              "events": [
                {
                  "name": "event56"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "page"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL42caa4805c5145c4a8970220521209e1",
      "name": "AA | Subscription | Ended | event - Ended",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "startsWith",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Ended"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Action");
  var arr = action.split(":");
  _satellite.logger.log(arr[0].trim(),arr[1].trim());
  _satellite.setVar("subscription:product",arr[1].trim());
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar29",
                  "type": "value",
                  "value": "%subscription:product%"
                }
              ],
              "events": [
                {
                  "name": "event32"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL53c7d888fba1497c975166abd5c72200",
      "name": "AA | Betslip | Success | event - Betslip Complete",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Betslip Complete"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event22"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL681541cd03e24999a4089eef0a4244fe",
      "name": "AA | Subscription | Initialise First | event - Initialise First",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Category%",
            "rightOperand": "Subscription"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "startsWith",
              "caseInsensitive": true
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Initialize First"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try{
  var action = _satellite.getVar("Event | Action");
  var arr = action.split(":");
  _satellite.logger.log(arr[0].trim(),arr[1].trim());
  _satellite.setVar("subscription:product",arr[1].trim());
  return true;
}catch(e){}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "eVars": [
                {
                  "name": "eVar29",
                  "type": "value",
                  "value": "%subscription:product%"
                }
              ],
              "events": [
                {
                  "name": "event27"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action%",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL0b11381d2fae4e09964e396343786fdc",
      "name": "ECID | Consent | Personalized Customer Reject | event - consentChanged",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "consentChanged"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "isFalse"
            },
            "leftOperand": "%Consent | Personalized Customer%"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  try{
  adobe.optIn.deny([adobe.optIn.Categories.TARGET],true);
  adobe.optIn.complete();
}catch(e){}
}
            },
            "trackerProperties": {
            }
          }
        }
      ]
    },
    {
      "id": "RL1ab58f6e3242413bbab204044ab24d21",
      "name": "AA | Spela Tillsammans | Click | event - Create Team Start",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "Started creating team"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event40"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action% Start",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL9122dd114e794950add07d6f0ba7a4a2",
      "name": "AA | Spela Tillsammans | Click | event - Deposit success",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "deposit success"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event42"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action% ",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL97f21b0007a64c6f80fa97fccb1ea54d",
      "name": "AA | Spela Tillsammans | Click | event - Create Team Success",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "created team"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event41"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "Play together Success",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RLf573a2a8560b45d39999502e1de7f7c9",
      "name": "AA | Spela Tillsammans | Click | event - Invited members",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%Event | Action%",
            "rightOperand": "invited members"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "matchesRegex"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "event"
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "trackerProperties": {
              "events": [
                {
                  "name": "event43"
                }
              ]
            }
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/sendBeacon.js",
          "settings": {
            "type": "link",
            "linkName": "%Event | Action% ",
            "linkType": "o"
          }
        },
        {
          "modulePath": "adobe-analytics/src/lib/actions/clearVariables.js",
          "settings": {
          }
        }
      ]
    },
    {
      "id": "RL1b9afa1ed9db4b89bb0d6e7e06293ec9",
      "name": "ECID | Consent | Personalized Browser Accept | event - consentChanged ",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "consentChanged"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  if (_satellite.getVar("Consent | Personalized Browser") == true) {
    return true;
  }
  return false;
} catch (e) {
  _satellite.logger.log("Error in personalized consent condition " + e);
}
}
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  if (_satellite.getVar("Consent | Analytics Browser") == true) {
    return true;
  }
  return false;
} catch (e) {
  _satellite.logger.log("Error in analytics consent condition in personalized " + e);
}
}
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _consCust = _satellite.getVar("Consent | Personalized Customer");
  if (_consCust !== '') {
    if (_consCust === true) {
      return true;
    } else return false;
  }
  if (_consCust === '') {
    return true;
  }
} catch (e) {
  _satellite.logger.log("Error in condition of personalized browser accept consent condition " + e);
}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  try{
  adobe.optIn.approve([adobe.optIn.Categories.TARGET],true);
  adobe.optIn.complete();
  _satellite.logger.log("The user consent checked for personalized and optIn set AT " );
}catch(e){}
}
            },
            "trackerProperties": {
            }
          }
        }
      ]
    },
    {
      "id": "RL4294770faf394d6299f666ed3a1da87d",
      "name": "ECID | Consent | Personalized Browser Reject | event - consentChanged",
      "events": [
        {
          "modulePath": "core/src/lib/events/customEvent.js",
          "settings": {
            "type": "eddlChanged",
            "bubbleFireIfParent": true,
            "bubbleFireIfChildFired": true
          },
          "ruleOrder": 50.0
        }
      ],
      "conditions": [
        {
          "modulePath": "core/src/lib/conditions/valueComparison.js",
          "settings": {
            "comparison": {
              "operator": "equals"
            },
            "leftOperand": "%EDDL | event%",
            "rightOperand": "consentChanged"
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  var _con =_satellite.getVar("Consent | Personalized Browser");
  if (_con == 'false'|| _con == false){
    return true;
  }
  return false;
} catch (e) {
  _satellite.logger.log("Error in personalized consent condition " + e);
}
}
          }
        },
        {
          "modulePath": "core/src/lib/conditions/customCode.js",
          "settings": {
            "source": function(event, target) {
  try {
  if (_satellite.getVar("Consent | Analytics Browser") == true) {
    return true;
  }
  return false;
} catch (e) {
  _satellite.logger.log("Error in analytics consent condition in personalized " + e);
}
}
          }
        }
      ],
      "actions": [
        {
          "modulePath": "adobe-analytics/src/lib/actions/setVariables.js",
          "settings": {
            "customSetup": {
              "source": function(event, s) {
  try{
  adobe.optIn.deny([adobe.optIn.Categories.TARGET],true);
  adobe.optIn.complete();
  _satellite.logger.log("The user consent reject for personalized and optIn set AT " );
}catch(e){}
}
            },
            "trackerProperties": {
            }
          }
        }
      ]
    }
  ]
}
})();

var _satellite = (function () {
	'use strict';

	if (!window.atob) { console.warn('Adobe Launch is unsupported in IE 9 and below.'); return; }

	var reactorDocument = document;

	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}


			var test1 = new String('abc');  
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			return false;
		}
	}

	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};

	var reactorObjectAssign = objectAssign;

	var reactorWindow = window;


	var createDynamicHostResolver = function (turbineEmbedCode, cdnAllowList, debugController) {
	  var isDynamicEnforced = Array.isArray(cdnAllowList);
	  var shouldAugment = Boolean(isDynamicEnforced && turbineEmbedCode);

	  var turbineUrl = document.createElement('a');
	  turbineUrl.href = turbineEmbedCode;
	  if (
	    (!/^https?:\/\/.*/.test(turbineEmbedCode) || !turbineUrl.host) &&
	    isDynamicEnforced
	  ) {
	    var missingEmbedCodeError = new Error(
	      'Unable to find the Library Embed Code for Dynamic Host Resolution.'
	    );
	    missingEmbedCodeError.code = 'dynamic_host_resolver_constructor_error';
	    throw missingEmbedCodeError;
	  }

	  if (isDynamicEnforced && cdnAllowList.indexOf(turbineUrl.hostname) === -1) {
	    var dynamicDeniedError = new Error(
	      'This library is not authorized for this domain. ' +
	        'Please contact your CSM for more information.'
	    );
	    dynamicDeniedError.code = 'dynamic_host_not_allowed';
	    throw dynamicDeniedError;
	  }

	  var memoizedHostResult;
	  var getTurbineHost = function () {
	    if (memoizedHostResult != null) {
	      return memoizedHostResult;
	    }

	    if (shouldAugment) {
	      var sanitizedHost = turbineUrl.host;
	      if (/:80$/.test(sanitizedHost)) {
	        sanitizedHost = sanitizedHost.replace(':80', '');
	      } else if (/:80\/$/.test(sanitizedHost)) {
	        sanitizedHost = sanitizedHost.replace(':80/', '');
	      } else if (/:443$/.test(sanitizedHost)) {
	        sanitizedHost = sanitizedHost.replace(':443', '');
	      } else if (/:443\/$/.test(sanitizedHost)) {
	        sanitizedHost = sanitizedHost.replace(':443/', '');
	      }

	      memoizedHostResult = 'https://' + sanitizedHost;
	    } else {
	      memoizedHostResult = '';
	    }

	    return memoizedHostResult;
	  };

	  var decorateWithDynamicHost = function (sourceUrl) {
	    if (shouldAugment && typeof sourceUrl === 'string') {
	      var urlParts = [
	        getTurbineHost(),
	        sourceUrl.charAt(0) === '/' ? sourceUrl.slice(1) : sourceUrl
	      ];

	      return urlParts.join('/');
	    }

	    return sourceUrl;
	  };

	  var dynamicHostResolver = {
	    getTurbineHost: getTurbineHost,
	    decorateWithDynamicHost: decorateWithDynamicHost,
	    get isDynamicEnforced() {
	      return isDynamicEnforced;
	    }
	  };

	  if (reactorWindow) {
	    debugController.onDebugChanged(function (isEnabled) {
	      if (isEnabled) {
	        reactorWindow.dynamicHostResolver = dynamicHostResolver;
	      } else {
	        delete reactorWindow.dynamicHostResolver;
	      }
	    });
	  }

	  return dynamicHostResolver;
	};

	var buildRuleExecutionOrder = function (rules) {
	  var ruleEventPairs = [];

	  rules.forEach(function (rule) {
	    if (rule.events) {
	      rule.events.forEach(function (event) {
	        ruleEventPairs.push({
	          rule: rule,
	          event: event
	        });
	      });
	    }
	  });

	  return ruleEventPairs.sort(function (ruleEventPairA, ruleEventPairB) {
	    return ruleEventPairA.event.ruleOrder - ruleEventPairB.event.ruleOrder;
	  });
	};

	var DEBUG_LOCAL_STORAGE_NAME = 'debug';

	var createDebugController = function (localStorage, logger) {
	  var getPersistedDebugEnabled = function () {
	    return localStorage.getItem(DEBUG_LOCAL_STORAGE_NAME) === 'true';
	  };

	  var setPersistedDebugEnabled = function (enabled) {
	    localStorage.setItem(DEBUG_LOCAL_STORAGE_NAME, enabled);
	  };

	  var debugChangedCallbacks = [];
	  var onDebugChanged = function (callback) {
	    debugChangedCallbacks.push(callback);
	  };

	  logger.outputEnabled = getPersistedDebugEnabled();

	  return {
	    onDebugChanged: onDebugChanged,
	    getDebugEnabled: getPersistedDebugEnabled,
	    setDebugEnabled: function (enabled) {
	      if (getPersistedDebugEnabled() !== enabled) {
	        setPersistedDebugEnabled(enabled);
	        logger.outputEnabled = enabled;
	        debugChangedCallbacks.forEach(function (callback) {
	          callback(enabled);
	        });
	      }
	    }
	  };
	};

	var MODULE_NOT_FUNCTION_ERROR = 'Module did not export a function.';

	var createExecuteDelegateModule = function (
	  moduleProvider,
	  replaceTokens,
	  settingsFileTransformer
	) {
	  return function (moduleDescriptor, syntheticEvent, moduleCallParameters) {
	    moduleCallParameters = moduleCallParameters || [];
	    var moduleExports = moduleProvider.getModuleExports(
	      moduleDescriptor.modulePath
	    );

	    if (typeof moduleExports !== 'function') {
	      throw new Error(MODULE_NOT_FUNCTION_ERROR);
	    }

	    var moduleDefinition = moduleProvider.getModuleDefinition(
	      moduleDescriptor.modulePath
	    );

	    var moduleSettings = moduleDescriptor.settings || {};
	    if (
	      !moduleDescriptor.hasTransformedFilePaths &&
	      moduleDefinition.filePaths
	    ) {
	      settingsFileTransformer(
	        moduleSettings,
	        moduleDefinition.filePaths,
	        moduleDescriptor.modulePath
	      );
	      moduleDescriptor.hasTransformedFilePaths = true;
	    }

	    var moduleDescriptorSettings = replaceTokens(
	      moduleSettings,
	      syntheticEvent
	    );
	    return moduleExports
	      .bind(null, moduleDescriptorSettings)
	      .apply(null, moduleCallParameters);
	  };
	};

	var cleanText = function (str) {
	  return typeof str === 'string' ? str.replace(/\s+/g, ' ').trim() : str;
	};

	var levels = {
	  LOG: 'log',
	  INFO: 'info',
	  DEBUG: 'debug',
	  WARN: 'warn',
	  ERROR: 'error'
	};

	var ROCKET = '\uD83D\uDE80';

	var ieVersion = parseInt(
	  (/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1]
	);

	var launchPrefix = ieVersion === 10 ? '[Launch]' : ROCKET;

	var outputEnabled = false;

	var process = function (level) {
	  if (outputEnabled && window.console) {
	    var logArguments = Array.prototype.slice.call(arguments, 1);
	    logArguments.unshift(launchPrefix);
	    if (level === levels.DEBUG && !window.console[level]) {
	      level = levels.INFO;
	    }
	    window.console[level].apply(window.console, logArguments);
	  }
	};

	var log = process.bind(null, levels.LOG);

	var info = process.bind(null, levels.INFO);

	var debug = process.bind(null, levels.DEBUG);

	var warn = process.bind(null, levels.WARN);

	var error = process.bind(null, levels.ERROR);

	var logDeprecation = function () {
	  var wasEnabled = outputEnabled;
	  outputEnabled = true;

	  process.apply(
	    null,
	    Array.prototype.concat(levels.WARN, Array.prototype.slice.call(arguments))
	  );

	  if (!wasEnabled) {
	    outputEnabled = false;
	  }
	};

	var logger = {
	  log: log,
	  info: info,
	  debug: debug,
	  warn: warn,
	  error: error,
	  deprecation: logDeprecation,
	  get outputEnabled() {
	    return outputEnabled;
	  },
	  set outputEnabled(value) {
	    outputEnabled = value;
	  },
	  createPrefixedLogger: function (identifier) {
	    var loggerSpecificPrefix = '[' + identifier + ']';

	    return {
	      log: log.bind(null, loggerSpecificPrefix),
	      info: info.bind(null, loggerSpecificPrefix),
	      debug: debug.bind(null, loggerSpecificPrefix),
	      warn: warn.bind(null, loggerSpecificPrefix),
	      error: error.bind(null, loggerSpecificPrefix)
	    };
	  }
	};

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getAugmentedNamespace(n) {
		if (n.__esModule) return n;
		var a = Object.defineProperty({}, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	function createCommonjsModule(fn) {
	  var module = { exports: {} };
		return fn(module, module.exports), module.exports;
	}


	var js_cookie = createCommonjsModule(function (module, exports) {
	(function (factory) {
		var registeredInModuleLoader;
		{
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}

		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}

		function init (converter) {
			function api() {}

			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}

				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}

				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}

					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}

				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}

				var jar = {};
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;

				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');

					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}

					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);

						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}

						jar[name] = cookie;

						if (key === name) {
							break;
						}
					} catch (e) {}
				}

				return key ? jar[key] : jar;
			}

			api.set = set;
			api.get = function (key) {
				return get(key, false );
			};
			api.getJSON = function (key) {
				return get(key, true );
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};

			api.defaults = {};

			api.withConverter = init;

			return api;
		}

		return init(function () {});
	}));
	});




	var reactorCookie = {
	  get: js_cookie.get,
	  set: js_cookie.set,
	  remove: js_cookie.remove
	};


	var NAMESPACE = 'com.adobe.reactor.';

	var getNamespacedStorage = function (storageType, additionalNamespace) {
	  var finalNamespace = NAMESPACE + (additionalNamespace || '');

	  return {
	    getItem: function (name) {
	      try {
	        return reactorWindow[storageType].getItem(finalNamespace + name);
	      } catch (e) {
	        return null;
	      }
	    },
	    setItem: function (name, value) {
	      try {
	        reactorWindow[storageType].setItem(finalNamespace + name, value);
	        return true;
	      } catch (e) {
	        return false;
	      }
	    }
	  };
	};


	var COOKIE_PREFIX = '_sdsat_';

	var DATA_ELEMENTS_NAMESPACE = 'dataElements.';
	var MIGRATED_KEY = 'dataElementCookiesMigrated';

	var reactorLocalStorage = getNamespacedStorage('localStorage');
	var dataElementSessionStorage = getNamespacedStorage(
	  'sessionStorage',
	  DATA_ELEMENTS_NAMESPACE
	);
	var dataElementLocalStorage = getNamespacedStorage(
	  'localStorage',
	  DATA_ELEMENTS_NAMESPACE
	);

	var storageDurations = {
	  PAGEVIEW: 'pageview',
	  SESSION: 'session',
	  VISITOR: 'visitor'
	};

	var pageviewCache = {};

	var serialize = function (value) {
	  var serialized;

	  try {
	    serialized = JSON.stringify(value);
	  } catch (e) {}

	  return serialized;
	};

	var setValue = function (key, storageDuration, value) {
	  var serializedValue;

	  switch (storageDuration) {
	    case storageDurations.PAGEVIEW:
	      pageviewCache[key] = value;
	      return;
	    case storageDurations.SESSION:
	      serializedValue = serialize(value);
	      if (serializedValue) {
	        dataElementSessionStorage.setItem(key, serializedValue);
	      }
	      return;
	    case storageDurations.VISITOR:
	      serializedValue = serialize(value);
	      if (serializedValue) {
	        dataElementLocalStorage.setItem(key, serializedValue);
	      }
	      return;
	  }
	};

	var getValue = function (key, storageDuration) {
	  var value;

	  switch (storageDuration) {
	    case storageDurations.PAGEVIEW:
	      return pageviewCache.hasOwnProperty(key) ? pageviewCache[key] : null;
	    case storageDurations.SESSION:
	      value = dataElementSessionStorage.getItem(key);
	      return value === null ? value : JSON.parse(value);
	    case storageDurations.VISITOR:
	      value = dataElementLocalStorage.getItem(key);
	      return value === null ? value : JSON.parse(value);
	  }
	};

	var migrateDataElement = function (dataElementName, storageDuration) {
	  var storedValue = reactorCookie.get(COOKIE_PREFIX + dataElementName);

	  if (storedValue !== undefined) {
	    setValue(dataElementName, storageDuration, storedValue);
	  }
	};

	var migrateCookieData = function (dataElements) {
	  if (!reactorLocalStorage.getItem(MIGRATED_KEY)) {
	    Object.keys(dataElements).forEach(function (dataElementName) {
	      migrateDataElement(
	        dataElementName,
	        dataElements[dataElementName].storageDuration
	      );
	    });

	    reactorLocalStorage.setItem(MIGRATED_KEY, true);
	  }
	};

	var dataElementSafe = {
	  setValue: setValue,
	  getValue: getValue,
	  migrateCookieData: migrateCookieData
	};


	var getErrorMessage = function (
	  dataDef,
	  dataElementName,
	  errorMessage,
	  errorStack
	) {
	  return (
	    'Failed to execute data element module ' +
	    dataDef.modulePath +
	    ' for data element ' +
	    dataElementName +
	    '. ' +
	    errorMessage +
	    (errorStack ? '\n' + errorStack : '')
	  );
	};

	var createGetDataElementValue = function (
	  moduleProvider,
	  getDataElementDefinition,
	  replaceTokens,
	  undefinedVarsReturnEmpty,
	  settingsFileTransformer
	) {
	  return function (name, syntheticEvent) {
	    var dataDef = getDataElementDefinition(name);

	    if (!dataDef) {
	      return undefinedVarsReturnEmpty ? '' : undefined;
	    }

	    var storageDuration = dataDef.storageDuration;
	    var moduleExports;
	    var moduleDefinition;

	    try {
	      moduleExports = moduleProvider.getModuleExports(dataDef.modulePath);
	      moduleDefinition = moduleProvider.getModuleDefinition(dataDef.modulePath);
	    } catch (e) {
	      logger.error(getErrorMessage(dataDef, name, e.message, e.stack));
	      return;
	    }

	    if (typeof moduleExports !== 'function') {
	      logger.error(
	        getErrorMessage(dataDef, name, 'Module did not export a function.')
	      );
	      return;
	    }

	    var value;

	    var dataElementSettings = dataDef.settings || {};
	    if (!dataDef.hasTransformedFilePaths && moduleDefinition.filePaths) {
	      settingsFileTransformer(
	        dataElementSettings,
	        moduleDefinition.filePaths,
	        dataDef.modulePath
	      );
	      dataDef.hasTransformedFilePaths = true;
	    }

	    try {
	      value = moduleExports(
	        replaceTokens(dataElementSettings, syntheticEvent),
	        syntheticEvent
	      );
	    } catch (e) {
	      logger.error(getErrorMessage(dataDef, name, e.message, e.stack));
	      return;
	    }

	    if (storageDuration) {
	      if (value != null) {
	        dataElementSafe.setValue(name, storageDuration, value);
	      } else {
	        value = dataElementSafe.getValue(name, storageDuration);
	      }
	    }

	    if (value == null && dataDef.defaultValue != null) {
	      value = dataDef.defaultValue;
	    }

	    if (typeof value === 'string') {
	      if (dataDef.cleanText) {
	        value = cleanText(value);
	      }

	      if (dataDef.forceLowerCase) {
	        value = value.toLowerCase();
	      }
	    }

	    return value;
	  };
	};


	var specialPropertyAccessors = {
	  text: function (obj) {
	    return obj.textContent;
	  },
	  cleanText: function (obj) {
	    return cleanText(obj.textContent);
	  }
	};

	var getObjectProperty = function (host, propChain, supportSpecial) {
	  var value = host;
	  var attrMatch;
	  for (var i = 0, len = propChain.length; i < len; i++) {
	    if (value == null) {
	      return undefined;
	    }
	    var prop = propChain[i];
	    if (supportSpecial && prop.charAt(0) === '@') {
	      var specialProp = prop.slice(1);
	      value = specialPropertyAccessors[specialProp](value);
	      continue;
	    }
	    if (
	      value.getAttribute &&
	      (attrMatch = prop.match(/^getAttribute\((.+)\)$/))
	    ) {
	      var attr = attrMatch[1];
	      value = value.getAttribute(attr);
	      continue;
	    }
	    value = value[prop];
	  }
	  return value;
	};

	var createGetVar = function (
	  customVars,
	  getDataElementDefinition,
	  getDataElementValue
	) {
	  return function (variable, syntheticEvent) {
	    var value;

	    if (getDataElementDefinition(variable)) {
	      value = getDataElementValue(variable, syntheticEvent);
	    } else {
	      var propChain = variable.split('.');
	      var variableHostName = propChain.shift();

	      if (variableHostName === 'this') {
	        if (syntheticEvent) {
	          value = getObjectProperty(syntheticEvent.element, propChain, true);
	        }
	      } else if (variableHostName === 'event') {
	        if (syntheticEvent) {
	          value = getObjectProperty(syntheticEvent, propChain);
	        }
	      } else if (variableHostName === 'target') {
	        if (syntheticEvent) {
	          value = getObjectProperty(syntheticEvent.target, propChain);
	        }
	      } else {
	        value = getObjectProperty(customVars[variableHostName], propChain);
	      }
	    }

	    return value;
	  };
	};

	var createIsVar = function (customVars, getDataElementDefinition) {
	  return function (variableName) {
	    var nameBeforeDot = variableName.split('.')[0];

	    return Boolean(
	      getDataElementDefinition(variableName) ||
	        nameBeforeDot === 'this' ||
	        nameBeforeDot === 'event' ||
	        nameBeforeDot === 'target' ||
	        customVars.hasOwnProperty(nameBeforeDot)
	    );
	  };
	};

	var extractModuleExports = function (script, require, turbine) {
	  var module = {
	    exports: {}
	  };

	  script.call(module.exports, module, module.exports, require, turbine);

	  return module.exports;
	};


	var createModuleProvider = function () {
	  var moduleByReferencePath = {};

	  var getModule = function (referencePath) {
	    var module = moduleByReferencePath[referencePath];

	    if (!module) {
	      throw new Error('Module ' + referencePath + ' not found.');
	    }

	    return module;
	  };

	  var registerModule = function (
	    referencePath,
	    moduleDefinition,
	    extensionName,
	    require,
	    turbine
	  ) {
	    var module = {
	      definition: moduleDefinition,
	      extensionName: extensionName,
	      require: require,
	      turbine: turbine
	    };
	    module.require = require;
	    moduleByReferencePath[referencePath] = module;
	  };

	  var hydrateCache = function () {
	    Object.keys(moduleByReferencePath).forEach(function (referencePath) {
	      try {
	        getModuleExports(referencePath);
	      } catch (e) {
	        var errorMessage =
	          'Error initializing module ' +
	          referencePath +
	          '. ' +
	          e.message +
	          (e.stack ? '\n' + e.stack : '');
	        logger.error(errorMessage);
	      }
	    });
	  };

	  var getModuleExports = function (referencePath) {
	    var module = getModule(referencePath);

	    if (!module.hasOwnProperty('exports')) {
	      module.exports = extractModuleExports(
	        module.definition.script,
	        module.require,
	        module.turbine
	      );
	    }

	    return module.exports;
	  };

	  var getModuleDefinition = function (referencePath) {
	    return getModule(referencePath).definition;
	  };

	  var getModuleExtensionName = function (referencePath) {
	    return getModule(referencePath).extensionName;
	  };

	  return {
	    registerModule: registerModule,
	    hydrateCache: hydrateCache,
	    getModuleExports: getModuleExports,
	    getModuleDefinition: getModuleDefinition,
	    getModuleExtensionName: getModuleExtensionName
	  };
	};


	var warningLogged = false;

	var createNotifyMonitors = function (_satellite) {
	  return function (type, event) {
	    var monitors = _satellite._monitors;

	    if (monitors) {
	      if (!warningLogged) {
	        logger.warn(
	          'The _satellite._monitors API may change at any time and should only ' +
	            'be used for debugging.'
	        );
	        warningLogged = true;
	      }

	      monitors.forEach(function (monitor) {
	        if (monitor[type]) {
	          monitor[type](event);
	        }
	      });
	    }
	  };
	};


	var createReplaceTokens = function (isVar, getVar, undefinedVarsReturnEmpty) {
	  var replaceTokensInString;
	  var replaceTokensInObject;
	  var replaceTokensInArray;
	  var replaceTokens;
	  var variablesBeingRetrieved = [];

	  var getVarValue = function (token, variableName, syntheticEvent) {
	    if (!isVar(variableName)) {
	      return token;
	    }

	    variablesBeingRetrieved.push(variableName);
	    var val = getVar(variableName, syntheticEvent);
	    variablesBeingRetrieved.pop();
	    return val == null && undefinedVarsReturnEmpty ? '' : val;
	  };

	  replaceTokensInString = function (str, syntheticEvent) {
	    var result = /^%([^%]+)%$/.exec(str);

	    if (result) {
	      return getVarValue(str, result[1], syntheticEvent);
	    } else {
	      return str.replace(/%(.+?)%/g, function (token, variableName) {
	        return getVarValue(token, variableName, syntheticEvent);
	      });
	    }
	  };

	  replaceTokensInObject = function (obj, syntheticEvent) {
	    var ret = {};
	    var keys = Object.keys(obj);
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      ret[key] = replaceTokens(value, syntheticEvent);
	    }
	    return ret;
	  };

	  replaceTokensInArray = function (arr, syntheticEvent) {
	    var ret = [];
	    for (var i = 0, len = arr.length; i < len; i++) {
	      ret.push(replaceTokens(arr[i], syntheticEvent));
	    }
	    return ret;
	  };

	  replaceTokens = function (thing, syntheticEvent) {
	    if (typeof thing === 'string') {
	      return replaceTokensInString(thing, syntheticEvent);
	    } else if (Array.isArray(thing)) {
	      return replaceTokensInArray(thing, syntheticEvent);
	    } else if (typeof thing === 'object' && thing !== null) {
	      return replaceTokensInObject(thing, syntheticEvent);
	    }

	    return thing;
	  };

	  return function (thing, syntheticEvent) {
	    if (variablesBeingRetrieved.length > 10) {
	      logger.error(
	        'Data element circular reference detected: ' +
	          variablesBeingRetrieved.join(' -> ')
	      );
	      return thing;
	    }

	    return replaceTokens(thing, syntheticEvent);
	  };
	};

	var createSetCustomVar = function (customVars) {
	  return function () {
	    if (typeof arguments[0] === 'string') {
	      customVars[arguments[0]] = arguments[1];
	    } else if (arguments[0]) {
	      var mapping = arguments[0];
	      for (var key in mapping) {
	        customVars[key] = mapping[key];
	      }
	    }
	  };
	};

	function finallyConstructor(callback) {
	  var constructor = this.constructor;
	  return this.then(
	    function(value) {
	      return constructor.resolve(callback()).then(function() {
	        return value;
	      });
	    },
	    function(reason) {
	      return constructor.resolve(callback()).then(function() {
	        return constructor.reject(reason);
	      });
	    }
	  );
	}

	var setTimeoutFunc = setTimeout;

	function isArray(x) {
	  return Boolean(x && typeof x.length !== 'undefined');
	}

	function noop() {}

	function bind(fn, thisArg) {
	  return function() {
	    fn.apply(thisArg, arguments);
	  };
	}

	function Promise(fn) {
	  if (!(this instanceof Promise))
	    throw new TypeError('Promises must be constructed via new');
	  if (typeof fn !== 'function') throw new TypeError('not a function');
	  this._state = 0;
	  this._handled = false;
	  this._value = undefined;
	  this._deferreds = [];

	  doResolve(fn, this);
	}

	function handle(self, deferred) {
	  while (self._state === 3) {
	    self = self._value;
	  }
	  if (self._state === 0) {
	    self._deferreds.push(deferred);
	    return;
	  }
	  self._handled = true;
	  Promise._immediateFn(function() {
	    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	      return;
	    }
	    var ret;
	    try {
	      ret = cb(self._value);
	    } catch (e) {
	      reject(deferred.promise, e);
	      return;
	    }
	    resolve(deferred.promise, ret);
	  });
	}

	function resolve(self, newValue) {
	  try {
	    if (newValue === self)
	      throw new TypeError('A promise cannot be resolved with itself.');
	    if (
	      newValue &&
	      (typeof newValue === 'object' || typeof newValue === 'function')
	    ) {
	      var then = newValue.then;
	      if (newValue instanceof Promise) {
	        self._state = 3;
	        self._value = newValue;
	        finale(self);
	        return;
	      } else if (typeof then === 'function') {
	        doResolve(bind(then, newValue), self);
	        return;
	      }
	    }
	    self._state = 1;
	    self._value = newValue;
	    finale(self);
	  } catch (e) {
	    reject(self, e);
	  }
	}

	function reject(self, newValue) {
	  self._state = 2;
	  self._value = newValue;
	  finale(self);
	}

	function finale(self) {
	  if (self._state === 2 && self._deferreds.length === 0) {
	    Promise._immediateFn(function() {
	      if (!self._handled) {
	        Promise._unhandledRejectionFn(self._value);
	      }
	    });
	  }

	  for (var i = 0, len = self._deferreds.length; i < len; i++) {
	    handle(self, self._deferreds[i]);
	  }
	  self._deferreds = null;
	}

	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}

	function doResolve(fn, self) {
	  var done = false;
	  try {
	    fn(
	      function(value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      },
	      function(reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      }
	    );
	  } catch (ex) {
	    if (done) return;
	    done = true;
	    reject(self, ex);
	  }
	}

	Promise.prototype['catch'] = function(onRejected) {
	  return this.then(null, onRejected);
	};

	Promise.prototype.then = function(onFulfilled, onRejected) {
	  var prom = new this.constructor(noop);

	  handle(this, new Handler(onFulfilled, onRejected, prom));
	  return prom;
	};

	Promise.prototype['finally'] = finallyConstructor;

	Promise.all = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!isArray(arr)) {
	      return reject(new TypeError('Promise.all accepts an array'));
	    }

	    var args = Array.prototype.slice.call(arr);
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;

	    function res(i, val) {
	      try {
	        if (val && (typeof val === 'object' || typeof val === 'function')) {
	          var then = val.then;
	          if (typeof then === 'function') {
	            then.call(
	              val,
	              function(val) {
	                res(i, val);
	              },
	              reject
	            );
	            return;
	          }
	        }
	        args[i] = val;
	        if (--remaining === 0) {
	          resolve(args);
	        }
	      } catch (ex) {
	        reject(ex);
	      }
	    }

	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};

	Promise.resolve = function(value) {
	  if (value && typeof value === 'object' && value.constructor === Promise) {
	    return value;
	  }

	  return new Promise(function(resolve) {
	    resolve(value);
	  });
	};

	Promise.reject = function(value) {
	  return new Promise(function(resolve, reject) {
	    reject(value);
	  });
	};

	Promise.race = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!isArray(arr)) {
	      return reject(new TypeError('Promise.race accepts an array'));
	    }

	    for (var i = 0, len = arr.length; i < len; i++) {
	      Promise.resolve(arr[i]).then(resolve, reject);
	    }
	  });
	};

	Promise._immediateFn =
	  (typeof setImmediate === 'function' &&
	    function(fn) {
	      setImmediate(fn);
	    }) ||
	  function(fn) {
	    setTimeoutFunc(fn, 0);
	  };

	Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	  if (typeof console !== 'undefined' && console) {
	    console.warn('Possible Unhandled Promise Rejection:', err); 
	  }
	};

	var src = Object.freeze({
		__proto__: null,
		'default': Promise
	});

	var require$$0 = getAugmentedNamespace(src);


	var reactorPromise =
	  (typeof window !== 'undefined' && window.Promise) ||
	  (typeof commonjsGlobal !== 'undefined' && commonjsGlobal.Promise) ||
	  require$$0.default ||
	  require$$0;


	var createAddActionToQueue = function (
	  executeDelegateModule,
	  normalizeRuleComponentError,
	  logActionError
	) {
	  return function (action, rule, syntheticEvent, lastPromiseInQueue) {
	    return lastPromiseInQueue.then(function () {

	      var delayNextAction = action.delayNext;
	      var actionTimeoutId;

	      return new reactorPromise(function (resolve, reject) {
	        var moduleResult = executeDelegateModule(action, syntheticEvent, [
	          syntheticEvent
	        ]);

	        if (!delayNextAction) {
	          return resolve();
	        }

	        var promiseTimeoutMs = action.timeout;
	        var timeoutPromise = new reactorPromise(function (resolve, reject) {
	          actionTimeoutId = setTimeout(function () {
	            reject(
	              new Error(
	                'A timeout occurred because the action took longer than ' +
	                  promiseTimeoutMs / 1000 +
	                  ' seconds to complete. '
	              )
	            );
	          }, promiseTimeoutMs);
	        });

	        reactorPromise.race([moduleResult, timeoutPromise]).then(resolve, reject);
	      })
	        .catch(function (e) {
	          clearTimeout(actionTimeoutId);
	          e = normalizeRuleComponentError(e);
	          logActionError(action, rule, e);
	          return reactorPromise.reject(e);
	        })
	        .then(function () {
	          clearTimeout(actionTimeoutId);
	        });
	    });
	  };
	};


	var createAddConditionToQueue = function (
	  executeDelegateModule,
	  normalizeRuleComponentError,
	  isConditionMet,
	  logConditionError,
	  logConditionNotMet
	) {
	  return function (condition, rule, syntheticEvent, lastPromiseInQueue) {
	    return lastPromiseInQueue.then(function () {
	      var conditionTimeoutId;

	      return new reactorPromise(function (resolve, reject) {
	        var moduleResult = executeDelegateModule(condition, syntheticEvent, [
	          syntheticEvent
	        ]);

	        var promiseTimeoutMs = condition.timeout;
	        var timeoutPromise = new reactorPromise(function (resolve, reject) {
	          conditionTimeoutId = setTimeout(function () {
	            reject(
	              new Error(
	                'A timeout occurred because the condition took longer than ' +
	                  promiseTimeoutMs / 1000 +
	                  ' seconds to complete. '
	              )
	            );
	          }, promiseTimeoutMs);
	        });

	        reactorPromise.race([moduleResult, timeoutPromise]).then(resolve, reject);
	      })
	        .catch(function (e) {
	          clearTimeout(conditionTimeoutId);
	          e = normalizeRuleComponentError(e);
	          logConditionError(condition, rule, e);
	          return reactorPromise.reject(e);
	        })
	        .then(function (result) {
	          clearTimeout(conditionTimeoutId);
	          if (!isConditionMet(condition, result)) {
	            logConditionNotMet(condition, rule);
	            return reactorPromise.reject();
	          }
	        });
	    });
	  };
	};


	var lastPromiseInQueue = reactorPromise.resolve();

	var createAddRuleToQueue = function (
	  addConditionToQueue,
	  addActionToQueue,
	  logRuleCompleted
	) {
	  return function (rule, syntheticEvent) {
	    if (rule.conditions) {
	      rule.conditions.forEach(function (condition) {
	        lastPromiseInQueue = addConditionToQueue(
	          condition,
	          rule,
	          syntheticEvent,
	          lastPromiseInQueue
	        );
	      });
	    }

	    if (rule.actions) {
	      rule.actions.forEach(function (action) {
	        lastPromiseInQueue = addActionToQueue(
	          action,
	          rule,
	          syntheticEvent,
	          lastPromiseInQueue
	        );
	      });
	    }

	    lastPromiseInQueue = lastPromiseInQueue.then(function () {
	      logRuleCompleted(rule);
	    });

	    lastPromiseInQueue = lastPromiseInQueue.catch(function () {});

	    return lastPromiseInQueue;
	  };
	};

	var isPromiseLike = function (value) {
	  return Boolean(
	    value && typeof value === 'object' && typeof value.then === 'function'
	  );
	};


	var createEvaluateConditions = function (
	  executeDelegateModule,
	  isConditionMet,
	  logConditionNotMet,
	  logConditionError
	) {
	  return function (rule, syntheticEvent) {
	    var condition;

	    if (rule.conditions) {
	      for (var i = 0; i < rule.conditions.length; i++) {
	        condition = rule.conditions[i];

	        try {
	          var result = executeDelegateModule(condition, syntheticEvent, [
	            syntheticEvent
	          ]);

	          if (isPromiseLike(result)) {
	            throw new Error(
	              'Rule component sequencing must be enabled on the property ' +
	                'for this condition to function properly.'
	            );
	          }

	          if (!isConditionMet(condition, result)) {
	            logConditionNotMet(condition, rule);
	            return false;
	          }
	        } catch (e) {
	          logConditionError(condition, rule, e);
	          return false;
	        }
	      }
	    }

	    return true;
	  };
	};

	var createExecuteRule = function (evaluateConditions, runActions) {
	  return function (rule, normalizedSyntheticEvent) {
	    if (evaluateConditions(rule, normalizedSyntheticEvent)) {
	      runActions(rule, normalizedSyntheticEvent);
	    }
	  };
	};

	var createGetModuleDisplayNameByRuleComponent = function (moduleProvider) {
	  return function (ruleComponent) {
	    var moduleDefinition = moduleProvider.getModuleDefinition(
	      ruleComponent.modulePath
	    );
	    return (
	      (moduleDefinition && moduleDefinition.displayName) ||
	      ruleComponent.modulePath
	    );
	  };
	};

	var createGetSyntheticEventMeta = function (moduleProvider) {
	  return function (ruleEventPair) {
	    var rule = ruleEventPair.rule;
	    var event = ruleEventPair.event;

	    var moduleName = moduleProvider.getModuleDefinition(event.modulePath).name;
	    var extensionName = moduleProvider.getModuleExtensionName(event.modulePath);

	    return {
	      $type: extensionName + '.' + moduleName,
	      $rule: {
	        id: rule.id,
	        name: rule.name
	      }
	    };
	  };
	};

	var createInitEventModule = function (
	  triggerRule,
	  executeDelegateModule,
	  normalizeSyntheticEvent,
	  getErrorMessage,
	  getSyntheticEventMeta,
	  logger
	) {
	  return function (guardUntilAllInitialized, ruleEventPair) {
	    var rule = ruleEventPair.rule;
	    var event = ruleEventPair.event;
	    event.settings = event.settings || {};

	    try {
	      var syntheticEventMeta = getSyntheticEventMeta(ruleEventPair);

	      executeDelegateModule(event, null, [
	        function trigger(syntheticEvent) {

	          var normalizedSyntheticEvent = normalizeSyntheticEvent(
	            syntheticEventMeta,
	            syntheticEvent
	          );

	          guardUntilAllInitialized(function () {
	            triggerRule(normalizedSyntheticEvent, rule);
	          });
	        }
	      ]);
	    } catch (e) {
	      logger.error(getErrorMessage(event, rule, e));
	    }
	  };
	};

	var createLogActionError = function (
	  getRuleComponentErrorMessage,
	  getModuleDisplayNameByRuleComponent,
	  logger,
	  notifyMonitors
	) {
	  return function (action, rule, e) {
	    var actionDisplayName = getModuleDisplayNameByRuleComponent(action);

	    logger.error(getRuleComponentErrorMessage(actionDisplayName, rule.name, e));

	    notifyMonitors('ruleActionFailed', {
	      rule: rule,
	      action: action
	    });
	  };
	};

	var createLogConditionError = function (
	  getRuleComponentErrorMessage,
	  getModuleDisplayNameByRuleComponent,
	  logger,
	  notifyMonitors
	) {
	  return function (condition, rule, e) {
	    var conditionDisplayName = getModuleDisplayNameByRuleComponent(condition);

	    logger.error(
	      getRuleComponentErrorMessage(conditionDisplayName, rule.name, e)
	    );

	    notifyMonitors('ruleConditionFailed', {
	      rule: rule,
	      condition: condition
	    });
	  };
	};

	var createLogConditionNotMet = function (
	  getModuleDisplayNameByRuleComponent,
	  logger,
	  notifyMonitors
	) {
	  return function (condition, rule) {
	    var conditionDisplayName = getModuleDisplayNameByRuleComponent(condition);

	    logger.log(
	      'Condition "' +
	        conditionDisplayName +
	        '" for rule "' +
	        rule.name +
	        '" was not met.'
	    );

	    notifyMonitors('ruleConditionFailed', {
	      rule: rule,
	      condition: condition
	    });
	  };
	};

	var createLogRuleCompleted = function (logger, notifyMonitors) {
	  return function (rule) {
	    logger.log('Rule "' + rule.name + '" fired.');
	    notifyMonitors('ruleCompleted', {
	      rule: rule
	    });
	  };
	};

	var createRunActions = function (
	  executeDelegateModule,
	  logActionError,
	  logRuleCompleted
	) {
	  return function (rule, syntheticEvent) {
	    var action;

	    if (rule.actions) {
	      for (var i = 0; i < rule.actions.length; i++) {
	        action = rule.actions[i];
	        try {
	          executeDelegateModule(action, syntheticEvent, [syntheticEvent]);
	        } catch (e) {
	          logActionError(action, rule, e);
	          return;
	        }
	      }
	    }

	    logRuleCompleted(rule);
	  };
	};

	var createTriggerRule = function (
	  ruleComponentSequencingEnabled,
	  executeRule,
	  addRuleToQueue,
	  notifyMonitors
	) {
	  return function (normalizedSyntheticEvent, rule) {
	    notifyMonitors('ruleTriggered', {
	      rule: rule
	    });

	    if (ruleComponentSequencingEnabled) {
	      addRuleToQueue(rule, normalizedSyntheticEvent);
	    } else {
	      executeRule(rule, normalizedSyntheticEvent);
	    }
	  };
	};

	var getRuleComponentErrorMessage = function (ruleComponentName, ruleName, error) {
	  return (
	    'Failed to execute "' +
	    ruleComponentName +
	    '" for "' +
	    ruleName +
	    '" rule. ' +
	    error.message +
	    (error.stack ? '\n' + error.stack : '')
	  );
	};

	var isConditionMet = function (condition, result) {
	  return (result && !condition.negate) || (!result && condition.negate);
	};

	var triggerCallQueue = [];
	var eventModulesInitialized = false;

	var guardUntilAllInitialized = function (callback) {
	  if (!eventModulesInitialized) {
	    triggerCallQueue.push(callback);
	  } else {
	    callback();
	  }
	};

	var initRules = function (buildRuleExecutionOrder, rules, initEventModule) {
	  buildRuleExecutionOrder(rules).forEach(function (ruleEventPair) {
	    initEventModule(guardUntilAllInitialized, ruleEventPair);
	  });

	  eventModulesInitialized = true;
	  triggerCallQueue.forEach(function (triggerCall) {
	    triggerCall();
	  });

	  triggerCallQueue = [];
	};

	var normalizeRuleComponentError = function (e) {
	  if (!e) {
	    e = new Error(
	      'The extension triggered an error, but no error information was provided.'
	    );
	  }

	  if (!(e instanceof Error)) {
	    var stringifiedError =
	      typeof e === 'object' ? JSON.stringify(e) : String(e);
	    e = new Error(stringifiedError);
	  }

	  return e;
	};


	var isobject = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};




	function isObjectObject(o) {
	  return isobject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}

	var isPlainObject = function isPlainObject(o) {
	  var ctor,prot;

	  if (isObjectObject(o) === false) return false;

	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;

	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;

	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }

	  return true;
	};


	var normalizeSyntheticEvent = function (syntheticEventMeta, syntheticEvent) {
	  syntheticEvent = syntheticEvent || {};

	  if (isPlainObject(syntheticEvent)) {
	    syntheticEvent = reactorObjectAssign({}, syntheticEvent, syntheticEventMeta);
	  } else {
	    reactorObjectAssign(syntheticEvent, syntheticEventMeta);
	  }

	  if (!syntheticEvent.hasOwnProperty('type')) {
	    Object.defineProperty(syntheticEvent, 'type', {
	      get: function () {
	        logger.deprecation(
	          'Accessing event.type in Adobe Launch has been deprecated and will be ' +
	            'removed soon. Please use event.$type instead.'
	        );
	        return syntheticEvent.$type;
	      }
	    });
	  }

	  return syntheticEvent;
	};

	var createGetSharedModuleExports = function (extensions, moduleProvider) {
	  return function (extensionName, moduleName) {
	    var extension = extensions[extensionName];

	    if (extension) {
	      var modules = extension.modules;
	      if (modules) {
	        var referencePaths = Object.keys(modules);
	        for (var i = 0; i < referencePaths.length; i++) {
	          var referencePath = referencePaths[i];
	          var module = modules[referencePath];
	          if (module.shared && module.name === moduleName) {
	            return moduleProvider.getModuleExports(referencePath);
	          }
	        }
	      }
	    }
	  };
	};

	var createGetExtensionSettings = function (replaceTokens, settings) {
	  return function () {
	    return settings ? replaceTokens(settings) : {};
	  };
	};


	var createGetHostedLibFileUrl = function (
	  decorateWithDynamicHost,
	  hostedLibFilesBaseUrl,
	  minified
	) {
	  return function (file) {
	    if (minified) {
	      var fileParts = file.split('.');
	      fileParts.splice(fileParts.length - 1 || 1, 0, 'min');
	      file = fileParts.join('.');
	    }

	    return decorateWithDynamicHost(hostedLibFilesBaseUrl) + file;
	  };
	};

	var JS_EXTENSION = '.js';

	var dirname = function (path) {
	  return path.substr(0, path.lastIndexOf('/'));
	};

	var endsWith = function (str, suffix) {
	  return str.indexOf(suffix, str.length - suffix.length) !== -1;
	};

	var resolveRelativePath = function (fromPath, relativePath) {
	  if (!endsWith(relativePath, JS_EXTENSION)) {
	    relativePath = relativePath + JS_EXTENSION;
	  }

	  var relativePathSegments = relativePath.split('/');
	  var resolvedPathSegments = dirname(fromPath).split('/');

	  relativePathSegments.forEach(function (relativePathSegment) {
	    if (!relativePathSegment || relativePathSegment === '.') {
	      return;
	    } else if (relativePathSegment === '..') {
	      if (resolvedPathSegments.length) {
	        resolvedPathSegments.pop();
	      }
	    } else {
	      resolvedPathSegments.push(relativePathSegment);
	    }
	  });

	  return resolvedPathSegments.join('/');
	};




	var getPromise = function(url, script) {
	  return new reactorPromise(function(resolve, reject) {
	    script.onload = function() {
	      resolve(script);
	    };

	    script.onerror = function() {
	      reject(new Error('Failed to load script ' + url));
	    };
	  });
	};

	var reactorLoadScript = function(url) {
	  var script = document.createElement('script');
	  script.src = url;
	  script.async = true;

	  var promise = getPromise(url, script);

	  document.getElementsByTagName('head')[0].appendChild(script);
	  return promise;
	};


	function hasOwnProperty$1(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	var decode = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};

	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }

	  var regexp = /\+/g;
	  qs = qs.split(sep);

	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }

	  var len = qs.length;
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }

	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;

	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }

	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);

	    if (!hasOwnProperty$1(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }

	  return obj;
	};


	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;

	    case 'boolean':
	      return v ? 'true' : 'false';

	    case 'number':
	      return isFinite(v) ? v : '';

	    default:
	      return '';
	  }
	};

	var encode = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }

	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);

	  }

	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};

	var querystring = createCommonjsModule(function (module, exports) {

	exports.decode = exports.parse = decode;
	exports.encode = exports.stringify = encode;
	});




	var reactorQueryString = {
	  parse: function(string) {
	    if (typeof string === 'string') {
	      string = string.trim().replace(/^[?#&]/, '');
	    }
	    return querystring.parse(string);
	  },
	  stringify: function(object) {
	    return querystring.stringify(object);
	  }
	};


	var CORE_MODULE_PREFIX = '@adobe/reactor-';

	var modules = {
	  cookie: reactorCookie,
	  document: reactorDocument,
	  'load-script': reactorLoadScript,
	  'object-assign': reactorObjectAssign,
	  promise: reactorPromise,
	  'query-string': reactorQueryString,
	  window: reactorWindow
	};

	var createPublicRequire = function (getModuleExportsByRelativePath) {
	  return function (key) {
	    if (key.indexOf(CORE_MODULE_PREFIX) === 0) {
	      var keyWithoutScope = key.substr(CORE_MODULE_PREFIX.length);
	      var module = modules[keyWithoutScope];

	      if (module) {
	        return module;
	      }
	    }

	    if (key.indexOf('./') === 0 || key.indexOf('../') === 0) {
	      return getModuleExportsByRelativePath(key);
	    }

	    throw new Error('Cannot resolve module "' + key + '".');
	  };
	};


	var hydrateModuleProvider = function (
	  container,
	  moduleProvider,
	  debugController,
	  replaceTokens,
	  getDataElementValue,
	  settingsFileTransformer,
	  decorateWithDynamicHost
	) {
	  var extensions = container.extensions;
	  var buildInfo = container.buildInfo;
	  var environment = container.environment;
	  var propertySettings = container.property.settings;

	  if (extensions) {
	    var getSharedModuleExports = createGetSharedModuleExports(
	      extensions,
	      moduleProvider
	    );

	    Object.keys(extensions).forEach(function (extensionName) {
	      var extension = extensions[extensionName];
	      var extensionSettings = extension.settings;
	      if (Array.isArray(extension.filePaths)) {
	        extensionSettings = settingsFileTransformer(
	          extensionSettings,
	          extension.filePaths
	        );
	      }
	      var getExtensionSettings = createGetExtensionSettings(
	        replaceTokens,
	        extensionSettings
	      );

	      if (extension.modules) {
	        var prefixedLogger = logger.createPrefixedLogger(extension.displayName);
	        var getHostedLibFileUrl = createGetHostedLibFileUrl(
	          decorateWithDynamicHost,
	          extension.hostedLibFilesBaseUrl,
	          buildInfo.minified
	        );
	        var turbine = {
	          buildInfo: buildInfo,
	          environment: environment,
	          property: {
	            name: container.property.name,
	            id: container.property.id
	          },
	          getDataElementValue: getDataElementValue,
	          getExtensionSettings: getExtensionSettings,
	          getHostedLibFileUrl: getHostedLibFileUrl,
	          getSharedModule: getSharedModuleExports,
	          logger: prefixedLogger,
	          propertySettings: propertySettings,
	          replaceTokens: replaceTokens,
	          onDebugChanged: debugController.onDebugChanged,
	          get debugEnabled() {
	            return debugController.getDebugEnabled();
	          }
	        };

	        Object.keys(extension.modules).forEach(function (referencePath) {
	          var module = extension.modules[referencePath];
	          var getModuleExportsByRelativePath = function (relativePath) {
	            var resolvedReferencePath = resolveRelativePath(
	              referencePath,
	              relativePath
	            );
	            return moduleProvider.getModuleExports(resolvedReferencePath);
	          };
	          var publicRequire = createPublicRequire(
	            getModuleExportsByRelativePath
	          );

	          moduleProvider.registerModule(
	            referencePath,
	            module,
	            extensionName,
	            publicRequire,
	            turbine
	          );
	        });
	      }
	    });

	    moduleProvider.hydrateCache();
	  }
	  return moduleProvider;
	};


	var hydrateSatelliteObject = function (
	  _satellite,
	  container,
	  setDebugEnabled,
	  getVar,
	  setCustomVar
	) {
	  var customScriptPrefixedLogger = logger.createPrefixedLogger('Custom Script');

	  _satellite.track = function (identifier) {
	    logger.log(
	      '"' + identifier + '" does not match any direct call identifiers.'
	    );
	  };

	  _satellite.getVisitorId = function () {
	    return null;
	  };

	  _satellite.property = {
	    name: container.property.name,
	    id: container.property.id
	  };

	  _satellite.company = container.company;

	  _satellite.buildInfo = container.buildInfo;

	  _satellite.environment = container.environment;

	  _satellite.logger = customScriptPrefixedLogger;

	  _satellite.notify = function (message, level) {
	    logger.deprecation(
	      '_satellite.notify is deprecated. Please use the `_satellite.logger` API.'
	    );

	    switch (level) {
	      case 3:
	        customScriptPrefixedLogger.info(message);
	        break;
	      case 4:
	        customScriptPrefixedLogger.warn(message);
	        break;
	      case 5:
	        customScriptPrefixedLogger.error(message);
	        break;
	      default:
	        customScriptPrefixedLogger.log(message);
	    }
	  };

	  _satellite.getVar = getVar;
	  _satellite.setVar = setCustomVar;

	  _satellite.setCookie = function (name, value, days) {
	    var optionsStr = '';
	    var options = {};

	    if (days) {
	      optionsStr = ', { expires: ' + days + ' }';
	      options.expires = days;
	    }

	    var msg =
	      '_satellite.setCookie is deprecated. Please use ' +
	      '_satellite.cookie.set("' +
	      name +
	      '", "' +
	      value +
	      '"' +
	      optionsStr +
	      ').';

	    logger.deprecation(msg);
	    reactorCookie.set(name, value, options);
	  };

	  _satellite.readCookie = function (name) {
	    logger.deprecation(
	      '_satellite.readCookie is deprecated. ' +
	        'Please use _satellite.cookie.get("' +
	        name +
	        '").'
	    );
	    return reactorCookie.get(name);
	  };

	  _satellite.removeCookie = function (name) {
	    logger.deprecation(
	      '_satellite.removeCookie is deprecated. ' +
	        'Please use _satellite.cookie.remove("' +
	        name +
	        '").'
	    );
	    reactorCookie.remove(name);
	  };

	  _satellite.cookie = reactorCookie;

	  _satellite.pageBottom = function () {};

	  _satellite.setDebug = setDebugEnabled;

	  var warningLogged = false;

	  Object.defineProperty(_satellite, '_container', {
	    get: function () {
	      if (!warningLogged) {
	        logger.warn(
	          '_satellite._container may change at any time and should only ' +
	            'be used for debugging.'
	        );
	        warningLogged = true;
	      }

	      return container;
	    }
	  });
	};




	var byRegexPattern = function (regexScriptSrcPattern) {
	  var scripts = reactorDocument.querySelectorAll('script');

	  for (var i = 0; i < scripts.length; i++) {
	    var script = scripts[i];
	    if (regexScriptSrcPattern.test(script.src)) {
	      return script;
	    }
	  }
	};

	var getTurbine = function () {
	  return byRegexPattern(new RegExp(/(launch|satelliteLib)-[^\/]+.js(\?.*)?$/));
	};

	var findPageScript = {
	  getTurbine: getTurbine,
	  byRegexPattern: byRegexPattern
	};


	function isArrayReference(str) {
	  return (
	    typeof str === 'string' &&
	    str.indexOf('[') !== -1 &&
	    str.indexOf(']') !== -1
	  );
	}
	function sanitizeArrayKey(pathStrSegment) {
	  return pathStrSegment.substr(
	    0,
	    pathStrSegment.indexOf('[')
	  );
	}

	function traverseIntoSettings(pathSegments, settings, decorateWithDynamicHost) {
	  if (!pathSegments.length || !isPlainObject(settings)) {
	    return;
	  }

	  var currentKey = pathSegments[0];

	  if (pathSegments.length === 1) {
	    if (
	      settings.hasOwnProperty(currentKey) &&
	      typeof settings[currentKey] === 'string'
	    ) {
	      settings[currentKey] = decorateWithDynamicHost(settings[currentKey]);
	    }
	    return;
	  }

	  var remainingPathSegments = pathSegments.slice(1);
	  if (isArrayReference(currentKey)) {
	    currentKey = sanitizeArrayKey(currentKey);
	    var settingsValue = settings[currentKey];
	    if (Array.isArray(settingsValue)) {
	      settingsValue.forEach(function (arrayEntryObject) {
	        return traverseIntoSettings(
	          remainingPathSegments,
	          arrayEntryObject,
	          decorateWithDynamicHost
	        );
	      });
	    }
	  } else {
	    return traverseIntoSettings(
	      remainingPathSegments,
	      settings[currentKey],
	      decorateWithDynamicHost
	    );
	  }
	}

	var createSettingsFileTransformer = function (isDynamicEnforced, decorateWithDynamicHost) {
	  return function (settings, filePaths, moduleReferencePath) {
	    if (
	      !isDynamicEnforced ||
	      !isPlainObject(settings) ||
	      !Object.keys(settings).length ||
	      !Array.isArray(filePaths) ||
	      !filePaths.length
	    ) {
	      return settings;
	    }

	    filePaths.forEach(function (filePathString) {
	      var isAdobeCustomCodeAction = Boolean(
	        moduleReferencePath != null &&
	          /^core\/.*actions.*\/customCode\.js$/.test(moduleReferencePath)
	      );
	      if (
	        isAdobeCustomCodeAction &&
	        filePathString === 'source' &&
	        !settings.isExternal
	      ) {
	        return;
	      }

	      traverseIntoSettings(
	        filePathString.split('.'),
	        settings,
	        decorateWithDynamicHost
	      );
	    });

	    return settings;
	  };
	};











































	var IEGetTurbineScript = findPageScript
	  .getTurbine;





	var _satellite = window._satellite;

	if (_satellite && !window.__satelliteLoaded) {
	  window.__satelliteLoaded = true;

	  var container = _satellite.container;

	  delete _satellite.container;

	  var buildInfo = reactorObjectAssign({}, container.buildInfo);
	  Object.defineProperty(buildInfo, 'environment', {
	    get: function () {
	      logger.deprecation(
	        'container.buildInfo.environment is deprecated.' +
	          'Please use `container.environment.stage` instead'
	      );
	      return container.environment.stage;
	    }
	  });
	  container.buildInfo = buildInfo;

	  var localStorage = getNamespacedStorage('localStorage');
	  var debugController = createDebugController(localStorage, logger);

	  var currentScriptSource = '';
	  if (reactorDocument.currentScript && reactorDocument.currentScript.getAttribute('src')) {
	    currentScriptSource = reactorDocument.currentScript.getAttribute('src');
	  } else if (IEGetTurbineScript()) {
	    currentScriptSource = IEGetTurbineScript().getAttribute('src');
	  }
	  var dynamicHostResolver;
	  try {
	    dynamicHostResolver = createDynamicHostResolver(
	      currentScriptSource,
	      container.company.cdnAllowList,
	      debugController
	    );
	  } catch (e) {
	    logger.warn('Please review the following error:');
	    throw e; 
	  }

	  var settingsFileTransformer = createSettingsFileTransformer(
	    dynamicHostResolver.isDynamicEnforced,
	    dynamicHostResolver.decorateWithDynamicHost
	  );

	  var moduleProvider = createModuleProvider();

	  var replaceTokens;

	  var undefinedVarsReturnEmpty =
	    container.property.settings.undefinedVarsReturnEmpty;
	  var ruleComponentSequencingEnabled =
	    container.property.settings.ruleComponentSequencingEnabled;

	  var dataElements = container.dataElements || {};

	  dataElementSafe.migrateCookieData(dataElements);

	  var getDataElementDefinition = function (name) {
	    return dataElements[name];
	  };

	  var proxyReplaceTokens = function () {
	    return replaceTokens.apply(null, arguments);
	  };

	  var getDataElementValue = createGetDataElementValue(
	    moduleProvider,
	    getDataElementDefinition,
	    proxyReplaceTokens,
	    undefinedVarsReturnEmpty,
	    settingsFileTransformer
	  );

	  var customVars = {};
	  var setCustomVar = createSetCustomVar(customVars);

	  var isVar = createIsVar(customVars, getDataElementDefinition);

	  var getVar = createGetVar(
	    customVars,
	    getDataElementDefinition,
	    getDataElementValue
	  );

	  replaceTokens = createReplaceTokens(isVar, getVar, undefinedVarsReturnEmpty);

	  hydrateSatelliteObject(
	    _satellite,
	    container,
	    debugController.setDebugEnabled,
	    getVar,
	    setCustomVar
	  );

	  hydrateModuleProvider(
	    container,
	    moduleProvider,
	    debugController,
	    replaceTokens,
	    getDataElementValue,
	    settingsFileTransformer,
	    dynamicHostResolver.decorateWithDynamicHost
	  );

	  var notifyMonitors = createNotifyMonitors(_satellite);
	  var executeDelegateModule = createExecuteDelegateModule(
	    moduleProvider,
	    replaceTokens,
	    settingsFileTransformer
	  );

	  var getModuleDisplayNameByRuleComponent = createGetModuleDisplayNameByRuleComponent(
	    moduleProvider
	  );
	  var logConditionNotMet = createLogConditionNotMet(
	    getModuleDisplayNameByRuleComponent,
	    logger,
	    notifyMonitors
	  );
	  var logConditionError = createLogConditionError(
	    getRuleComponentErrorMessage,
	    getModuleDisplayNameByRuleComponent,
	    logger,
	    notifyMonitors
	  );
	  var logActionError = createLogActionError(
	    getRuleComponentErrorMessage,
	    getModuleDisplayNameByRuleComponent,
	    logger,
	    notifyMonitors
	  );
	  var logRuleCompleted = createLogRuleCompleted(logger, notifyMonitors);

	  var evaluateConditions = createEvaluateConditions(
	    executeDelegateModule,
	    isConditionMet,
	    logConditionNotMet,
	    logConditionError
	  );
	  var runActions = createRunActions(
	    executeDelegateModule,
	    logActionError,
	    logRuleCompleted
	  );
	  var executeRule = createExecuteRule(evaluateConditions, runActions);

	  var addConditionToQueue = createAddConditionToQueue(
	    executeDelegateModule,
	    normalizeRuleComponentError,
	    isConditionMet,
	    logConditionError,
	    logConditionNotMet
	  );
	  var addActionToQueue = createAddActionToQueue(
	    executeDelegateModule,
	    normalizeRuleComponentError,
	    logActionError
	  );
	  var addRuleToQueue = createAddRuleToQueue(
	    addConditionToQueue,
	    addActionToQueue,
	    logRuleCompleted
	  );

	  var triggerRule = createTriggerRule(
	    ruleComponentSequencingEnabled,
	    executeRule,
	    addRuleToQueue,
	    notifyMonitors
	  );

	  var getSyntheticEventMeta = createGetSyntheticEventMeta(moduleProvider);

	  var initEventModule = createInitEventModule(
	    triggerRule,
	    executeDelegateModule,
	    normalizeSyntheticEvent,
	    getRuleComponentErrorMessage,
	    getSyntheticEventMeta,
	    logger
	  );

	  initRules(buildRuleExecutionOrder, container.rules || [], initEventModule);
	}

	var src$1 = _satellite;

	return src$1;

}());


